const portalLabBody = ({
    x, y, id, refName, color, fixed = false, vertices, radius = 0,
    density = 1, friction = 0.45, restitution = 0.05,
}) => [
    0, x, y, 0, 'portal-lab', refName, id,
    [color], ['#151922'], [1], fixed, true, [vertices], [density], [0], [radius], '', [2],
    true, false, false, [friction], [restitution], false, true, false, false, 1,
];

const portalLabBox = (x, y, id, refName, color, width = 2, height = 2, fixed = false) =>
    portalLabBody({
        x, y, id, refName, color, fixed,
        vertices: [
            {x: -width / 2, y: -height / 2},
            {x: width / 2, y: -height / 2},
            {x: width / 2, y: height / 2},
            {x: -width / 2, y: height / 2},
        ],
    });

const portalLabCircle = (x, y, id, refName, color, radius) => portalLabBody({
    x, y, id, refName, color, radius,
    vertices: [{x: 0, y: 0}, {x: 0, y: 0}],
});

export const levelsData = {
    singlePlayerLevel: {
        json: `{"objects":[]}`,
        title: '',
        description: '',
        crossPromo: [],
    },
    portalLab: () => ({
        json: JSON.stringify({
            objects: [
                portalLabBox(-3, -4.8, 0, 'single_fixture', '#71d6ff'),
                portalLabCircle(2.2, -7, 1, 'joint_left', '#ffd166', 0.72),
                portalLabCircle(3.8, -7, 2, 'joint_right', '#ef476f', 0.72),
                [2, 90, -210, 0, 'portal-lab', 'surviving_joint', 3, 1, 2, 3, false, false, 1, 10, false, 0, 0, 0, 0, 0, 0, true],
                portalLabBox(1, 6, 4, 'floor', '#3d4657', 30, 1, true),
                portalLabBox(14, 0, 5, 'portal_gun_wall_right', '#525f75', 0.8, 14, true),
                portalLabBox(-14, 0, 6, 'portal_gun_wall_left', '#525f75', 0.8, 14, true),
				[4, 0, 0, -90, {
					pairId: 'portal-lab-main', color: '#0093ff',
				}, 'Portal'],
				[4, 270, 0, 180, {
					pairId: 'portal-lab-main', color: '#ff9800',
				}, 'Portal'],
                [4, 0, -205, 0, {
                    isFlipped: false, life: 300, selectedVehicle: 'NoVehicle',
                }, 'NoVehicle'],
                [4, 13, -375, 0, {}, 'PortalHat'],
                [9, -405, -315, 0, '', 'portal_lab_title', 11,
                    'PORTAL MIRROR LAB', '#151922', 1, 30, 'Arial', 'left', null, null, null, null, 0, 0, 0, true],
                [9, -405, -278, 0, '', 'portal_lab_help', 12,
                    'T: test   E: fire helmet forward   Space: flip character / aim the other way',
                    '#334155', 1, 15, 'Arial', 'left', null, null, null, null, 0, 0, 0, true],
            ],
            settings: [10, 0, 10, '#dce8f2', 0.72, 0.35, [], true, true, 0.1, ''],
        }),
        title: 'Portal Mirror Lab',
        description: 'Fixture-level portal crossing, mirror-world collision, and joint continuity test.',
        crossPromo: [],
        portalLab: true,
    }),
    editorLevel: () => ({
        json: JSON.stringify({
            "objects": [
                [7, 7163.894, -518.6341, 0, "", "", 0, [
                    [6, -0.0049, 142.1802, 0, "", "", 352, "#6b6a6a", "#000000", 1, 0, [{
                        "x": -240.8255,
                        "y": 264.8976
                    }, {
                        "x": -240.8255,
                        "y": -264.8976
                    }, {
                        "x": 240.8255,
                        "y": -264.8976
                    }, {
                        "x": 240.8255,
                        "y": 264.8976
                    }], null, null, null, null, "", 2, 0, 0, 0, "", true],
                    [6, 0.0049, -142.1802, 0, "", "", 353, "#3d3d3d", "#000000", 1, 0, [{
                        "x": -243.5,
                        "y": 17.742
                    }, {
                        "x": -243.5,
                        "y": -17.742
                    }, {
                        "x": 243.5,
                        "y": -17.742
                    }, {
                        "x": 243.5,
                        "y": 17.742
                    }], null, null, null, null, "", 2, 0, 0, 0, "", true]
                ], null, null, null, null, 1, 0, 0, 0, true, false, []],
                [6, 7136.6525, 134.2957, 0, "", "", 1, "#666262", "#757575", 0.05, 0, [{
                    "x": -174.52,
                    "y": 80.205
                }, {
                    "x": -174.52,
                    "y": -80.205
                }, {
                    "x": 174.52,
                    "y": -80.205
                }, {
                    "x": 174.52,
                    "y": 80.205
                }], null, null, null, null, "Stripe2", 0, 0, 0, 0, "", true],
                [6, 3809.209, -36.4188, 0, "", "", 2, "#7c6a6a", "#757575", 1, 0, [{
                    "x": -64.5,
                    "y": 64.5
                }, {
                    "x": -64.5,
                    "y": -64.5
                }, {
                    "x": 64.5,
                    "y": -64.5
                }, {
                    "x": 64.5,
                    "y": 64.5
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [7, 3182.0917, -40.7551, 0, "", "", 3, [
                    [6, 44.8157, -81.9697, 0, "", "", 3, "#000000", "#000", 1, null, [{
                        "x": -58.8222,
                        "y": -222.6198,
                        "point1": {
                            "x": -13.4669,
                            "y": -226.2479
                        },
                        "point2": {
                            "x": 59.4409,
                            "y": -194.8701
                        }
                    }, {
                        "x": 81.1491,
                        "y": -158.6897,
                        "point1": {
                            "x": 92.605,
                            "y": -139.5965
                        },
                        "point2": {
                            "x": 105.059,
                            "y": -117.5704
                        }
                    }, {
                        "x": 110.1938,
                        "y": -95.3194,
                        "point1": {
                            "x": 125.328,
                            "y": -29.7382
                        },
                        "point2": {
                            "x": 81.9673,
                            "y": 58.3275
                        }
                    }, {
                        "x": 36.2619,
                        "y": 104.0328,
                        "point1": {
                            "x": 10.4698,
                            "y": 129.8249
                        },
                        "point2": {
                            "x": -18.8039,
                            "y": 153.9867
                        }
                    }, {
                        "x": -54.8329,
                        "y": 162.1222,
                        "point1": {
                            "x": -65.0364,
                            "y": 164.4262
                        },
                        "point2": {
                            "x": -75.0294,
                            "y": 167.5891
                        }
                    }, {
                        "x": -85.1978,
                        "y": 170.0435,
                        "point1": {
                            "x": -87.7999,
                            "y": 170.6716
                        },
                        "point2": {
                            "x": -92.2726,
                            "y": 173.9032
                        }
                    }, {
                        "x": -93.1191,
                        "y": 171.3637,
                        "point1": {
                            "x": -94.0101,
                            "y": 168.6905
                        },
                        "point2": {
                            "x": -88.9957,
                            "y": 167.425
                        }
                    }, {
                        "x": -86.518,
                        "y": 166.0829,
                        "point1": {
                            "x": -70.6881,
                            "y": 157.5084
                        },
                        "point2": {
                            "x": -60.4411,
                            "y": 153.4789
                        }
                    }, {
                        "x": -46.9116,
                        "y": 143.6392,
                        "point1": {
                            "x": -18.6228,
                            "y": 123.0656
                        },
                        "point2": {
                            "x": 2.9698,
                            "y": 103.4012
                        }
                    }, {
                        "x": 29.6608,
                        "y": 80.269,
                        "point1": {
                            "x": 53.1783,
                            "y": 59.8872
                        },
                        "point2": {
                            "x": 61.5206,
                            "y": 28.2806
                        }
                    }, {
                        "x": 72.503,
                        "y": 0.0402,
                        "point1": {
                            "x": 74.9852,
                            "y": -6.3428
                        },
                        "point2": {
                            "x": 76.4214,
                            "y": -14.7394
                        }
                    }, {
                        "x": 77.1885,
                        "y": -21.3875,
                        "point1": {
                            "x": 79.9166,
                            "y": -45.0311
                        },
                        "point2": {
                            "x": 81.7025,
                            "y": -68.8849
                        }
                    }, {
                        "x": 81.1491,
                        "y": -92.679,
                        "point1": {
                            "x": 80.1435,
                            "y": -135.9196
                        },
                        "point2": {
                            "x": 22.6188,
                            "y": -188.4203
                        }
                    }, {
                        "x": -15.9454,
                        "y": -199.6163,
                        "point1": {
                            "x": -40.5167,
                            "y": -206.7499
                        },
                        "point2": {
                            "x": -61.7138,
                            "y": -201.9207
                        }
                    }, {
                        "x": -86.518,
                        "y": -204.8972,
                        "point1": {
                            "x": -92.6522,
                            "y": -205.6333
                        },
                        "point2": {
                            "x": -59.2148,
                            "y": -222.5884
                        }
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, -41.7215, 90.6377, 1.0472, "", "", 4, "#000000", "#c45757", 1, 0, [{
                        "x": 29.5,
                        "y": -16.3333
                    }, {
                        "x": 0,
                        "y": 32.6667
                    }, {
                        "x": -29.5,
                        "y": -16.3333
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, 41.4529, -88.3341, 0, "", "", 70, "#ff0000", "#000", 1, null, [{
                        "x": -58.8222,
                        "y": -222.6198,
                        "point1": {
                            "x": -13.4669,
                            "y": -226.2479
                        },
                        "point2": {
                            "x": 59.4409,
                            "y": -194.8701
                        }
                    }, {
                        "x": 81.1491,
                        "y": -158.6897,
                        "point1": {
                            "x": 92.605,
                            "y": -139.5965
                        },
                        "point2": {
                            "x": 105.059,
                            "y": -117.5704
                        }
                    }, {
                        "x": 110.1938,
                        "y": -95.3194,
                        "point1": {
                            "x": 125.328,
                            "y": -29.7382
                        },
                        "point2": {
                            "x": 81.9673,
                            "y": 58.3275
                        }
                    }, {
                        "x": 36.2619,
                        "y": 104.0328,
                        "point1": {
                            "x": 10.4698,
                            "y": 129.8249
                        },
                        "point2": {
                            "x": -18.8039,
                            "y": 153.9867
                        }
                    }, {
                        "x": -54.8329,
                        "y": 162.1222,
                        "point1": {
                            "x": -65.0364,
                            "y": 164.4262
                        },
                        "point2": {
                            "x": -75.0294,
                            "y": 167.5891
                        }
                    }, {
                        "x": -85.1978,
                        "y": 170.0435,
                        "point1": {
                            "x": -87.7999,
                            "y": 170.6716
                        },
                        "point2": {
                            "x": -92.2726,
                            "y": 173.9032
                        }
                    }, {
                        "x": -93.1191,
                        "y": 171.3637,
                        "point1": {
                            "x": -94.0101,
                            "y": 168.6905
                        },
                        "point2": {
                            "x": -88.9957,
                            "y": 167.425
                        }
                    }, {
                        "x": -86.518,
                        "y": 166.0829,
                        "point1": {
                            "x": -70.6881,
                            "y": 157.5084
                        },
                        "point2": {
                            "x": -60.4411,
                            "y": 153.4789
                        }
                    }, {
                        "x": -46.9116,
                        "y": 143.6392,
                        "point1": {
                            "x": -18.6228,
                            "y": 123.0656
                        },
                        "point2": {
                            "x": 2.9698,
                            "y": 103.4012
                        }
                    }, {
                        "x": 29.6608,
                        "y": 80.269,
                        "point1": {
                            "x": 53.1783,
                            "y": 59.8872
                        },
                        "point2": {
                            "x": 61.5206,
                            "y": 28.2806
                        }
                    }, {
                        "x": 72.503,
                        "y": 0.0402,
                        "point1": {
                            "x": 74.9852,
                            "y": -6.3428
                        },
                        "point2": {
                            "x": 76.4214,
                            "y": -14.7394
                        }
                    }, {
                        "x": 77.1885,
                        "y": -21.3875,
                        "point1": {
                            "x": 79.9166,
                            "y": -45.0311
                        },
                        "point2": {
                            "x": 81.7025,
                            "y": -68.8849
                        }
                    }, {
                        "x": 81.1491,
                        "y": -92.679,
                        "point1": {
                            "x": 80.1435,
                            "y": -135.9196
                        },
                        "point2": {
                            "x": 22.6188,
                            "y": -188.4203
                        }
                    }, {
                        "x": -15.9454,
                        "y": -199.6163,
                        "point1": {
                            "x": -40.5167,
                            "y": -206.7499
                        },
                        "point2": {
                            "x": -61.7138,
                            "y": -201.9207
                        }
                    }, {
                        "x": -86.518,
                        "y": -204.8972,
                        "point1": {
                            "x": -92.6522,
                            "y": -205.6333
                        },
                        "point2": {
                            "x": -59.2148,
                            "y": -222.5884
                        }
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, -44.5471, 79.6659, 1.0472, "", "", 83, "#ff0000", "#c45757", 1, 0, [{
                        "x": 29.5,
                        "y": -16.3333
                    }, {
                        "x": 0,
                        "y": 32.6667
                    }, {
                        "x": -29.5,
                        "y": -16.3333
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true]
                ], null, null, null, null, 1, 0, 0, 0, true, false, []],
                [6, 1958.6703, -30.237, 0, "", "", 4, "#56c9d1", "#00ff0a", 1, 0, [{
                    "x": -75,
                    "y": 41.6667
                }, {
                    "x": 0,
                    "y": -83.3333
                }, {
                    "x": 75,
                    "y": 41.6667
                }], null, null, null, null, "", 6, 0, 0, 0, "", true],
                [7, 458.742, 30.752, 0, "", "", 5, [
                    [6, 0.8073, 82.3584, 0, "", "", 0, "#000000", "#000", 1, 78.5242, [{
                        "x": 0,
                        "y": 0
                    }, {
                        "x": 0,
                        "y": 0
                    }], null, null, null, null, "", 2, 0, 0, 0, "", true],
                    [6, 0.6123, -22.1016, 0, "", "", 1, "#999999", "#000", 1, 78.5242, [{
                        "x": 0,
                        "y": 0
                    }, {
                        "x": 0,
                        "y": 0
                    }], null, null, null, null, "", 2, 0, 0, 0, "", true],
                    [6, -1.0572, -61.2606, 0, "", "", 2, "#000000", "#000", 1, 0, [{
                        "x": -5.0535,
                        "y": 38.244
                    }, {
                        "x": -5.0535,
                        "y": -38.244
                    }, {
                        "x": 5.0535,
                        "y": -38.244
                    }, {
                        "x": 5.0535,
                        "y": 38.244
                    }], null, null, null, null, "", 2, 0, 0, 0, "", true],
                    [6, -0.9747, -32.5836, 0, "", "", 3, "#999999", "#000", 1, 14.7212, [{
                        "x": 0,
                        "y": 0
                    }, {
                        "x": 0,
                        "y": 0
                    }], null, null, null, null, "", 2, 0, 0, 0, "", true],
                    [6, 0.6123, 33.5874, 0, "", "", 4, "#000000", "#000", 1, 0, [{
                        "x": -79.377,
                        "y": 56.304
                    }, {
                        "x": -79.377,
                        "y": -56.304
                    }, {
                        "x": 79.377,
                        "y": -56.304
                    }, {
                        "x": 79.377,
                        "y": 56.304
                    }], null, null, null, null, "", 2, 0, 0, 0, "", true]
                ], null, null, null, null, 1, 0, 0, 0, true, false, []],
                [6, 217.306, -425.3218, 0, "", "", 6, "#0aa5d6", "#000000", 1, 0, [{
                    "x": -298.9155,
                    "y": 42.036
                }, {
                    "x": -298.9155,
                    "y": -42.036
                }, {
                    "x": 298.9155,
                    "y": -42.036
                }, {
                    "x": 298.9155,
                    "y": 42.036
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [6, 546.4964, -426.6216, 0, "", "", 7, "#0aa5d6", "#000000", 1, 0, [{
                    "x": 74.025,
                    "y": 0.784
                }, {
                    "x": -36.333,
                    "y": 62.932
                }, {
                    "x": -37.692,
                    "y": -63.716
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [6, 5372.0416, -307.4507, 0, "", "", 8, "#968f8f", "#000000", 1, 0, [{
                    "x": -210.006,
                    "y": 122.5
                }, {
                    "x": -210.006,
                    "y": -122.5
                }, {
                    "x": 210.006,
                    "y": -122.5
                }, {
                    "x": 210.006,
                    "y": 122.5
                }], null, null, null, null, "", 4, 0, 0, 0, "", true],
                [6, 5373.0525, -314.3125, 0, "", "", 9, "#0aa5d6", "#0aa5d6", 1, 0, [{
                    "x": -194.52,
                    "y": 94.521
                }, {
                    "x": -194.52,
                    "y": -94.521
                }, {
                    "x": 194.52,
                    "y": -94.521
                }, {
                    "x": 194.52,
                    "y": 94.521
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [6, -590.1055, -401.5539, 0, "", "", 10, "#d60a0a", "#000", 1, 0, [{
                    "x": -393.009,
                    "y": 70
                }, {
                    "x": -393.009,
                    "y": -70
                }, {
                    "x": 393.009,
                    "y": -70
                }, {
                    "x": 393.009,
                    "y": 70
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [0, 288.5415, 12.683, 0, "", "", 11, ["#999999"],
                    ["#000"],
                    [1], true, true, [
                        [{
                            "x": -333.3173,
                            "y": 4.984
                        }, {
                            "x": -333.3173,
                            "y": -4.984
                        }, {
                            "x": 333.3173,
                            "y": -4.984
                        }, {
                            "x": 333.3173,
                            "y": 4.984
                        }]
                    ],
                    [1],
                    [0],
                    [0], "", [0], true, false, false, [0.5],
                    [0.2], false, true, false
                ],
                [0, -39.431, -4.4718, 0, "", "", 12, ["#9e0000"],
                    ["#000"],
                    [1], true, true, [
                        [{
                            "x": 5.2888,
                            "y": -12.219
                        }, {
                            "x": 5.2888,
                            "y": 12.219
                        }, {
                            "x": -5.2888,
                            "y": 12.219
                        }, {
                            "x": -5.2888,
                            "y": -12.219
                        }]
                    ],
                    [1],
                    [0],
                    [0], "Stripe3", [0], true, false, false, [0.5],
                    [0.2], false, true, false
                ],
                [0, 97.2307, -11.6487, 0, "", "", 13, ["#008d96"],
                    ["#000"],
                    [1], true, true, [
                        [{
                            "x": -8.4934,
                            "y": 2.5185
                        }, {
                            "x": 0,
                            "y": -5.037
                        }, {
                            "x": 8.4934,
                            "y": 2.5185
                        }]
                    ],
                    [1],
                    [0],
                    [0], "", [0], true, false, false, [0.5],
                    [0.2], false, true, false
                ],
                [0, 478.5239, 2.5082, 0, "", "", 14, ["#000000"],
                    ["#000"],
                    [1], true, true, [
                        [{
                            "x": 0,
                            "y": 0
                        }, {
                            "x": 0,
                            "y": 0
                        }]
                    ],
                    [1],
                    [0],
                    [150.9726], "", [0], true, false, false, [0.5],
                    [0.2], false, true, false
                ],
                [0, 616.5972, -4.4809, 0, "", "", 15, ["#9e0000"],
                    ["#000"],
                    [1], true, true, [
                        [{
                            "x": 5.2888,
                            "y": -12.219
                        }, {
                            "x": 5.2888,
                            "y": 12.219
                        }, {
                            "x": -5.2888,
                            "y": 12.219
                        }, {
                            "x": -5.2888,
                            "y": -12.219
                        }]
                    ],
                    [1],
                    [0],
                    [0], "Stripe3", [0], true, false, false, [0.5],
                    [0.2], false, true, false
                ],
                [9, -598.2916, -427.0735, 0, "", "Tutorial_Text_1", 16, "Welcome to the tutorial level!", "#ffffff", 1, 55, "Lily Script One", "left", null, null, null, null, 0, 0, 0, true],
                [9, 5393.5087, -388.1819, 0, "", "Tip_Title_1", 17, "!-Create a floor base", "#000", 1, 20, "Lily Script One", "left", null, null, null, null, 0, 0, 0, true],
                [0, 174.6749, -11.8462, 0, "", "", 18, ["#919191", "#f9ff00", "#082796", "#ed0000"],
                    ["#000", "#000", "#000", "#000"],
                    [1, 1, 1, 1, 1], true, true, [
                        [{
                            "x": -1.3482,
                            "y": 1.2275
                        }, {
                            "x": -1.3482,
                            "y": -1.4072
                        }, {
                            "x": 1.2865,
                            "y": -1.4072
                        }, {
                            "x": 1.2865,
                            "y": 1.2275
                        }],
                        [
                            [{
                                "x": 0.3089,
                                "y": 0.1587
                            }, {
                                "x": -1.1541,
                                "y": 0.1476
                            }, {
                                "x": -0.4004,
                                "y": -1.1381
                            }]
                        ],
                        [{
                            "x": -0.0457,
                            "y": -0.0631
                        }, {
                            "x": -0.0457,
                            "y": -0.0631
                        }],
                        [{
                            "x": -0.079,
                            "y": 0.9456
                        }, {
                            "x": -0.079,
                            "y": -0.0852
                        }, {
                            "x": 1.0626,
                            "y": -0.0852
                        }, {
                            "x": 1.0626,
                            "y": 0.9456
                        }]
                    ],
                    [1, 1, 1, 1],
                    [0, 0, 0, 0],
                    [0, 0, 20, 0], "", [2, 1, 1, 1], true, false, false, [0.5, 0.5, 0.5, 0.5],
                    [0.2, 0.2, 0.2, 0.2], false, true, false
                ],
                [9, 5419.5039, -305.3079, 0, "", "Tip_Body_1", 19, "To create a floor base \nplatform for the character\nto ride on, select the \nGeometry tool and draw \na rectangle under the \ncharacter.", "#000", 1, 20, "Karla", "left", null, null, null, null, 0, 0, 0, true],
                [6, 5080.3922, -6.9455, 1.5708, "", "", 20, "#000000", "#000000", 1, 0, [{
                    "x": -199.521,
                    "y": 7.02
                }, {
                    "x": -199.521,
                    "y": -7.02
                }, {
                    "x": 199.521,
                    "y": -7.02
                }, {
                    "x": 199.521,
                    "y": 7.02
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [6, 5124.4082, -199.5935, 0, "", "", 21, "#000000", "#000000", 1, 0, [{
                    "x": -37.263,
                    "y": 7.02
                }, {
                    "x": -37.263,
                    "y": -7.02
                }, {
                    "x": 37.263,
                    "y": -7.02
                }, {
                    "x": 37.263,
                    "y": 7.02
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [6, 5079.5342, 204.2005, 0, "", "", 22, "#000000", "#000000", 1, 0, [{
                    "x": 22.278,
                    "y": -13.392
                }, {
                    "x": 0,
                    "y": 26.784
                }, {
                    "x": -22.278,
                    "y": -13.392
                }], null, null, null, null, "", 4, 0, 0, 0, "", true],
                [9, 51.3373, -424.0296, 0, "", "Tutorial_Titlte_1", 23, "1/10-Drag", "#000", 1, 50, "Lily Script One", "left", null, null, null, null, 0, 0, 0, true],
                [6, 140.0508, 67.1311, 0, "", "", 24, "#999999", "#000", 1, 0, [{
                    "x": -147.2212,
                    "y": 22.92
                }, {
                    "x": -134.6092,
                    "y": -22.92
                }, {
                    "x": 133.5218,
                    "y": -22.92
                }, {
                    "x": 148.3088,
                    "y": 22.92
                }], null, null, null, null, "", 2, 0, 0, 0, "", true],
                [6, 140.7206, 100.9111, 0, "", "", 25, "#707070", "#000", 1, 0, [{
                    "x": -148.521,
                    "y": 8.481
                }, {
                    "x": -148.521,
                    "y": -8.481
                }, {
                    "x": 148.521,
                    "y": -8.481
                }, {
                    "x": 148.521,
                    "y": 8.481
                }], null, null, null, null, "", 2, 0, 0, 0, "", true],
                [9, 129.2289, 65.7452, 0, "", "", 26, "Space", "#000", 1, 25, "Lily Script One", "left", null, null, null, null, 0, 0, 0, true],
                [9, 1077.5305, 46.4744, 0, "", "", 27, "or", "#000", 1, 42, "Lily Script One", "left", null, null, null, null, 0, 0, 0, true],
                [9, 456.6103, 80.5384, 0, "", "", 28, "Click", "#ffffff", 1, 25, "Lily Script One", "left", null, null, null, null, 0, 0, 0, true],
                [6, 355.5476, -41.2949, -0.5236, "", "", 29, "#000000", "#000", 1, 0, [{
                    "x": 20.433,
                    "y": 13.188
                }, {
                    "x": -13.002,
                    "y": -2.415
                }, {
                    "x": -7.431,
                    "y": -10.773
                }], null, null, null, null, "", 2, 0, 0, 0, "", true],
                [6, 381.5516, -87.7319, 0.3491, "", "", 30, "#000000", "#000", 1, 0, [{
                    "x": 20.433,
                    "y": 13.188
                }, {
                    "x": -13.002,
                    "y": -2.415
                }, {
                    "x": -7.431,
                    "y": -10.773
                }], null, null, null, null, "", 2, 0, 0, 0, "", true],
                [6, 361.4906, -67.6709, 0, "", "", 31, "#000000", "#000", 1, 0, [{
                    "x": 20.433,
                    "y": 13.188
                }, {
                    "x": -13.002,
                    "y": -2.415
                }, {
                    "x": -7.431,
                    "y": -10.773
                }], null, null, null, null, "", 2, 0, 0, 0, "", true],
                [6, 1501.7688, 115.3939, 0, "", "", 32, "#000000", "#000", 1, 78.5242, [{
                    "x": 0,
                    "y": 0
                }, {
                    "x": 0,
                    "y": 0
                }], null, null, null, null, "", 2, 0, 0, 0, "", true],
                [6, 1501.5738, 10.9339, 0, "", "", 33, "#999999", "#000", 1, 78.5242, [{
                    "x": 0,
                    "y": 0
                }, {
                    "x": 0,
                    "y": 0
                }], null, null, null, null, "", 2, 0, 0, 0, "", true],
                [6, 1499.9043, -28.2251, 0, "", "", 34, "#000000", "#000", 1, 0, [{
                    "x": -5.0535,
                    "y": 38.244
                }, {
                    "x": -5.0535,
                    "y": -38.244
                }, {
                    "x": 5.0535,
                    "y": -38.244
                }, {
                    "x": 5.0535,
                    "y": 38.244
                }], null, null, null, null, "", 2, 0, 0, 0, "", true],
                [6, 1499.9868, 0.4519, 0, "", "", 35, "#ff0000", "#000", 1, 14.7212, [{
                    "x": 0,
                    "y": 0
                }, {
                    "x": 0,
                    "y": 0
                }], null, null, null, null, "", 2, 0, 0, 0, "", true],
                [6, 1501.5738, 66.6229, 0, "", "", 36, "#000000", "#000", 1, 0, [{
                    "x": -79.377,
                    "y": 56.304
                }, {
                    "x": -79.377,
                    "y": -56.304
                }, {
                    "x": 79.377,
                    "y": -56.304
                }, {
                    "x": 79.377,
                    "y": 56.304
                }], null, null, null, null, "", 2, 0, 0, 0, "", true],
                [6, 1199.6949, -435.4277, 0, "", "", 37, "#0aa5d6", "#000000", 1, 0, [{
                    "x": -322.9273,
                    "y": 42.036
                }, {
                    "x": -322.9273,
                    "y": -42.036
                }, {
                    "x": 322.9273,
                    "y": -42.036
                }, {
                    "x": 322.9273,
                    "y": 42.036
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [9, 1180.2049, -432.6029, 0, "", "Tutorial_Titlte_2", 38, "2/10-Zoom In & Zoom Out", "#000", 1, 50, "Lily Script One", "left", null, null, null, null, 0, 0, 0, true],
                [7, 963.4266, 77.5934, 0, "", "", 39, [
                    [6, -0.6694, -27.2081, 0, "", "", 223, "#999999", "#000", 1, 0, [{
                        "x": -60.6776,
                        "y": 43.9721
                    }, {
                        "x": -47.5733,
                        "y": -43.9721
                    }, {
                        "x": 46.3132,
                        "y": -43.9721
                    }, {
                        "x": 61.9376,
                        "y": 43.9721
                    }], null, null, null, null, "", 2, 0, 0, 0, "", true],
                    [6, 0.6694, 27.2081, 0, "", "", 224, "#707070", "#000", 1, 0, [{
                        "x": -61,
                        "y": 8.481
                    }, {
                        "x": -61,
                        "y": -8.481
                    }, {
                        "x": 61,
                        "y": -8.481
                    }, {
                        "x": 61,
                        "y": 8.481
                    }], null, null, null, null, "", 2, 0, 0, 0, "", true]
                ], null, null, null, null, 1, 0, 0, 0, true, false, []],
                [9, 962.4478, 47.6597, 0, "", "", 40, "+", "#070000", 1, 89, "Lily Script One", "left", null, null, null, null, 0, 0, 0, true],
                [7, 1194.0697, 78.0421, 0, "", "", 41, [
                    [6, -0.6694, -27.2081, 0, "", "", 223, "#999999", "#000", 1, 0, [{
                        "x": -60.6776,
                        "y": 43.9721
                    }, {
                        "x": -47.5733,
                        "y": -43.9721
                    }, {
                        "x": 46.3132,
                        "y": -43.9721
                    }, {
                        "x": 61.9376,
                        "y": 43.9721
                    }], null, null, null, null, "", 2, 0, 0, 0, "", true],
                    [6, 0.6694, 27.2081, 0, "", "", 224, "#707070", "#000", 1, 0, [{
                        "x": -61,
                        "y": 8.481
                    }, {
                        "x": -61,
                        "y": -8.481
                    }, {
                        "x": 61,
                        "y": -8.481
                    }, {
                        "x": 61,
                        "y": 8.481
                    }], null, null, null, null, "", 2, 0, 0, 0, "", true]
                ], null, null, null, null, 1, 0, 0, 0, true, false, []],
                [9, 1193.0909, 48.1085, 0, "", "", 42, "-", "#070000", 1, 89, "Lily Script One", "left", null, null, null, null, 0, 0, 0, true],
                [9, 331.5372, 79.738, 0, "", "", 43, "+", "#000", 1, 100, "Lily Script One", "left", null, null, null, null, 0, 0, 0, true],
                [9, 1336.2951, 55.3487, 0, "", "", 44, "or", "#000", 1, 42, "Lily Script One", "left", null, null, null, null, 0, 0, 0, true],
                [9, 5113.5955, -399.7711, 0, "", "", 45, "Tip!", "#000", 1, 50, "Lily Script One", "left", null, null, null, null, 0, 0, 0, true],
                [7, 2030.3618, 47.9875, -0.5236, "", "", 46, [
                    [6, 39.9149, 117.8124, 0, "", "", 298, "#000000", "#000", 1, 78.5242, [{
                        "x": 0,
                        "y": 0
                    }, {
                        "x": 0,
                        "y": 0
                    }], null, null, null, null, "", 2, 0, 0, 0, "", true],
                    [6, 39.7198, 13.3524, 0, "", "", 299, "#999999", "#000", 1, 78.5242, [{
                        "x": 0,
                        "y": 0
                    }, {
                        "x": 0,
                        "y": 0
                    }], null, null, null, null, "", 2, 0, 0, 0, "", true],
                    [6, 38.0503, -25.8066, 0, "", "", 300, "#000000", "#000", 1, 0, [{
                        "x": -5.0535,
                        "y": 38.244
                    }, {
                        "x": -5.0535,
                        "y": -38.244
                    }, {
                        "x": 5.0535,
                        "y": -38.244
                    }, {
                        "x": 5.0535,
                        "y": 38.244
                    }], null, null, null, null, "", 2, 0, 0, 0, "", true],
                    [6, 38.1328, 2.8704, 0, "", "", 301, "#999999", "#000", 1, 14.7212, [{
                        "x": 0,
                        "y": 0
                    }, {
                        "x": 0,
                        "y": 0
                    }], null, null, null, null, "", 2, 0, 0, 0, "", true],
                    [6, 39.7198, 69.0414, 0, "", "", 302, "#000000", "#000", 1, 0, [{
                        "x": -79.377,
                        "y": 56.304
                    }, {
                        "x": -79.377,
                        "y": -56.304
                    }, {
                        "x": 79.377,
                        "y": -56.304
                    }, {
                        "x": 79.377,
                        "y": 56.304
                    }], null, null, null, null, "", 2, 0, 0, 0, "", true],
                    [6, -75.8283, -34.8191, -0.5236, "", "", 303, "#000000", "#000", 1, 0, [{
                        "x": 20.433,
                        "y": 13.188
                    }, {
                        "x": -13.002,
                        "y": -2.415
                    }, {
                        "x": -7.431,
                        "y": -10.773
                    }], null, null, null, null, "", 2, 0, 0, 0, "", true],
                    [6, -49.8243, -81.2561, 0.3491, "", "", 304, "#000000", "#000", 1, 0, [{
                        "x": 20.433,
                        "y": 13.188
                    }, {
                        "x": -13.002,
                        "y": -2.415
                    }, {
                        "x": -7.431,
                        "y": -10.773
                    }], null, null, null, null, "", 2, 0, 0, 0, "", true],
                    [6, -69.8852, -61.1951, 0, "", "", 305, "#000000", "#000", 1, 0, [{
                        "x": 20.433,
                        "y": 13.188
                    }, {
                        "x": -13.002,
                        "y": -2.415
                    }, {
                        "x": -7.431,
                        "y": -10.773
                    }], null, null, null, null, "", 2, 0, 0, 0, "", true]
                ], null, null, null, null, 1, 0, 0, 0, true, false, []],
                [6, 2173.5129, -428.67, 0, "", "", 47, "#0aa5d6", "#000000", 1, 0, [{
                    "x": -322.9273,
                    "y": 42.036
                }, {
                    "x": -322.9273,
                    "y": -42.036
                }, {
                    "x": 322.9273,
                    "y": -42.036
                }, {
                    "x": 322.9273,
                    "y": 42.036
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [9, 2113.2077, -430.1512, 0, "", "Tutorial_Titlte_3", 48, "3/10-Move the triangle", "#000", 1, 50, "Lily Script One", "left", null, null, null, null, 0, 0, 0, true],
                [7, 2898.0319, 223.9455, 0, "", "", 49, [
                    [6, -237.8185, -0.2569, 0, "", "", 257, "#605959", "#000", 1, 0, [{
                        "x": -25.9304,
                        "y": 5.5565
                    }, {
                        "x": -25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": 5.5565
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, -179.1379, -0.1057, 0, "", "", 258, "#605959", "#000", 1, 0, [{
                        "x": -25.9304,
                        "y": 5.5565
                    }, {
                        "x": -25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": 5.5565
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, -118.3049, -0.1813, 0, "", "", 259, "#605959", "#000", 1, 0, [{
                        "x": -25.9304,
                        "y": 5.5565
                    }, {
                        "x": -25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": 5.5565
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, -59.6243, -0.0301, 0, "", "", 260, "#605959", "#000", 1, 0, [{
                        "x": -25.9304,
                        "y": 5.5565
                    }, {
                        "x": -25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": 5.5565
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, 0.8297, 0.0015, 0, "", "", 261, "#605959", "#000", 1, 0, [{
                        "x": -25.9304,
                        "y": 5.5565
                    }, {
                        "x": -25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": 5.5565
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, 59.5102, 0.1526, 0, "", "", 262, "#605959", "#000", 1, 0, [{
                        "x": -25.9304,
                        "y": 5.5565
                    }, {
                        "x": -25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": 5.5565
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, 120.3432, 0.077, 0, "", "", 263, "#605959", "#000", 1, 0, [{
                        "x": -25.9304,
                        "y": 5.5565
                    }, {
                        "x": -25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": 5.5565
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, 179.0238, 0.2282, 0, "", "", 264, "#605959", "#000", 1, 0, [{
                        "x": -25.9304,
                        "y": 5.5565
                    }, {
                        "x": -25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": 5.5565
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, 235.1789, 0.1148, 0, "", "", 265, "#605959", "#000", 1, 0, [{
                        "x": -25.9304,
                        "y": 5.5565
                    }, {
                        "x": -25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": 5.5565
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true]
                ], null, null, null, null, 1, 0, 0, 0, true, false, []],
                [7, 3038.4573, 95.8414, 0.733, "", "", 50, [
                    [6, -148.8346, -0.1151, 0, "", "", 263, "#605959", "#000", 1, 0, [{
                        "x": -25.9304,
                        "y": 5.5565
                    }, {
                        "x": -25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": 5.5565
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, -88.3806, -0.0858, 0, "", "", 264, "#605959", "#000", 1, 0, [{
                        "x": -25.9304,
                        "y": 5.5565
                    }, {
                        "x": -25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": 5.5565
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, -29.7, 0.0631, 0, "", "", 265, "#605959", "#000", 1, 0, [{
                        "x": -25.9304,
                        "y": 5.5565
                    }, {
                        "x": -25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": 5.5565
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, 31.1329, -0.0149, 0, "", "", 266, "#605959", "#000", 1, 0, [{
                        "x": -25.9304,
                        "y": 5.5565
                    }, {
                        "x": -25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": 5.5565
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, 89.8136, 0.1341, 0, "", "", 267, "#605959", "#000", 1, 0, [{
                        "x": -25.9304,
                        "y": 5.5565
                    }, {
                        "x": -25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": 5.5565
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, 145.9687, 0.0185, 0, "", "", 268, "#605959", "#000", 1, 0, [{
                        "x": -25.9304,
                        "y": 5.5565
                    }, {
                        "x": -25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": 5.5565
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true]
                ], null, null, null, null, 1, 0, 0, 0, true, false, []],
                [7, 2759.2252, 88.5998, -0.733, "", "", 51, [
                    [6, -148.8346, -0.1151, 0, "", "", 263, "#605959", "#000", 1, 0, [{
                        "x": -25.9304,
                        "y": 5.5565
                    }, {
                        "x": -25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": 5.5565
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, -88.3806, -0.0858, 0, "", "", 264, "#605959", "#000", 1, 0, [{
                        "x": -25.9304,
                        "y": 5.5565
                    }, {
                        "x": -25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": 5.5565
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, -29.7, 0.0631, 0, "", "", 265, "#605959", "#000", 1, 0, [{
                        "x": -25.9304,
                        "y": 5.5565
                    }, {
                        "x": -25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": 5.5565
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, 31.1329, -0.0149, 0, "", "", 266, "#605959", "#000", 1, 0, [{
                        "x": -25.9304,
                        "y": 5.5565
                    }, {
                        "x": -25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": 5.5565
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, 89.8136, 0.1341, 0, "", "", 267, "#605959", "#000", 1, 0, [{
                        "x": -25.9304,
                        "y": 5.5565
                    }, {
                        "x": -25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": 5.5565
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, 145.9687, 0.0185, 0, "", "", 268, "#605959", "#000", 1, 0, [{
                        "x": -25.9304,
                        "y": 5.5565
                    }, {
                        "x": -25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": 5.5565
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true]
                ], null, null, null, null, 1, 0, 0, 0, true, false, []],
                [6, 4587.6195, -20.1105, 0, "", "", 52, "#000000", "#c45757", 1, 0, [{
                    "x": 29.5,
                    "y": -16.3333
                }, {
                    "x": 0,
                    "y": 32.6667
                }, {
                    "x": -29.5,
                    "y": -16.3333
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [6, 4015.2759, -424.3549, 0, "", "", 53, "#0aa5d6", "#000000", 1, 0, [{
                    "x": -322.9273,
                    "y": 42.036
                }, {
                    "x": -322.9273,
                    "y": -42.036
                }, {
                    "x": 322.9273,
                    "y": -42.036
                }, {
                    "x": 322.9273,
                    "y": 42.036
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [9, 3931.9782, -425.5675, 0, "", "Tutorial_Titlte_4", 54, "4/10-Draw a square", "#000", 1, 50, "Lily Script One", "left", null, null, null, null, 0, 0, 0, true],
                [7, 3650.9524, -421.1973, 0, "", "", 55, [
                    [6, -0.9488, -2.7622, 0, "", "", 134, "#919191", "#000", 1, 0, [{
                        "x": -40.5,
                        "y": 40.5
                    }, {
                        "x": -40.5,
                        "y": -40.5
                    }, {
                        "x": 40.5,
                        "y": -40.5
                    }, {
                        "x": 40.5,
                        "y": 40.5
                    }], null, null, null, null, "", 2, 0, 0, 0, "", true],
                    [6, -12.7651, -8.5241, 0, "", "", 135, "#f9ff00", "#000", 1, null, [{
                        "x": 22.2614,
                        "y": 13.4032
                    }, {
                        "x": -22.7164,
                        "y": 13.0619
                    }, {
                        "x": 0.455,
                        "y": -26.4651
                    }], null, null, null, null, "", 1, 0, 0, 0, "", true],
                    [6, -1.4054, -1.9398, 0, "", "", 136, "#082796", "#000", 1, 20, [{
                        "x": 0,
                        "y": 0
                    }, {
                        "x": 0,
                        "y": 0
                    }], null, null, null, null, "", 1, 0, 0, 0, "", true],
                    [6, 15.1193, 13.226, 0, "", "", 137, "#ed0000", "#000", 1, 0, [{
                        "x": -17.5484,
                        "y": 15.8452
                    }, {
                        "x": -17.5484,
                        "y": -15.8452
                    }, {
                        "x": 17.5484,
                        "y": -15.8452
                    }, {
                        "x": 17.5484,
                        "y": 15.8452
                    }], null, null, null, null, "", 1, 0, 0, 0, "", true]
                ], null, null, null, null, 1, 0, 0, 0, true, false, []],
                [9, 2100.8093, 93.4288, -0.5236, "", "", 56, "Select & Drag", "#ffffff", 1, 25, "Lily Script One", "left", null, null, null, null, 0, 0, 0, true],
                [7, 3903.0222, 53.6341, -0.5236, "", "", 57, [
                    [6, 39.9149, 117.8124, 0, "", "", 298, "#000000", "#000", 1, 78.5242, [{
                        "x": 0,
                        "y": 0
                    }, {
                        "x": 0,
                        "y": 0
                    }], null, null, null, null, "", 2, 0, 0, 0, "", true],
                    [6, 39.7198, 13.3524, 0, "", "", 299, "#999999", "#000", 1, 78.5242, [{
                        "x": 0,
                        "y": 0
                    }, {
                        "x": 0,
                        "y": 0
                    }], null, null, null, null, "", 2, 0, 0, 0, "", true],
                    [6, 38.0503, -25.8066, 0, "", "", 300, "#000000", "#000", 1, 0, [{
                        "x": -5.0535,
                        "y": 38.244
                    }, {
                        "x": -5.0535,
                        "y": -38.244
                    }, {
                        "x": 5.0535,
                        "y": -38.244
                    }, {
                        "x": 5.0535,
                        "y": 38.244
                    }], null, null, null, null, "", 2, 0, 0, 0, "", true],
                    [6, 38.1328, 2.8704, 0, "", "", 301, "#999999", "#000", 1, 14.7212, [{
                        "x": 0,
                        "y": 0
                    }, {
                        "x": 0,
                        "y": 0
                    }], null, null, null, null, "", 2, 0, 0, 0, "", true],
                    [6, 39.7198, 69.0414, 0, "", "", 302, "#000000", "#000", 1, 0, [{
                        "x": -79.377,
                        "y": 56.304
                    }, {
                        "x": -79.377,
                        "y": -56.304
                    }, {
                        "x": 79.377,
                        "y": -56.304
                    }, {
                        "x": 79.377,
                        "y": 56.304
                    }], null, null, null, null, "", 2, 0, 0, 0, "", true],
                    [6, -75.8283, -34.8191, -0.5236, "", "", 303, "#000000", "#000", 1, 0, [{
                        "x": 20.433,
                        "y": 13.188
                    }, {
                        "x": -13.002,
                        "y": -2.415
                    }, {
                        "x": -7.431,
                        "y": -10.773
                    }], null, null, null, null, "", 2, 0, 0, 0, "", true],
                    [6, -49.8243, -81.2561, 0.3491, "", "", 304, "#000000", "#000", 1, 0, [{
                        "x": 20.433,
                        "y": 13.188
                    }, {
                        "x": -13.002,
                        "y": -2.415
                    }, {
                        "x": -7.431,
                        "y": -10.773
                    }], null, null, null, null, "", 2, 0, 0, 0, "", true],
                    [6, -69.8852, -61.1951, 0, "", "", 305, "#000000", "#000", 1, 0, [{
                        "x": 20.433,
                        "y": 13.188
                    }, {
                        "x": -13.002,
                        "y": -2.415
                    }, {
                        "x": -7.431,
                        "y": -10.773
                    }], null, null, null, null, "", 2, 0, 0, 0, "", true]
                ], null, null, null, null, 1, 0, 0, 0, true, false, []],
                [9, 3973.4698, 99.0753, -0.5236, "", "", 58, "Click & Drag", "#ffffff", 1, 25, "Lily Script One", "left", null, null, null, null, 0, 0, 0, true],
                [7, 4582.7619, 221.877, 0, "", "", 59, [
                    [6, -60.1155, 0, 0, "", "", 398, "#ff0000", "#000", 1, 0, [{
                        "x": -25.9304,
                        "y": 5.5565
                    }, {
                        "x": -25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": 5.5565
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, 0.7175, -0.0756, 0, "", "", 399, "#ff0000", "#000", 1, 0, [{
                        "x": -25.9304,
                        "y": 5.5565
                    }, {
                        "x": -25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": 5.5565
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, 59.3981, 0.0756, 0, "", "", 400, "#ff0000", "#000", 1, 0, [{
                        "x": -25.9304,
                        "y": 5.5565
                    }, {
                        "x": -25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": 5.5565
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true]
                ], null, null, null, null, 1, 0, 0, 0, true, false, []],
                [7, 4580.0476, 32.3676, 0, "", "", 60, [
                    [6, -60.1155, 0, 0, "", "", 398, "#ff0000", "#000", 1, 0, [{
                        "x": -25.9304,
                        "y": 5.5565
                    }, {
                        "x": -25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": 5.5565
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, 0.7175, -0.0756, 0, "", "", 399, "#ff0000", "#000", 1, 0, [{
                        "x": -25.9304,
                        "y": 5.5565
                    }, {
                        "x": -25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": 5.5565
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, 59.3981, 0.0756, 0, "", "", 400, "#ff0000", "#000", 1, 0, [{
                        "x": -25.9304,
                        "y": 5.5565
                    }, {
                        "x": -25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": 5.5565
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true]
                ], null, null, null, null, 1, 0, 0, 0, true, false, []],
                [7, 4674.4555, 128.3846, 1.5708, "", "", 61, [
                    [6, -60.1155, -0.0002, 0, "", "", 398, "#ff0000", "#000", 1, 0, [{
                        "x": -25.9304,
                        "y": 5.5565
                    }, {
                        "x": -25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": 5.5565
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, 0.7175, -0.0756, 0, "", "", 399, "#ff0000", "#000", 1, 0, [{
                        "x": -25.9304,
                        "y": 5.5565
                    }, {
                        "x": -25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": 5.5565
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, 59.3981, 0.0758, 0, "", "", 400, "#ff0000", "#000", 1, 0, [{
                        "x": -25.9304,
                        "y": 5.5565
                    }, {
                        "x": -25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": 5.5565
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true]
                ], null, null, null, null, 1, 0, 0, 0, true, false, []],
                [7, 4489.1174, 128.4552, 1.5708, "", "", 62, [
                    [6, -60.1155, 0, 0, "", "", 398, "#f90000", "#000", 1, 0, [{
                        "x": -25.9304,
                        "y": 5.5565
                    }, {
                        "x": -25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": 5.5565
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, 0.7175, -0.0756, 0, "", "", 399, "#f90000", "#000", 1, 0, [{
                        "x": -25.9304,
                        "y": 5.5565
                    }, {
                        "x": -25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": 5.5565
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, 59.3981, 0.0756, 0, "", "", 400, "#f90000", "#000", 1, 0, [{
                        "x": -25.9304,
                        "y": 5.5565
                    }, {
                        "x": -25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": 5.5565
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true]
                ], null, null, null, null, 1, 0, 0, 0, true, false, []],
                [6, 4582.7922, -21.814, 0, "", "", 63, "#f40000", "#c45757", 1, 0, [{
                    "x": 29.5,
                    "y": -16.3333
                }, {
                    "x": 0,
                    "y": 32.6667
                }, {
                    "x": -29.5,
                    "y": -16.3333
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [9, 4582.6764, -61.3468, 0, "", "", 64, "Here", "#000000", 1, 25, "Lily Script One", "left", null, null, null, null, 0, 0, 0, true],
                [6, 6386.5006, -424.1113, 0, "", "", 65, "#0aa5d6", "#000000", 1, 0, [{
                    "x": -322.9273,
                    "y": 42.036
                }, {
                    "x": -322.9273,
                    "y": -42.036
                }, {
                    "x": 322.9273,
                    "y": -42.036
                }, {
                    "x": 322.9273,
                    "y": 42.036
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [9, 6344.0032, -424.956, 0, "", "Tutorial_Titlte_5", 66, "5/10-Modify this square", "#000", 1, 50, "Lily Script One", "left", null, null, null, null, 0, 0, 0, true],
                [6, 6252.5995, -26.208, 0, "", "", 67, "#7c6a6a", "#60ff00", 1, 0, [{
                    "x": -64.5,
                    "y": 64.5
                }, {
                    "x": -64.5,
                    "y": -64.5
                }, {
                    "x": 64.5,
                    "y": -64.5
                }, {
                    "x": 64.5,
                    "y": 64.5
                }], null, null, null, null, "", 3, 0, 0, 0, "", true],
                [7, 6333.1074, 57.1923, -0.5236, "", "", 68, [
                    [6, 39.9149, 117.8124, 0, "", "", 298, "#000000", "#000", 1, 78.5242, [{
                        "x": 0,
                        "y": 0
                    }, {
                        "x": 0,
                        "y": 0
                    }], null, null, null, null, "", 2, 0, 0, 0, "", true],
                    [6, 39.7198, 13.3524, 0, "", "", 299, "#999999", "#000", 1, 78.5242, [{
                        "x": 0,
                        "y": 0
                    }, {
                        "x": 0,
                        "y": 0
                    }], null, null, null, null, "", 2, 0, 0, 0, "", true],
                    [6, 38.0503, -25.8066, 0, "", "", 300, "#000000", "#000", 1, 0, [{
                        "x": -5.0535,
                        "y": 38.244
                    }, {
                        "x": -5.0535,
                        "y": -38.244
                    }, {
                        "x": 5.0535,
                        "y": -38.244
                    }, {
                        "x": 5.0535,
                        "y": 38.244
                    }], null, null, null, null, "", 2, 0, 0, 0, "", true],
                    [6, 38.1328, 2.8704, 0, "", "", 301, "#999999", "#000", 1, 14.7212, [{
                        "x": 0,
                        "y": 0
                    }, {
                        "x": 0,
                        "y": 0
                    }], null, null, null, null, "", 2, 0, 0, 0, "", true],
                    [6, 39.7198, 69.0414, 0, "", "", 302, "#000000", "#000", 1, 0, [{
                        "x": -79.377,
                        "y": 56.304
                    }, {
                        "x": -79.377,
                        "y": -56.304
                    }, {
                        "x": 79.377,
                        "y": -56.304
                    }, {
                        "x": 79.377,
                        "y": 56.304
                    }], null, null, null, null, "", 2, 0, 0, 0, "", true],
                    [6, -75.8283, -34.8191, -0.5236, "", "", 303, "#000000", "#000", 1, 0, [{
                        "x": 20.433,
                        "y": 13.188
                    }, {
                        "x": -13.002,
                        "y": -2.415
                    }, {
                        "x": -7.431,
                        "y": -10.773
                    }], null, null, null, null, "", 2, 0, 0, 0, "", true],
                    [6, -49.8243, -81.2561, 0.3491, "", "", 304, "#000000", "#000", 1, 0, [{
                        "x": 20.433,
                        "y": 13.188
                    }, {
                        "x": -13.002,
                        "y": -2.415
                    }, {
                        "x": -7.431,
                        "y": -10.773
                    }], null, null, null, null, "", 2, 0, 0, 0, "", true],
                    [6, -69.8852, -61.1951, 0, "", "", 305, "#000000", "#000", 1, 0, [{
                        "x": 20.433,
                        "y": 13.188
                    }, {
                        "x": -13.002,
                        "y": -2.415
                    }, {
                        "x": -7.431,
                        "y": -10.773
                    }], null, null, null, null, "", 2, 0, 0, 0, "", true]
                ], null, null, null, null, 1, 0, 0, 0, true, false, []],
                [9, 6403.555, 102.6335, -0.5236, "", "", 69, "Select", "#ffffff", 1, 25, "Lily Script One", "left", null, null, null, null, 0, 0, 0, true],
                [0, 234.8447, 4.3955, 0, "", "", 70, ["#21a33d"],
                    ["#000000"],
                    [1], true, true, [
                        [{
                            "x": -2.731,
                            "y": 2.6735
                        }, {
                            "x": -2.731,
                            "y": -2.6735
                        }, {
                            "x": 2.731,
                            "y": -2.6735
                        }, {
                            "x": 2.731,
                            "y": 2.6735
                        }]
                    ],
                    [1],
                    [0],
                    [0], "", [2], true, false, false, [0.5],
                    [0.2], false, true, false
                ],
                [6, 6987.8845, 224, 0, "", "", 71, "#ff0000", "#000", 1, 0, [{
                    "x": -25.9304,
                    "y": 5.5565
                }, {
                    "x": -25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": 5.5565
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [6, 7048.7175, 223.9244, 0, "", "", 72, "#ff0000", "#000", 1, 0, [{
                    "x": -25.9304,
                    "y": 5.5565
                }, {
                    "x": -25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": 5.5565
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [6, 7107.3981, 224.0756, 0, "", "", 73, "#ff0000", "#000", 1, 0, [{
                    "x": -25.9304,
                    "y": 5.5565
                }, {
                    "x": -25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": 5.5565
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [7, 7322, 132, 0, "", "", 74, [
                    [6, 0.0002, -60.1155, 1.5708, "", "", 84, "#f90000", "#000", 1, 0, [{
                        "x": -25.9304,
                        "y": 5.5565
                    }, {
                        "x": -25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": 5.5565
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, 0.0756, 0.7175, 1.5708, "", "", 85, "#f90000", "#000", 1, 0, [{
                        "x": -25.9304,
                        "y": 5.5565
                    }, {
                        "x": -25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": 5.5565
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, -0.0758, 59.3981, 1.5708, "", "", 86, "#f90000", "#000", 1, 0, [{
                        "x": -25.9304,
                        "y": 5.5565
                    }, {
                        "x": -25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": 5.5565
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true]
                ], null, null, null, null, 1, 0, 0, 0, true, false, []],
                [6, 7165.7917, 223.2428, 0, "", "", 75, "#ff0000", "#000", 1, 0, [{
                    "x": -25.9304,
                    "y": 5.5565
                }, {
                    "x": -25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": 5.5565
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [6, 7226.6247, 223.1672, 0, "", "", 76, "#ff0000", "#000", 1, 0, [{
                    "x": -25.9304,
                    "y": 5.5565
                }, {
                    "x": -25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": 5.5565
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [6, 7285.3053, 223.3184, 0, "", "", 77, "#ff0000", "#000", 1, 0, [{
                    "x": -25.9304,
                    "y": 5.5565
                }, {
                    "x": -25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": 5.5565
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [6, 6987.8845, 40, 0, "", "", 78, "#ea0000", "#000", 1, 0, [{
                    "x": -25.9304,
                    "y": 5.5565
                }, {
                    "x": -25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": 5.5565
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [6, 7048.7175, 39.9244, 0, "", "", 79, "#ea0000", "#000", 1, 0, [{
                    "x": -25.9304,
                    "y": 5.5565
                }, {
                    "x": -25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": 5.5565
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [6, 7107.3981, 40.0756, 0, "", "", 80, "#ea0000", "#000", 1, 0, [{
                    "x": -25.9304,
                    "y": 5.5565
                }, {
                    "x": -25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": 5.5565
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [6, 7167.8845, 40, 0, "", "", 81, "#ea0000", "#000", 1, 0, [{
                    "x": -25.9304,
                    "y": 5.5565
                }, {
                    "x": -25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": 5.5565
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [6, 7228.7175, 39.9244, 0, "", "", 82, "#ea0000", "#000", 1, 0, [{
                    "x": -25.9304,
                    "y": 5.5565
                }, {
                    "x": -25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": 5.5565
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [6, 7287.3981, 40.0756, 0, "", "", 83, "#ea0000", "#000", 1, 0, [{
                    "x": -25.9304,
                    "y": 5.5565
                }, {
                    "x": -25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": 5.5565
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [6, 6946.0002, 73.8845, 1.5708, "", "", 84, "#f40000", "#000", 1, 0, [{
                    "x": -25.9304,
                    "y": 5.5565
                }, {
                    "x": -25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": 5.5565
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [6, 6946.0756, 134.7175, 1.5708, "", "", 85, "#f40000", "#000", 1, 0, [{
                    "x": -25.9304,
                    "y": 5.5565
                }, {
                    "x": -25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": 5.5565
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [6, 6945.9242, 193.3981, 1.5708, "", "", 86, "#f40000", "#000", 1, 0, [{
                    "x": -25.9304,
                    "y": 5.5565
                }, {
                    "x": -25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": 5.5565
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [9, 6997.1029, -665.8704, 0, "", "", 87, "Body", "#ffffff", 1, 25, "Karla", "left", null, null, null, null, 0, 0, 0, true],
                [6, 7164.5155, -424.4061, 0, "", "", 88, "#3d3d3d", "#000000", 1, 0, [{
                    "x": -246.21,
                    "y": 16.239
                }, {
                    "x": -246.21,
                    "y": -16.239
                }, {
                    "x": 246.21,
                    "y": -16.239
                }, {
                    "x": 246.21,
                    "y": 16.239
                }], null, null, null, null, "", 2, 0, 0, 0, "", true],
                [9, 7001.7391, -423.4392, 0, "", "", 89, "Visuals", "#ffffff", 1, 25, "Karla", "left", null, null, null, null, 0, 0, 0, true],
                [6, 6942.1505, -665.188, 0, "", "", 90, "#ffffff", "#ffffff", 1, 0, [{
                    "x": 10.6992,
                    "y": -5.1267
                }, {
                    "x": 0,
                    "y": 10.2534
                }, {
                    "x": -10.6992,
                    "y": -5.1267
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [6, 6939.4168, -427.4339, 0, "", "", 91, "#ffffff", "#ffffff", 1, 0, [{
                    "x": 10.6992,
                    "y": -5.1267
                }, {
                    "x": 0,
                    "y": 10.2534
                }, {
                    "x": -10.6992,
                    "y": -5.1267
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [9, 6976.3272, -559.5801, 0, "", "", 92, "Width", "#ffffff", 1, 25, "Karla", "left", null, null, null, null, 0, 0, 0, true],
                [9, 7119.656, -606.851, 0, "", "", 93, "7045", "#00efff", 1, 25, "Karla", "left", null, null, null, null, 0, 0, 0, true],
                [9, 6973.3847, -468.9216, 0, "", "", 94, "Name", "#ffffff", 1, 25, "Karla", "left", null, null, null, null, 0, 0, 0, true],
                [9, 7268.3272, -555.5801, 0, "", "", 95, "Height", "#ffffff", 1, 25, "Karla", "left", null, null, null, null, 0, 0, 0, true],
                [9, 7240.3272, -607.5801, 0, "", "", 96, "Y", "#ffffff", 1, 25, "Karla", "left", null, null, null, null, 0, 0, 0, true],
                [9, 6986.3272, -506.1298, 0, "", "", 97, "Rotation", "#ffffff", 1, 25, "Karla", "left", null, null, null, null, 0, 0, 0, true],
                [9, 6954.8472, -610.3228, 0, "", "", 98, "X", "#ffffff", 1, 25, "Karla", "left", null, null, null, null, 0, 0, 0, true],
                [9, 7112.3272, -559.5801, 0, "", "", 99, "165", "#00efff", 1, 25, "Karla", "left", null, null, null, null, 0, 0, 0, true],
                [9, 7360.3272, -553.5801, 0, "", "", 100, "161", "#00efff", 1, 25, "Karla", "left", null, null, null, null, 0, 0, 0, true],
                [9, 7360.3272, -603.5801, 0, "", "", 101, "134", "#00efff", 1, 25, "Karla", "left", null, null, null, null, 0, 0, 0, true],
                [9, 7369.3716, -176.6024, 0, "", "", 102, "1", "#00efff", 1, 25, "Karla", "left", null, null, null, null, 0, 0, 0, true],
                [7, 7521.9504, -344.7394, 0.5236, "", "", 103, [
                    [6, -0.5315, 2.9732, 0, "", "", 400, "#000000", "#000", 1, null, [{
                        "x": -76.396,
                        "y": -5.7186,
                        "point1": {
                            "x": -46.0445,
                            "y": -0.8105
                        },
                        "point2": {
                            "x": -17.8157,
                            "y": -6.128
                        }
                    }, {
                        "x": 12.9262,
                        "y": -5.6321,
                        "point1": {
                            "x": 16.5689,
                            "y": -5.5734
                        },
                        "point2": {
                            "x": 20.0893,
                            "y": -4.1356
                        }
                    }, {
                        "x": 23.7288,
                        "y": -3.9702,
                        "point1": {
                            "x": 52.9054,
                            "y": -2.644
                        },
                        "point2": {
                            "x": 82.7952,
                            "y": -3.1143
                        }
                    }, {
                        "x": 111.8114,
                        "y": -2.3082,
                        "point1": {
                            "x": 121.783,
                            "y": -2.0313
                        },
                        "point2": {
                            "x": 131.7632,
                            "y": -1.9754
                        }
                    }, {
                        "x": 141.7263,
                        "y": -1.4773,
                        "point1": {
                            "x": 145.5993,
                            "y": -1.2836
                        },
                        "point2": {
                            "x": 150.0714,
                            "y": -3.5325
                        }
                    }, {
                        "x": 153.3598,
                        "y": -1.4773,
                        "point1": {
                            "x": 155.1943,
                            "y": -0.3307
                        },
                        "point2": {
                            "x": 150.2788,
                            "y": 1.6519
                        }
                    }, {
                        "x": 148.374,
                        "y": 2.6776,
                        "point1": {
                            "x": 146.5985,
                            "y": 3.6336
                        },
                        "point2": {
                            "x": 144.5708,
                            "y": 4.2307
                        }
                    }, {
                        "x": 142.5572,
                        "y": 4.3395,
                        "point1": {
                            "x": 132.5963,
                            "y": 4.8779
                        },
                        "point2": {
                            "x": 122.6158,
                            "y": 4.9669
                        }
                    }, {
                        "x": 112.6424,
                        "y": 5.1705,
                        "point1": {
                            "x": 81.7926,
                            "y": 5.8001
                        },
                        "point2": {
                            "x": 50.2664,
                            "y": 4.7862
                        }
                    }, {
                        "x": 19.5739,
                        "y": 6.8324,
                        "point1": {
                            "x": -9.8137,
                            "y": 8.7916
                        },
                        "point2": {
                            "x": -56.371,
                            "y": 6.8195
                        }
                    }, {
                        "x": -85.6731,
                        "y": 5.8427,
                        "point1": {
                            "x": -97.7406,
                            "y": 5.4405
                        },
                        "point2": {
                            "x": -85.6388,
                            "y": 19.6952
                        }
                    }, {
                        "x": -97.5992,
                        "y": 18.6079,
                        "point1": {
                            "x": -101.2274,
                            "y": 18.2781
                        },
                        "point2": {
                            "x": -113.0359,
                            "y": 10.1583
                        }
                    }, {
                        "x": -117.0103,
                        "y": 8.4008,
                        "point1": {
                            "x": -118.7836,
                            "y": 7.6166
                        },
                        "point2": {
                            "x": -141.4126,
                            "y": -6.7188
                        }
                    }, {
                        "x": -141.4126,
                        "y": -8.6577,
                        "point1": {
                            "x": -141.4126,
                            "y": -10.7515
                        },
                        "point2": {
                            "x": -94.9839,
                            "y": -24.1173
                        }
                    }, {
                        "x": -93.8001,
                        "y": -24.4461,
                        "point1": {
                            "x": -88.3996,
                            "y": -25.9463
                        },
                        "point2": {
                            "x": -92.0859,
                            "y": -16.0355
                        }
                    }, {
                        "x": -89.8107,
                        "y": -11.0481,
                        "point1": {
                            "x": -88.4967,
                            "y": -8.1676
                        },
                        "point2": {
                            "x": -93.083,
                            "y": -7.569
                        }
                    }, {
                        "x": -89.258,
                        "y": -6.9315,
                        "point1": {
                            "x": -87.0552,
                            "y": -6.5643
                        },
                        "point2": {
                            "x": -84.013,
                            "y": -6.9503
                        }
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, 0.5315, -2.9732, 0, "", "", 401, "#e80000", "#000", 1, null, [{
                        "x": -90.1139,
                        "y": -3.9702,
                        "point1": {
                            "x": -86.5414,
                            "y": -4.6847
                        },
                        "point2": {
                            "x": -82.9541,
                            "y": -5.5734
                        }
                    }, {
                        "x": -79.3113,
                        "y": -5.6321,
                        "point1": {
                            "x": -48.5695,
                            "y": -6.128
                        },
                        "point2": {
                            "x": -17.8157,
                            "y": -6.128
                        }
                    }, {
                        "x": 12.9262,
                        "y": -5.6321,
                        "point1": {
                            "x": 16.5689,
                            "y": -5.5734
                        },
                        "point2": {
                            "x": 20.0893,
                            "y": -4.1356
                        }
                    }, {
                        "x": 23.7288,
                        "y": -3.9702,
                        "point1": {
                            "x": 52.9054,
                            "y": -2.644
                        },
                        "point2": {
                            "x": 82.7952,
                            "y": -3.1143
                        }
                    }, {
                        "x": 111.8114,
                        "y": -2.3082,
                        "point1": {
                            "x": 121.783,
                            "y": -2.0313
                        },
                        "point2": {
                            "x": 131.7632,
                            "y": -1.9754
                        }
                    }, {
                        "x": 141.7263,
                        "y": -1.4773,
                        "point1": {
                            "x": 145.5993,
                            "y": -1.2836
                        },
                        "point2": {
                            "x": 150.0714,
                            "y": -3.5325
                        }
                    }, {
                        "x": 153.3598,
                        "y": -1.4773,
                        "point1": {
                            "x": 155.1943,
                            "y": -0.3307
                        },
                        "point2": {
                            "x": 150.2788,
                            "y": 1.6519
                        }
                    }, {
                        "x": 148.374,
                        "y": 2.6776,
                        "point1": {
                            "x": 146.5985,
                            "y": 3.6336
                        },
                        "point2": {
                            "x": 144.5708,
                            "y": 4.2307
                        }
                    }, {
                        "x": 142.5572,
                        "y": 4.3395,
                        "point1": {
                            "x": 132.5963,
                            "y": 4.8779
                        },
                        "point2": {
                            "x": 122.6158,
                            "y": 4.9669
                        }
                    }, {
                        "x": 112.6424,
                        "y": 5.1705,
                        "point1": {
                            "x": 81.7926,
                            "y": 5.8001
                        },
                        "point2": {
                            "x": 50.2664,
                            "y": 4.7862
                        }
                    }, {
                        "x": 19.5739,
                        "y": 6.8324,
                        "point1": {
                            "x": -9.8137,
                            "y": 8.7916
                        },
                        "point2": {
                            "x": -62.8525,
                            "y": 7.6973
                        }
                    }, {
                        "x": -92.1432,
                        "y": 6.4223,
                        "point1": {
                            "x": -101.6459,
                            "y": 6.0087
                        },
                        "point2": {
                            "x": -89.0926,
                            "y": 18.7366
                        }
                    }, {
                        "x": -101.053,
                        "y": 17.6493,
                        "point1": {
                            "x": -104.6812,
                            "y": 17.3195
                        },
                        "point2": {
                            "x": -116.5157,
                            "y": 10.8862
                        }
                    }, {
                        "x": -120.0228,
                        "y": 9.5431,
                        "point1": {
                            "x": -121.8335,
                            "y": 8.8497
                        },
                        "point2": {
                            "x": -141.0945,
                            "y": -2.4356
                        }
                    }, {
                        "x": -141.0945,
                        "y": -4.3745,
                        "point1": {
                            "x": -141.0945,
                            "y": -6.4683
                        },
                        "point2": {
                            "x": -97.639,
                            "y": -20.6604
                        }
                    }, {
                        "x": -96.4552,
                        "y": -20.9892,
                        "point1": {
                            "x": -91.0547,
                            "y": -22.4894
                        },
                        "point2": {
                            "x": -98.5297,
                            "y": -6.0754
                        }
                    }, {
                        "x": -93.0547,
                        "y": -6.3492,
                        "point1": {
                            "x": -89.1817,
                            "y": -6.5428
                        },
                        "point2": {
                            "x": -87.2912,
                            "y": -5.4387
                        }
                    }, {
                        "x": -83.4662,
                        "y": -4.8012,
                        "point1": {
                            "x": -81.2634,
                            "y": -4.434
                        },
                        "point2": {
                            "x": -92.3037,
                            "y": -3.5322
                        }
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true]
                ], null, null, null, null, 1, 0, 0, 0, true, false, []],
                [9, 6834.7817, -565.8062, 0, "", "", 104, "346", "#000000", 1, 65, "Karla", "left", null, null, null, null, 0, 0, 0, true],
                [9, 6834.5125, -567.4194, 0, "", "", 105, "346", "#ff0000", 1, 65, "Karla", "left", null, null, null, null, 0, 0, 0, true],
                [9, 6995.2019, -381.3919, 0, "", "", 106, "tileTexture", "#ffffff", 1, 25, "Karla", "left", null, null, null, null, 0, 0, 0, true],
                [9, 6980.2874, -327.6504, 0, "", "", 107, "colorFill", "#ffffff", 1, 25, "Karla", "left", null, null, null, null, 0, 0, 0, true],
                [9, 6988.1921, -279.074, 0, "", "", 108, "colorLine", "#ffffff", 1, 25, "Karla", "left", null, null, null, null, 0, 0, 0, true],
                [9, 6991.5605, -227.0906, 0, "", "", 109, "LineWidth", "#ffffff", 1, 25, "Karla", "left", null, null, null, null, 0, 0, 0, true],
                [9, 6980.2682, -171.6425, 0, "", "", 110, "Opacity", "#ffffff", 1, 25, "Karla", "left", null, null, null, null, 0, 0, 0, true],
                [6, 7294.8612, -376.5661, 0, "", "", 111, "#3d3d3d", "#000000", 1, 0, [{
                    "x": -86.112,
                    "y": 25
                }, {
                    "x": -86.112,
                    "y": -25
                }, {
                    "x": 86.112,
                    "y": -25
                }, {
                    "x": 86.112,
                    "y": 25
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [6, 7294.8527, -319.0926, 0, "", "", 112, "#21a33d", "#000000", 1, 0, [{
                    "x": -86.112,
                    "y": 17.664
                }, {
                    "x": -86.112,
                    "y": -17.664
                }, {
                    "x": 86.112,
                    "y": -17.664
                }, {
                    "x": 86.112,
                    "y": 17.664
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [6, 7295.2734, -275.0926, 0, "", "", 113, "#000000", "#000000", 1, 0, [{
                    "x": -86.112,
                    "y": 17.664
                }, {
                    "x": -86.112,
                    "y": -17.664
                }, {
                    "x": 86.112,
                    "y": -17.664
                }, {
                    "x": 86.112,
                    "y": 17.664
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [6, 7279.9637, -229.0926, 0, "", "", 114, "#3d3d3d", "#000000", 1, 0, [{
                    "x": -69.8919,
                    "y": 17.664
                }, {
                    "x": -69.8919,
                    "y": -17.664
                }, {
                    "x": 69.8919,
                    "y": -17.664
                }, {
                    "x": 69.8919,
                    "y": 17.664
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [6, 7279.7474, -178.6701, 0, "", "", 115, "#3d3d3d", "#000000", 1, 0, [{
                    "x": -69.8919,
                    "y": 17.664
                }, {
                    "x": -69.8919,
                    "y": -17.664
                }, {
                    "x": 69.8919,
                    "y": -17.664
                }, {
                    "x": 69.8919,
                    "y": 17.664
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [9, 7236.7234, -503.6964, 0, "", "", 116, "0", "#00efff", 1, 25, "Karla", "left", null, null, null, null, 0, 0, 0, true],
                [9, 7369.4858, -227.6903, 0, "", "", 117, "2", "#00efff", 1, 25, "Karla", "left", null, null, null, null, 0, 0, 0, true],
                [6, 7277.887, -178.6313, 0, "", "", 118, "#00d1ff", "#000000", 1, 0, [{
                    "x": -69.8919,
                    "y": 17.664
                }, {
                    "x": -69.8919,
                    "y": -17.664
                }, {
                    "x": 69.8919,
                    "y": -17.664
                }, {
                    "x": 69.8919,
                    "y": 17.664
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [9, 7293.4974, -317.1742, 0, "", "", 119, "#21a33d", "#ffffff", 1, 20, "Karla", "left", null, null, null, null, 0, 0, 0, true],
                [6, 7225.4288, -228.7404, 0, "", "", 120, "#00d1ff", "#000000", 1, 0, [{
                    "x": -15,
                    "y": 17.664
                }, {
                    "x": -15,
                    "y": -17.664
                }, {
                    "x": 15,
                    "y": -17.664
                }, {
                    "x": 15,
                    "y": 17.664
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [9, 7294.4243, -275.8869, 0, "", "", 121, "#000000", "#ffffff", 1, 20, "Karla", "left", null, null, null, null, 0, 0, 0, true],
                [7, 6984.3212, -535.2622, 0, "", "", 122, [
                    [6, -0.4821, 3.0587, 0, "", "", 373, "#000000", "#000", 1, null, [{
                        "x": -90.1139,
                        "y": -3.9702,
                        "point1": {
                            "x": -86.5414,
                            "y": -4.6847
                        },
                        "point2": {
                            "x": -82.9541,
                            "y": -5.5734
                        }
                    }, {
                        "x": -79.3113,
                        "y": -5.6321,
                        "point1": {
                            "x": -48.5695,
                            "y": -6.128
                        },
                        "point2": {
                            "x": -17.8157,
                            "y": -6.128
                        }
                    }, {
                        "x": 12.9262,
                        "y": -5.6321,
                        "point1": {
                            "x": 16.5689,
                            "y": -5.5734
                        },
                        "point2": {
                            "x": 20.0893,
                            "y": -4.1356
                        }
                    }, {
                        "x": 23.7288,
                        "y": -3.9702,
                        "point1": {
                            "x": 52.9054,
                            "y": -2.644
                        },
                        "point2": {
                            "x": 82.7952,
                            "y": -3.1143
                        }
                    }, {
                        "x": 111.8114,
                        "y": -2.3082,
                        "point1": {
                            "x": 121.783,
                            "y": -2.0313
                        },
                        "point2": {
                            "x": 131.7632,
                            "y": -1.9754
                        }
                    }, {
                        "x": 141.7263,
                        "y": -1.4773,
                        "point1": {
                            "x": 145.5993,
                            "y": -1.2836
                        },
                        "point2": {
                            "x": 150.0714,
                            "y": -3.5325
                        }
                    }, {
                        "x": 153.3598,
                        "y": -1.4773,
                        "point1": {
                            "x": 155.1943,
                            "y": -0.3307
                        },
                        "point2": {
                            "x": 150.2788,
                            "y": 1.6519
                        }
                    }, {
                        "x": 148.374,
                        "y": 2.6776,
                        "point1": {
                            "x": 146.5985,
                            "y": 3.6336
                        },
                        "point2": {
                            "x": 144.5708,
                            "y": 4.2307
                        }
                    }, {
                        "x": 142.5572,
                        "y": 4.3395,
                        "point1": {
                            "x": 132.5963,
                            "y": 4.8779
                        },
                        "point2": {
                            "x": 122.6158,
                            "y": 4.9669
                        }
                    }, {
                        "x": 112.6424,
                        "y": 5.1705,
                        "point1": {
                            "x": 81.7926,
                            "y": 5.8001
                        },
                        "point2": {
                            "x": 50.2664,
                            "y": 4.7862
                        }
                    }, {
                        "x": 19.5739,
                        "y": 6.8324,
                        "point1": {
                            "x": -9.8137,
                            "y": 8.7916
                        },
                        "point2": {
                            "x": -39.2066,
                            "y": 6.9782
                        }
                    }, {
                        "x": -68.5087,
                        "y": 6.0014,
                        "point1": {
                            "x": -80.5762,
                            "y": 5.5992
                        },
                        "point2": {
                            "x": -92.28,
                            "y": 5.4268
                        }
                    }, {
                        "x": -104.2404,
                        "y": 4.3395,
                        "point1": {
                            "x": -107.8686,
                            "y": 4.0097
                        },
                        "point2": {
                            "x": -111.4178,
                            "y": 3.0401
                        }
                    }, {
                        "x": -115.043,
                        "y": 2.6776,
                        "point1": {
                            "x": -116.9723,
                            "y": 2.4846
                        },
                        "point2": {
                            "x": -120.8597,
                            "y": 4.6165
                        }
                    }, {
                        "x": -120.8597,
                        "y": 2.6776,
                        "point1": {
                            "x": -120.8597,
                            "y": 0.5838
                        },
                        "point2": {
                            "x": -111.2409,
                            "y": -0.3175
                        }
                    }, {
                        "x": -110.0571,
                        "y": -0.6463,
                        "point1": {
                            "x": -104.6566,
                            "y": -2.1465
                        },
                        "point2": {
                            "x": -100.5747,
                            "y": -4.5274
                        }
                    }, {
                        "x": -95.0997,
                        "y": -4.8012,
                        "point1": {
                            "x": -91.2267,
                            "y": -4.9948
                        },
                        "point2": {
                            "x": -87.2912,
                            "y": -5.4387
                        }
                    }, {
                        "x": -83.4662,
                        "y": -4.8012,
                        "point1": {
                            "x": -81.2634,
                            "y": -4.434
                        },
                        "point2": {
                            "x": -92.3037,
                            "y": -3.5322
                        }
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, 0.4821, -3.0587, 0, "", "", 374, "#e80000", "#000", 1, null, [{
                        "x": -90.1139,
                        "y": -3.9702,
                        "point1": {
                            "x": -86.5414,
                            "y": -4.6847
                        },
                        "point2": {
                            "x": -82.9541,
                            "y": -5.5734
                        }
                    }, {
                        "x": -79.3113,
                        "y": -5.6321,
                        "point1": {
                            "x": -48.5695,
                            "y": -6.128
                        },
                        "point2": {
                            "x": -17.8157,
                            "y": -6.128
                        }
                    }, {
                        "x": 12.9262,
                        "y": -5.6321,
                        "point1": {
                            "x": 16.5689,
                            "y": -5.5734
                        },
                        "point2": {
                            "x": 20.0893,
                            "y": -4.1356
                        }
                    }, {
                        "x": 23.7288,
                        "y": -3.9702,
                        "point1": {
                            "x": 52.9054,
                            "y": -2.644
                        },
                        "point2": {
                            "x": 82.7952,
                            "y": -3.1143
                        }
                    }, {
                        "x": 111.8114,
                        "y": -2.3082,
                        "point1": {
                            "x": 121.783,
                            "y": -2.0313
                        },
                        "point2": {
                            "x": 131.7632,
                            "y": -1.9754
                        }
                    }, {
                        "x": 141.7263,
                        "y": -1.4773,
                        "point1": {
                            "x": 145.5993,
                            "y": -1.2836
                        },
                        "point2": {
                            "x": 150.0714,
                            "y": -3.5325
                        }
                    }, {
                        "x": 153.3598,
                        "y": -1.4773,
                        "point1": {
                            "x": 155.1943,
                            "y": -0.3307
                        },
                        "point2": {
                            "x": 150.2788,
                            "y": 1.6519
                        }
                    }, {
                        "x": 148.374,
                        "y": 2.6776,
                        "point1": {
                            "x": 146.5985,
                            "y": 3.6336
                        },
                        "point2": {
                            "x": 144.5708,
                            "y": 4.2307
                        }
                    }, {
                        "x": 142.5572,
                        "y": 4.3395,
                        "point1": {
                            "x": 132.5963,
                            "y": 4.8779
                        },
                        "point2": {
                            "x": 122.6158,
                            "y": 4.9669
                        }
                    }, {
                        "x": 112.6424,
                        "y": 5.1705,
                        "point1": {
                            "x": 81.7926,
                            "y": 5.8001
                        },
                        "point2": {
                            "x": 50.2664,
                            "y": 4.7862
                        }
                    }, {
                        "x": 19.5739,
                        "y": 6.8324,
                        "point1": {
                            "x": -9.8137,
                            "y": 8.7916
                        },
                        "point2": {
                            "x": -39.2066,
                            "y": 6.9782
                        }
                    }, {
                        "x": -68.5087,
                        "y": 6.0014,
                        "point1": {
                            "x": -80.5762,
                            "y": 5.5992
                        },
                        "point2": {
                            "x": -92.28,
                            "y": 5.4268
                        }
                    }, {
                        "x": -104.2404,
                        "y": 4.3395,
                        "point1": {
                            "x": -107.8686,
                            "y": 4.0097
                        },
                        "point2": {
                            "x": -111.4178,
                            "y": 3.0401
                        }
                    }, {
                        "x": -115.043,
                        "y": 2.6776,
                        "point1": {
                            "x": -116.9723,
                            "y": 2.4846
                        },
                        "point2": {
                            "x": -120.8597,
                            "y": 4.6165
                        }
                    }, {
                        "x": -120.8597,
                        "y": 2.6776,
                        "point1": {
                            "x": -120.8597,
                            "y": 0.5838
                        },
                        "point2": {
                            "x": -111.2409,
                            "y": -0.3175
                        }
                    }, {
                        "x": -110.0571,
                        "y": -0.6463,
                        "point1": {
                            "x": -104.6566,
                            "y": -2.1465
                        },
                        "point2": {
                            "x": -100.5747,
                            "y": -4.5274
                        }
                    }, {
                        "x": -95.0997,
                        "y": -4.8012,
                        "point1": {
                            "x": -91.2267,
                            "y": -4.9948
                        },
                        "point2": {
                            "x": -87.2912,
                            "y": -5.4387
                        }
                    }, {
                        "x": -83.4662,
                        "y": -4.8012,
                        "point1": {
                            "x": -81.2634,
                            "y": -4.434
                        },
                        "point2": {
                            "x": -92.3037,
                            "y": -3.5322
                        }
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true]
                ], null, null, null, null, 1, 0, 0, 0, true, false, []],
                [6, 7163.2985, -101.8994, 0, "", "", 123, "#3d3d3d", "#000000", 1, 0, [{
                    "x": -246.21,
                    "y": 16.239
                }, {
                    "x": -246.21,
                    "y": -16.239
                }, {
                    "x": 246.21,
                    "y": -16.239
                }, {
                    "x": 246.21,
                    "y": 16.239
                }], null, null, null, null, "", 2, 0, 0, 0, "", true],
                [9, 7011.31, -102.2999, 0, "", "", 124, "Advanced", "#ffffff", 1, 25, "Karla", "left", null, null, null, null, 0, 0, 0, true],
                [6, 6938.8981, -102.2953, 0.5236, "", "", 125, "#ffffff", "#ffffff", 1, 0, [{
                    "x": 10.6992,
                    "y": -5.1267
                }, {
                    "x": -0.9331,
                    "y": 12.6418
                }, {
                    "x": -10.6992,
                    "y": -5.1267
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [4, 9003.1952, 211.0579, 0, {
                    "delay": 3,
                    "force": 2500,
                    "active": false,
                    "activateOn": "Impact"
                }, "Grenade"],
                [6, 8617.8821, -422.4895, 0, "", "", 128, "#0aa5d6", "#000000", 1, 0, [{
                    "x": -322.9273,
                    "y": 42.036
                }, {
                    "x": -322.9273,
                    "y": -42.036
                }, {
                    "x": 322.9273,
                    "y": -42.036
                }, {
                    "x": 322.9273,
                    "y": 42.036
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [9, 8546.6903, -420.7625, 0, "", "Tutorial_Titlte_6", 129, "6/10-Add Obstacles!", "#000", 1, 50, "Lily Script One", "left", null, null, null, null, 0, 0, 0, true],
                [0, 293.5689, 6.627, 0, "", "", 130, ["#999999"],
                    ["#000000"],
                    [1], true, true, [
                        [
                            [{
                                "x": 5.221,
                                "y": 1.0985
                            }, {
                                "x": 5.2258,
                                "y": -2.2341
                            }, {
                                "x": -10.4051,
                                "y": 1.1355
                            }]
                        ]
                    ],
                    [1],
                    [0],
                    [0], "", [0], true, false, false, [0.5],
                    [0.2], false, true, false
                ],
                [0, 322.6967, 6.6408, 0, "", "", 131, ["#999999"],
                    ["#000000"],
                    [1], true, true, [
                        [
                            [{
                                "x": -5.221,
                                "y": 1.0985
                            }, {
                                "x": -5.2258,
                                "y": -2.2341
                            }, {
                                "x": 10.4051,
                                "y": 1.1355
                            }]
                        ]
                    ],
                    [1],
                    [0],
                    [0], "", [0], true, false, false, [0.5],
                    [0.2], false, true, false
                ],
                [4, 9069.1743, 212.5594, 0, {
                    "delay": 3,
                    "force": 2500,
                    "active": false,
                    "activateOn": "Impact"
                }, "Grenade"],
                [4, 9133.1964, 211.8086, 0, {
                    "delay": 3,
                    "force": 2500,
                    "active": false,
                    "activateOn": "Impact"
                }, "Grenade"],
                [4, 9199.1756, 213.3102, 0, {
                    "delay": 3,
                    "force": 2500,
                    "active": false,
                    "activateOn": "Impact"
                }, "Grenade"],
                [4, 9279.339, 213.3354, 0, {
                    "delay": 3,
                    "force": 2500,
                    "active": false,
                    "activateOn": "Impact"
                }, "Grenade"],
                [4, 9345.3181, 214.837, 0, {
                    "delay": 3,
                    "force": 2500,
                    "active": false,
                    "activateOn": "Impact"
                }, "Grenade"],
                [4, 9409.3402, 214.0862, 0, {
                    "delay": 3,
                    "force": 2500,
                    "active": false,
                    "activateOn": "Impact"
                }, "Grenade"],
                [4, 9475.3194, 215.5878, 0, {
                    "delay": 3,
                    "force": 2500,
                    "active": false,
                    "activateOn": "Impact"
                }, "Grenade"],
                [6, 9247.3837, 40.2272, 0, "", "", 146, "#000000", "#c45757", 1, 0, [{
                    "x": 29.5,
                    "y": -16.3333
                }, {
                    "x": 0,
                    "y": 32.6667
                }, {
                    "x": -29.5,
                    "y": -16.3333
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [6, 9242.5564, 38.5237, 0, "", "", 147, "#f40000", "#c45757", 1, 0, [{
                    "x": 29.5,
                    "y": -16.3333
                }, {
                    "x": 0,
                    "y": 32.6667
                }, {
                    "x": -29.5,
                    "y": -16.3333
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [9, 9244.7776, -2.1776, 0, "", "", 148, "Here", "#000000", 1, 25, "Lily Script One", "left", null, null, null, null, 0, 0, 0, true],
                [6, 8256.6164, -422.6194, 0, "", "", 149, "#919191", "#000", 1, 0, [{
                    "x": -40.5,
                    "y": 40.5
                }, {
                    "x": -40.5,
                    "y": -40.5
                }, {
                    "x": 40.5,
                    "y": -40.5
                }, {
                    "x": 40.5,
                    "y": 40.5
                }], null, null, null, null, "", 2, 0, 0, 0, "", true],
                [6, 8257.2858, -422.7558, 0, "", "", 150, "#00e0ff", "#000000", 1, 0, [{
                    "x": -10.3455,
                    "y": -11.9386
                }, {
                    "x": -1.1363,
                    "y": -31.1245
                }, {
                    "x": 7.3055,
                    "y": -11.5549
                }, {
                    "x": 27.9581,
                    "y": -11.1711
                }, {
                    "x": 14.2124,
                    "y": 4.945
                }, {
                    "x": 19.4855,
                    "y": 27.3491
                }, {
                    "x": 0.8999,
                    "y": 11.9509
                }, {
                    "x": -16.485,
                    "y": 27.2006
                }, {
                    "x": -13.898,
                    "y": 5.8982
                }, {
                    "x": -27.9965,
                    "y": -11.5549
                }], null, null, null, null, "", 1, 0, 0, 0, "", true],
                [7, 9256.6453, -457.0224, 0, "", "", 151, [
                    [6, -0.0049, 108.7963, 0, "", "", 450, "#6b6a6a", "#000000", 1, 0, [{
                        "x": -240.8255,
                        "y": 198.5
                    }, {
                        "x": -240.8255,
                        "y": -198.5
                    }, {
                        "x": 240.8255,
                        "y": -198.5
                    }, {
                        "x": 240.8255,
                        "y": 198.5
                    }], null, null, null, null, "", 2, 0, 0, 0, "", true],
                    [6, 0.0049, -108.7963, 0, "", "", 451, "#3d3d3d", "#000000", 1, 0, [{
                        "x": -243.5,
                        "y": 17.742
                    }, {
                        "x": -243.5,
                        "y": -17.742
                    }, {
                        "x": 243.5,
                        "y": -17.742
                    }, {
                        "x": 243.5,
                        "y": 17.742
                    }], null, null, null, null, "", 2, 0, 0, 0, "", true]
                ], null, null, null, null, 1, 0, 0, 0, true, false, []],
                [9, 9096.5309, -565.8673, 0, "", "", 152, "Prefabs", "#ffffff", 1, 25, "Karla", "left", null, null, null, null, 0, 0, 0, true],
                [6, 9033.0373, -569.8667, 0, "", "", 153, "#ffffff", "#ffffff", 1, 0, [{
                    "x": 10.6992,
                    "y": -5.1267
                }, {
                    "x": 0,
                    "y": 10.2534
                }, {
                    "x": -10.6992,
                    "y": -5.1267
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [9, 9122.1588, -522.6171, 0, "", "", 154, "Choose Category", "#ffffff", 1, 25, "Karla", "left", null, null, null, null, 0, 0, 0, true],
                [6, 9255.3423, -323.8517, 0, "", "", 155, "#262525", "#000000", 1, 0, [{
                    "x": -237.786,
                    "y": 170.232
                }, {
                    "x": -237.786,
                    "y": -170.232
                }, {
                    "x": 237.786,
                    "y": -170.232
                }, {
                    "x": 237.786,
                    "y": 170.232
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [9, 12936.1506, -180.945, 0, "", "", 156, "Click Here", "#000000", 1, 25, "Lily Script One", "left", null, null, null, null, 0, 0, 0, true],
                [6, 6857.434, 15.1857, 0.6109, "", "", 157, "#000000", "#000", 1, null, [{
                    "x": 76.396,
                    "y": -5.7186,
                    "point1": {
                        "x": 46.0445,
                        "y": -0.8105
                    },
                    "point2": {
                        "x": 17.8157,
                        "y": -6.128
                    }
                }, {
                    "x": -12.9262,
                    "y": -5.6321,
                    "point1": {
                        "x": -16.5689,
                        "y": -5.5734
                    },
                    "point2": {
                        "x": -24.4,
                        "y": -5.8171
                    }
                }, {
                    "x": -28.0395,
                    "y": -5.6517,
                    "point1": {
                        "x": -57.2161,
                        "y": -4.3255
                    },
                    "point2": {
                        "x": -83.9522,
                        "y": -7.004
                    }
                }, {
                    "x": -112.9684,
                    "y": -6.1979,
                    "point1": {
                        "x": -122.94,
                        "y": -5.921
                    },
                    "point2": {
                        "x": -131.6585,
                        "y": -5.1819
                    }
                }, {
                    "x": -141.6216,
                    "y": -4.6838,
                    "point1": {
                        "x": -145.4946,
                        "y": -4.4901
                    },
                    "point2": {
                        "x": -639.4627,
                        "y": -13.3468
                    }
                }, {
                    "x": -642.7511,
                    "y": -11.2916,
                    "point1": {
                        "x": -644.5856,
                        "y": -10.145
                    },
                    "point2": {
                        "x": -641.4563,
                        "y": -0.6452
                    }
                }, {
                    "x": -639.5515,
                    "y": 0.3805,
                    "point1": {
                        "x": -637.776,
                        "y": 1.3365
                    },
                    "point2": {
                        "x": -144.5708,
                        "y": 4.2307
                    }
                }, {
                    "x": -142.5572,
                    "y": 4.3395,
                    "point1": {
                        "x": -132.5963,
                        "y": 4.8779
                    },
                    "point2": {
                        "x": -122.6158,
                        "y": 4.9669
                    }
                }, {
                    "x": -112.6424,
                    "y": 5.1705,
                    "point1": {
                        "x": -81.7926,
                        "y": 5.8001
                    },
                    "point2": {
                        "x": -50.2664,
                        "y": 4.7862
                    }
                }, {
                    "x": -19.5739,
                    "y": 6.8324,
                    "point1": {
                        "x": 9.8137,
                        "y": 8.7916
                    },
                    "point2": {
                        "x": 56.371,
                        "y": 6.8195
                    }
                }, {
                    "x": 85.6731,
                    "y": 5.8427,
                    "point1": {
                        "x": 97.7406,
                        "y": 5.4405
                    },
                    "point2": {
                        "x": 85.6388,
                        "y": 19.6952
                    }
                }, {
                    "x": 97.5992,
                    "y": 18.6079,
                    "point1": {
                        "x": 101.2274,
                        "y": 18.2781
                    },
                    "point2": {
                        "x": 113.0359,
                        "y": 10.1583
                    }
                }, {
                    "x": 117.0103,
                    "y": 8.4008,
                    "point1": {
                        "x": 118.7836,
                        "y": 7.6166
                    },
                    "point2": {
                        "x": 141.4126,
                        "y": -6.7188
                    }
                }, {
                    "x": 141.4126,
                    "y": -8.6577,
                    "point1": {
                        "x": 141.4126,
                        "y": -10.7515
                    },
                    "point2": {
                        "x": 94.9839,
                        "y": -24.1173
                    }
                }, {
                    "x": 93.8001,
                    "y": -24.4461,
                    "point1": {
                        "x": 88.3996,
                        "y": -25.9463
                    },
                    "point2": {
                        "x": 92.0859,
                        "y": -16.0355
                    }
                }, {
                    "x": 89.8107,
                    "y": -11.0481,
                    "point1": {
                        "x": 88.4967,
                        "y": -8.1676
                    },
                    "point2": {
                        "x": 93.083,
                        "y": -7.569
                    }
                }, {
                    "x": 89.258,
                    "y": -6.9315,
                    "point1": {
                        "x": 87.0552,
                        "y": -6.5643
                    },
                    "point2": {
                        "x": 84.013,
                        "y": -6.9503
                    }
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [6, 6861.3277, 10.5675, 0.6109, "", "", 158, "#e80000", "#000", 1, null, [{
                    "x": 90.1139,
                    "y": -3.9702,
                    "point1": {
                        "x": 86.5414,
                        "y": -4.6847
                    },
                    "point2": {
                        "x": 82.9541,
                        "y": -5.5734
                    }
                }, {
                    "x": 79.3113,
                    "y": -5.6321,
                    "point1": {
                        "x": 48.5695,
                        "y": -6.128
                    },
                    "point2": {
                        "x": 17.8157,
                        "y": -6.128
                    }
                }, {
                    "x": -12.9262,
                    "y": -5.6321,
                    "point1": {
                        "x": -16.5689,
                        "y": -5.5734
                    },
                    "point2": {
                        "x": -20.0893,
                        "y": -4.1356
                    }
                }, {
                    "x": -23.7288,
                    "y": -3.9702,
                    "point1": {
                        "x": -52.9054,
                        "y": -2.644
                    },
                    "point2": {
                        "x": -82.6905,
                        "y": -6.3208
                    }
                }, {
                    "x": -111.7067,
                    "y": -5.5147,
                    "point1": {
                        "x": -121.6783,
                        "y": -5.2378
                    },
                    "point2": {
                        "x": -131.869,
                        "y": -6.6012
                    }
                }, {
                    "x": -141.8321,
                    "y": -6.1031,
                    "point1": {
                        "x": -145.7051,
                        "y": -5.9094
                    },
                    "point2": {
                        "x": -650.3969,
                        "y": -16.6569
                    }
                }, {
                    "x": -653.6853,
                    "y": -14.6017,
                    "point1": {
                        "x": -655.5198,
                        "y": -13.4551
                    },
                    "point2": {
                        "x": -653.4946,
                        "y": -5.5321
                    }
                }, {
                    "x": -651.5898,
                    "y": -4.5064,
                    "point1": {
                        "x": -649.8143,
                        "y": -3.5504
                    },
                    "point2": {
                        "x": -144.5708,
                        "y": 4.2307
                    }
                }, {
                    "x": -142.5572,
                    "y": 4.3395,
                    "point1": {
                        "x": -132.5963,
                        "y": 4.8779
                    },
                    "point2": {
                        "x": -122.6158,
                        "y": 4.9669
                    }
                }, {
                    "x": -112.6424,
                    "y": 5.1705,
                    "point1": {
                        "x": -81.7926,
                        "y": 5.8001
                    },
                    "point2": {
                        "x": -50.2664,
                        "y": 4.7862
                    }
                }, {
                    "x": -19.5739,
                    "y": 6.8324,
                    "point1": {
                        "x": 9.8137,
                        "y": 8.7916
                    },
                    "point2": {
                        "x": 62.8525,
                        "y": 7.6973
                    }
                }, {
                    "x": 92.1432,
                    "y": 6.4223,
                    "point1": {
                        "x": 101.6459,
                        "y": 6.0087
                    },
                    "point2": {
                        "x": 89.0926,
                        "y": 18.7366
                    }
                }, {
                    "x": 101.053,
                    "y": 17.6493,
                    "point1": {
                        "x": 104.6812,
                        "y": 17.3195
                    },
                    "point2": {
                        "x": 116.5157,
                        "y": 10.8862
                    }
                }, {
                    "x": 120.0228,
                    "y": 9.5431,
                    "point1": {
                        "x": 121.8335,
                        "y": 8.8497
                    },
                    "point2": {
                        "x": 141.0945,
                        "y": -2.4356
                    }
                }, {
                    "x": 141.0945,
                    "y": -4.3745,
                    "point1": {
                        "x": 141.0945,
                        "y": -6.4683
                    },
                    "point2": {
                        "x": 97.639,
                        "y": -20.6604
                    }
                }, {
                    "x": 96.4552,
                    "y": -20.9892,
                    "point1": {
                        "x": 91.0547,
                        "y": -22.4894
                    },
                    "point2": {
                        "x": 98.5297,
                        "y": -6.0754
                    }
                }, {
                    "x": 93.0547,
                    "y": -6.3492,
                    "point1": {
                        "x": 89.1817,
                        "y": -6.5428
                    },
                    "point2": {
                        "x": 87.2912,
                        "y": -5.4387
                    }
                }, {
                    "x": 83.4662,
                    "y": -4.8012,
                    "point1": {
                        "x": 81.2634,
                        "y": -4.434
                    },
                    "point2": {
                        "x": 92.3037,
                        "y": -3.5322
                    }
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [6, 9375.7582, -519.6649, 0, "", "", 159, "#302d2d", "#cccccc", 1, 0, [{
                    "x": -109,
                    "y": 18.8141
                }, {
                    "x": -109,
                    "y": -18.8141
                }, {
                    "x": 109,
                    "y": -18.8141
                }, {
                    "x": 109,
                    "y": 18.8141
                }], null, null, null, null, "", 1, 0, 0, 0, "", true],
                [6, 9464.81, -523.2266, 0, "", "", 160, "#00ffef", "#ffffff", 1, 0, [{
                    "x": 10.6992,
                    "y": -5.1267
                }, {
                    "x": 0,
                    "y": 10.2534
                }, {
                    "x": -10.6992,
                    "y": -5.1267
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [9, 9319.6894, -520.2186, 0, "", "", 161, "Weapon", "#ffffff", 1, 25, "Karla", "left", null, null, null, null, 0, 0, 0, true],
                [6, 10695.3056, -432.9431, 0, "", "", 162, "#0aa5d6", "#000000", 1, 0, [{
                    "x": -322.9273,
                    "y": 42.036
                }, {
                    "x": -322.9273,
                    "y": -42.036
                }, {
                    "x": 322.9273,
                    "y": -42.036
                }, {
                    "x": 322.9273,
                    "y": 42.036
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [9, 10616.0885, -433.8888, 0, "", "Tutorial_Titlte_7", 163, "7/10-Add Checkpoint", "#000", 1, 50, "Lily Script One", "left", null, null, null, null, 0, 0, 0, true],
                [6, 10331.0196, -431.7537, 0, "", "", 164, "#919191", "#000", 1, 0, [{
                    "x": -40.5,
                    "y": 40.5
                }, {
                    "x": -40.5,
                    "y": -40.5
                }, {
                    "x": 40.5,
                    "y": -40.5
                }, {
                    "x": 40.5,
                    "y": 40.5
                }], null, null, null, null, "", 2, 0, 0, 0, "", true],
                [6, 10331.689, -431.8901, 0, "", "", 165, "#00e0ff", "#000000", 1, 0, [{
                    "x": -10.3455,
                    "y": -11.9386
                }, {
                    "x": -1.1363,
                    "y": -31.1245
                }, {
                    "x": 7.3055,
                    "y": -11.5549
                }, {
                    "x": 27.9581,
                    "y": -11.1711
                }, {
                    "x": 14.2124,
                    "y": 4.945
                }, {
                    "x": 19.4855,
                    "y": 27.3491
                }, {
                    "x": 0.8999,
                    "y": 11.9509
                }, {
                    "x": -16.485,
                    "y": 27.2006
                }, {
                    "x": -13.898,
                    "y": 5.8982
                }, {
                    "x": -27.9965,
                    "y": -11.5549
                }], null, null, null, null, "", 1, 0, 0, 0, "", true],
                [7, 11334.0688, -467.476, 0, "", "", 166, [
                    [6, -0.0049, 108.7963, 0, "", "", 450, "#6b6a6a", "#000000", 1, 0, [{
                        "x": -240.8255,
                        "y": 198.5
                    }, {
                        "x": -240.8255,
                        "y": -198.5
                    }, {
                        "x": 240.8255,
                        "y": -198.5
                    }, {
                        "x": 240.8255,
                        "y": 198.5
                    }], null, null, null, null, "", 2, 0, 0, 0, "", true],
                    [6, 0.0049, -108.7963, 0, "", "", 451, "#3d3d3d", "#000000", 1, 0, [{
                        "x": -243.5,
                        "y": 17.742
                    }, {
                        "x": -243.5,
                        "y": -17.742
                    }, {
                        "x": 243.5,
                        "y": -17.742
                    }, {
                        "x": 243.5,
                        "y": 17.742
                    }], null, null, null, null, "", 2, 0, 0, 0, "", true]
                ], null, null, null, null, 1, 0, 0, 0, true, false, []],
                [9, 11173.9544, -576.3209, 0, "", "", 167, "Prefabs", "#ffffff", 1, 25, "Karla", "left", null, null, null, null, 0, 0, 0, true],
                [6, 11110.4608, -580.3203, 0, "", "", 168, "#ffffff", "#ffffff", 1, 0, [{
                    "x": 10.6992,
                    "y": -5.1267
                }, {
                    "x": 0,
                    "y": 10.2534
                }, {
                    "x": -10.6992,
                    "y": -5.1267
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [9, 11199.5823, -533.0707, 0, "", "", 169, "Choose Category", "#ffffff", 1, 25, "Karla", "left", null, null, null, null, 0, 0, 0, true],
                [6, 11333.988, -334.917, 0, "", "", 170, "#262525", "#000000", 1, 0, [{
                    "x": -237.786,
                    "y": 170.232
                }, {
                    "x": -237.786,
                    "y": -170.232
                }, {
                    "x": 237.786,
                    "y": -170.232
                }, {
                    "x": 237.786,
                    "y": 170.232
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [6, 11453.1816, -530.1184, 0, "", "", 171, "#302d2d", "#cccccc", 1, 0, [{
                    "x": -109,
                    "y": 18.8141
                }, {
                    "x": -109,
                    "y": -18.8141
                }, {
                    "x": 109,
                    "y": -18.8141
                }, {
                    "x": 109,
                    "y": 18.8141
                }], null, null, null, null, "", 1, 0, 0, 0, "", true],
                [6, 11542.2334, -533.6802, 0, "", "", 172, "#00ffef", "#ffffff", 1, 0, [{
                    "x": 10.6992,
                    "y": -5.1267
                }, {
                    "x": 0,
                    "y": 10.2534
                }, {
                    "x": -10.6992,
                    "y": -5.1267
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [9, 11381.3306, -530.6722, 0, "", "", 173, "Level", "#ffffff", 1, 25, "Karla", "left", null, null, null, null, 0, 0, 0, true],
                [6, 12044.5411, -454.7834, 0, "", "", 174, "#968f8f", "#000000", 1, 0, [{
                    "x": -210.006,
                    "y": 122.5
                }, {
                    "x": -210.006,
                    "y": -122.5
                }, {
                    "x": 210.006,
                    "y": -122.5
                }, {
                    "x": 210.006,
                    "y": 122.5
                }], null, null, null, null, "", 4, 0, 0, 0, "", true],
                [6, 12039.9577, -457.4494, 0, "", "", 175, "#0aa5d6", "#0aa5d6", 1, 0, [{
                    "x": -194.52,
                    "y": 110
                }, {
                    "x": -194.52,
                    "y": -110
                }, {
                    "x": 194.52,
                    "y": -110
                }, {
                    "x": 194.52,
                    "y": 110
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [9, 11941.5745, -541.3666, 0, "", "Tip_Title_2", 176, "!-Prefabs Settings", "#000", 1, 20, "Lily Script One", "left", null, null, null, null, 0, 0, 0, true],
                [9, 12044.3442, -444.5068, 0, "", "Tip_Body_2", 177, "Some elements, including prefabs have\ndifferent settings that you can modify\njust left click on them to open the\nsettings box.\nIf you want a prefab to not move from\nwhere you placed it, then tick the\nIs Fixed Box and it will stay in place.", "#000", 1, 20, "Karla", "left", null, null, null, null, 0, 0, 0, true],
                [9, 11786.095, -555.4953, 0, "", "", 178, "Tip!", "#000", 1, 50, "Lily Script One", "left", null, null, null, null, 0, 0, 0, true],
                [6, 12625.2622, -433.5998, 0, "", "", 179, "#6b6a6a", "#000000", 1, 0, [{
                    "x": -240.8255,
                    "y": 123.5
                }, {
                    "x": -240.8255,
                    "y": -123.5
                }, {
                    "x": 240.8255,
                    "y": -123.5
                }, {
                    "x": 240.8255,
                    "y": 123.5
                }], null, null, null, null, "", 2, 0, 0, 0, "", true],
                [6, 12623.7712, -569.374, 0, "", "", 180, "#3d3d3d", "#000000", 1, 0, [{
                    "x": -243.5,
                    "y": 17.742
                }, {
                    "x": -243.5,
                    "y": -17.742
                }, {
                    "x": 243.5,
                    "y": -17.742
                }, {
                    "x": 243.5,
                    "y": 17.742
                }], null, null, null, null, "", 2, 0, 0, 0, "", true],
                [9, 12456.9752, -574.4301, 0, "", "", 181, "Body", "#ffffff", 1, 25, "Karla", "left", null, null, null, null, 0, 0, 0, true],
                [6, 12402.0228, -573.7477, 0, "", "", 182, "#ffffff", "#ffffff", 1, 0, [{
                    "x": 10.6992,
                    "y": -5.1267
                }, {
                    "x": 0,
                    "y": 10.2534
                }, {
                    "x": -10.6992,
                    "y": -5.1267
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [9, 12579.5283, -515.4107, 0, "", "", 183, "10705", "#00efff", 1, 25, "Karla", "left", null, null, null, null, 0, 0, 0, true],
                [9, 12444.0181, -369.41, 0, "", "", 184, "Is Fixed", "#ffffff", 1, 25, "Karla", "left", null, null, null, null, 0, 0, 0, true],
                [9, 12700.1995, -516.1398, 0, "", "", 185, "Y", "#ffffff", 1, 25, "Karla", "left", null, null, null, null, 0, 0, 0, true],
                [9, 12446.6604, -441.2364, 0, "", "", 186, "Rotation", "#ffffff", 1, 25, "Karla", "left", null, null, null, null, 0, 0, 0, true],
                [9, 12414.7195, -518.8825, 0, "", "", 187, "X", "#ffffff", 1, 25, "Karla", "left", null, null, null, null, 0, 0, 0, true],
                [9, 12820.1995, -512.1398, 0, "", "", 188, "214", "#00efff", 1, 25, "Karla", "left", null, null, null, null, 0, 0, 0, true],
                [7, 12821.2902, -278.0297, 0.5236, "", "", 189, [
                    [6, -0.5315, 2.9732, 0, "", "", 400, "#000000", "#000", 1, null, [{
                        "x": -76.396,
                        "y": -5.7186,
                        "point1": {
                            "x": -46.0445,
                            "y": -0.8105
                        },
                        "point2": {
                            "x": -17.8157,
                            "y": -6.128
                        }
                    }, {
                        "x": 12.9262,
                        "y": -5.6321,
                        "point1": {
                            "x": 16.5689,
                            "y": -5.5734
                        },
                        "point2": {
                            "x": 20.0893,
                            "y": -4.1356
                        }
                    }, {
                        "x": 23.7288,
                        "y": -3.9702,
                        "point1": {
                            "x": 52.9054,
                            "y": -2.644
                        },
                        "point2": {
                            "x": 82.7952,
                            "y": -3.1143
                        }
                    }, {
                        "x": 111.8114,
                        "y": -2.3082,
                        "point1": {
                            "x": 121.783,
                            "y": -2.0313
                        },
                        "point2": {
                            "x": 131.7632,
                            "y": -1.9754
                        }
                    }, {
                        "x": 141.7263,
                        "y": -1.4773,
                        "point1": {
                            "x": 145.5993,
                            "y": -1.2836
                        },
                        "point2": {
                            "x": 150.0714,
                            "y": -3.5325
                        }
                    }, {
                        "x": 153.3598,
                        "y": -1.4773,
                        "point1": {
                            "x": 155.1943,
                            "y": -0.3307
                        },
                        "point2": {
                            "x": 150.2788,
                            "y": 1.6519
                        }
                    }, {
                        "x": 148.374,
                        "y": 2.6776,
                        "point1": {
                            "x": 146.5985,
                            "y": 3.6336
                        },
                        "point2": {
                            "x": 144.5708,
                            "y": 4.2307
                        }
                    }, {
                        "x": 142.5572,
                        "y": 4.3395,
                        "point1": {
                            "x": 132.5963,
                            "y": 4.8779
                        },
                        "point2": {
                            "x": 122.6158,
                            "y": 4.9669
                        }
                    }, {
                        "x": 112.6424,
                        "y": 5.1705,
                        "point1": {
                            "x": 81.7926,
                            "y": 5.8001
                        },
                        "point2": {
                            "x": 50.2664,
                            "y": 4.7862
                        }
                    }, {
                        "x": 19.5739,
                        "y": 6.8324,
                        "point1": {
                            "x": -9.8137,
                            "y": 8.7916
                        },
                        "point2": {
                            "x": -56.371,
                            "y": 6.8195
                        }
                    }, {
                        "x": -85.6731,
                        "y": 5.8427,
                        "point1": {
                            "x": -97.7406,
                            "y": 5.4405
                        },
                        "point2": {
                            "x": -85.6388,
                            "y": 19.6952
                        }
                    }, {
                        "x": -97.5992,
                        "y": 18.6079,
                        "point1": {
                            "x": -101.2274,
                            "y": 18.2781
                        },
                        "point2": {
                            "x": -113.0359,
                            "y": 10.1583
                        }
                    }, {
                        "x": -117.0103,
                        "y": 8.4008,
                        "point1": {
                            "x": -118.7836,
                            "y": 7.6166
                        },
                        "point2": {
                            "x": -141.4126,
                            "y": -6.7188
                        }
                    }, {
                        "x": -141.4126,
                        "y": -8.6577,
                        "point1": {
                            "x": -141.4126,
                            "y": -10.7515
                        },
                        "point2": {
                            "x": -94.9839,
                            "y": -24.1173
                        }
                    }, {
                        "x": -93.8001,
                        "y": -24.4461,
                        "point1": {
                            "x": -88.3996,
                            "y": -25.9463
                        },
                        "point2": {
                            "x": -92.0859,
                            "y": -16.0355
                        }
                    }, {
                        "x": -89.8107,
                        "y": -11.0481,
                        "point1": {
                            "x": -88.4967,
                            "y": -8.1676
                        },
                        "point2": {
                            "x": -93.083,
                            "y": -7.569
                        }
                    }, {
                        "x": -89.258,
                        "y": -6.9315,
                        "point1": {
                            "x": -87.0552,
                            "y": -6.5643
                        },
                        "point2": {
                            "x": -84.013,
                            "y": -6.9503
                        }
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, 0.5315, -2.9732, 0, "", "", 401, "#e80000", "#000", 1, null, [{
                        "x": -90.1139,
                        "y": -3.9702,
                        "point1": {
                            "x": -86.5414,
                            "y": -4.6847
                        },
                        "point2": {
                            "x": -82.9541,
                            "y": -5.5734
                        }
                    }, {
                        "x": -79.3113,
                        "y": -5.6321,
                        "point1": {
                            "x": -48.5695,
                            "y": -6.128
                        },
                        "point2": {
                            "x": -17.8157,
                            "y": -6.128
                        }
                    }, {
                        "x": 12.9262,
                        "y": -5.6321,
                        "point1": {
                            "x": 16.5689,
                            "y": -5.5734
                        },
                        "point2": {
                            "x": 20.0893,
                            "y": -4.1356
                        }
                    }, {
                        "x": 23.7288,
                        "y": -3.9702,
                        "point1": {
                            "x": 52.9054,
                            "y": -2.644
                        },
                        "point2": {
                            "x": 82.7952,
                            "y": -3.1143
                        }
                    }, {
                        "x": 111.8114,
                        "y": -2.3082,
                        "point1": {
                            "x": 121.783,
                            "y": -2.0313
                        },
                        "point2": {
                            "x": 131.7632,
                            "y": -1.9754
                        }
                    }, {
                        "x": 141.7263,
                        "y": -1.4773,
                        "point1": {
                            "x": 145.5993,
                            "y": -1.2836
                        },
                        "point2": {
                            "x": 150.0714,
                            "y": -3.5325
                        }
                    }, {
                        "x": 153.3598,
                        "y": -1.4773,
                        "point1": {
                            "x": 155.1943,
                            "y": -0.3307
                        },
                        "point2": {
                            "x": 150.2788,
                            "y": 1.6519
                        }
                    }, {
                        "x": 148.374,
                        "y": 2.6776,
                        "point1": {
                            "x": 146.5985,
                            "y": 3.6336
                        },
                        "point2": {
                            "x": 144.5708,
                            "y": 4.2307
                        }
                    }, {
                        "x": 142.5572,
                        "y": 4.3395,
                        "point1": {
                            "x": 132.5963,
                            "y": 4.8779
                        },
                        "point2": {
                            "x": 122.6158,
                            "y": 4.9669
                        }
                    }, {
                        "x": 112.6424,
                        "y": 5.1705,
                        "point1": {
                            "x": 81.7926,
                            "y": 5.8001
                        },
                        "point2": {
                            "x": 50.2664,
                            "y": 4.7862
                        }
                    }, {
                        "x": 19.5739,
                        "y": 6.8324,
                        "point1": {
                            "x": -9.8137,
                            "y": 8.7916
                        },
                        "point2": {
                            "x": -62.8525,
                            "y": 7.6973
                        }
                    }, {
                        "x": -92.1432,
                        "y": 6.4223,
                        "point1": {
                            "x": -101.6459,
                            "y": 6.0087
                        },
                        "point2": {
                            "x": -89.0926,
                            "y": 18.7366
                        }
                    }, {
                        "x": -101.053,
                        "y": 17.6493,
                        "point1": {
                            "x": -104.6812,
                            "y": 17.3195
                        },
                        "point2": {
                            "x": -116.5157,
                            "y": 10.8862
                        }
                    }, {
                        "x": -120.0228,
                        "y": 9.5431,
                        "point1": {
                            "x": -121.8335,
                            "y": 8.8497
                        },
                        "point2": {
                            "x": -141.0945,
                            "y": -2.4356
                        }
                    }, {
                        "x": -141.0945,
                        "y": -4.3745,
                        "point1": {
                            "x": -141.0945,
                            "y": -6.4683
                        },
                        "point2": {
                            "x": -97.639,
                            "y": -20.6604
                        }
                    }, {
                        "x": -96.4552,
                        "y": -20.9892,
                        "point1": {
                            "x": -91.0547,
                            "y": -22.4894
                        },
                        "point2": {
                            "x": -98.5297,
                            "y": -6.0754
                        }
                    }, {
                        "x": -93.0547,
                        "y": -6.3492,
                        "point1": {
                            "x": -89.1817,
                            "y": -6.5428
                        },
                        "point2": {
                            "x": -87.2912,
                            "y": -5.4387
                        }
                    }, {
                        "x": -83.4662,
                        "y": -4.8012,
                        "point1": {
                            "x": -81.2634,
                            "y": -4.434
                        },
                        "point2": {
                            "x": -92.3037,
                            "y": -3.5322
                        }
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true]
                ], null, null, null, null, 1, 0, 0, 0, true, false, []],
                [9, 12697.0566, -438.803, 0, "", "", 190, "0", "#00efff", 1, 25, "Karla", "left", null, null, null, null, 0, 0, 0, true],
                [6, 13905.4453, -429.775, 0, "", "", 191, "#0aa5d6", "#000000", 1, 0, [{
                    "x": -322.9273,
                    "y": 42.036
                }, {
                    "x": -322.9273,
                    "y": -42.036
                }, {
                    "x": 322.9273,
                    "y": -42.036
                }, {
                    "x": 322.9273,
                    "y": 42.036
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [9, 13878.7214, -431.1384, 0, "", "Tutorial_Titlte_8", 192, "8/10-Non-Static Objects", "#000", 1, 50, "Lily Script One", "left", null, null, null, null, 0, 0, 0, true],
                [6, 15851.4479, -431.4253, 0, "", "", 193, "#0aa5d6", "#000000", 1, 0, [{
                    "x": -322.9273,
                    "y": 42.036
                }, {
                    "x": -322.9273,
                    "y": -42.036
                }, {
                    "x": 322.9273,
                    "y": -42.036
                }, {
                    "x": 322.9273,
                    "y": 42.036
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [9, 15823.406, -434.2295, 0, "", "Tutorial_Titlte_9", 194, "9/10-Add The Finish Line", "#000", 1, 50, "Lily Script One", "left", null, null, null, null, 0, 0, 0, true],
                [7, 16624.9864, -346.4983, 0, "", "", 195, [
                    [6, -0.0049, 108.7963, 0, "", "", 450, "#6b6a6a", "#000000", 1, 0, [{
                        "x": -240.8255,
                        "y": 198.5
                    }, {
                        "x": -240.8255,
                        "y": -198.5
                    }, {
                        "x": 240.8255,
                        "y": -198.5
                    }, {
                        "x": 240.8255,
                        "y": 198.5
                    }], null, null, null, null, "", 2, 0, 0, 0, "", true],
                    [6, 0.0049, -108.7963, 0, "", "", 451, "#3d3d3d", "#000000", 1, 0, [{
                        "x": -243.5,
                        "y": 17.742
                    }, {
                        "x": -243.5,
                        "y": -17.742
                    }, {
                        "x": 243.5,
                        "y": -17.742
                    }, {
                        "x": 243.5,
                        "y": 17.742
                    }], null, null, null, null, "", 2, 0, 0, 0, "", true]
                ], null, null, null, null, 1, 0, 0, 0, true, false, []],
                [9, 16464.872, -455.3432, 0, "", "", 196, "Prefabs", "#ffffff", 1, 25, "Karla", "left", null, null, null, null, 0, 0, 0, true],
                [6, 16401.3784, -459.3426, 0, "", "", 197, "#ffffff", "#ffffff", 1, 0, [{
                    "x": 10.6992,
                    "y": -5.1267
                }, {
                    "x": 0,
                    "y": 10.2534
                }, {
                    "x": -10.6992,
                    "y": -5.1267
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [9, 16490.4999, -412.093, 0, "", "", 198, "Choose Category", "#ffffff", 1, 25, "Karla", "left", null, null, null, null, 0, 0, 0, true],
                [6, 16624.9056, -213.9393, 0, "", "", 199, "#262525", "#000000", 1, 0, [{
                    "x": -237.786,
                    "y": 170.232
                }, {
                    "x": -237.786,
                    "y": -170.232
                }, {
                    "x": 237.786,
                    "y": -170.232
                }, {
                    "x": 237.786,
                    "y": 170.232
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [6, 16744.0992, -409.1407, 0, "", "", 200, "#302d2d", "#cccccc", 1, 0, [{
                    "x": -109,
                    "y": 18.8141
                }, {
                    "x": -109,
                    "y": -18.8141
                }, {
                    "x": 109,
                    "y": -18.8141
                }, {
                    "x": 109,
                    "y": 18.8141
                }], null, null, null, null, "", 1, 0, 0, 0, "", true],
                [6, 16833.151, -412.7025, 0, "", "", 201, "#00ffef", "#ffffff", 1, 0, [{
                    "x": 10.6992,
                    "y": -5.1267
                }, {
                    "x": 0,
                    "y": 10.2534
                }, {
                    "x": -10.6992,
                    "y": -5.1267
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [9, 16672.2482, -409.6945, 0, "", "", 202, "Level", "#ffffff", 1, 25, "Karla", "left", null, null, null, null, 0, 0, 0, true],
                [6, 17765.8399, -417.021, 0, "", "", 203, "#0aa5d6", "#000000", 1, 0, [{
                    "x": -355,
                    "y": 42.036
                }, {
                    "x": -355,
                    "y": -42.036
                }, {
                    "x": 355,
                    "y": -42.036
                }, {
                    "x": 355,
                    "y": 42.036
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [9, 17676.2484, -416.48, 0, "", "Tutorial_Titlte_10", 204, "10/10-Test & Publish!", "#000", 1, 50, "Lily Script One", "left", null, null, null, null, 0, 0, 0, true],
                [9, -604.4336, -376.0178, 0, "", "Tutorial_Text_2", 205, "Learn how to build a level in 10 easy steps!", "#000000", 1, 35, "Lily Script One", "center", null, null, null, null, 0, 0, 0, true],
                [6, 9257.5387, -236.0951, 0, "", "", 206, "#383838", "#000", 1, 0, [{
                    "x": -234.52,
                    "y": 78.729
                }, {
                    "x": -234.52,
                    "y": -78.729
                }, {
                    "x": 234.52,
                    "y": -78.729
                }, {
                    "x": 234.52,
                    "y": 78.729
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [6, 11331.9312, -245.5534, 0, "", "", 207, "#383838", "#000", 1, 0, [{
                    "x": -234.519,
                    "y": 78.729
                }, {
                    "x": -234.519,
                    "y": -78.729
                }, {
                    "x": 234.519,
                    "y": -78.729
                }, {
                    "x": 234.519,
                    "y": 78.729
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [6, 16624.5101, -126.7847, 0, "", "", 208, "#383838", "#000", 1, 0, [{
                    "x": -234.519,
                    "y": 78.729
                }, {
                    "x": -234.519,
                    "y": -78.729
                }, {
                    "x": 234.519,
                    "y": -78.729
                }, {
                    "x": 234.519,
                    "y": 78.729
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [7, 17514.2249, -267.2264, 0, "", "", 209, [
                    [6, -0.6694, -27.2081, 0, "", "", 223, "#999999", "#000", 1, 0, [{
                        "x": -60.6776,
                        "y": 43.9721
                    }, {
                        "x": -47.5733,
                        "y": -43.9721
                    }, {
                        "x": 46.3132,
                        "y": -43.9721
                    }, {
                        "x": 61.9376,
                        "y": 43.9721
                    }], null, null, null, null, "", 2, 0, 0, 0, "", true],
                    [6, 0.6694, 27.2081, 0, "", "", 224, "#707070", "#000", 1, 0, [{
                        "x": -61,
                        "y": 8.481
                    }, {
                        "x": -61,
                        "y": -8.481
                    }, {
                        "x": 61,
                        "y": -8.481
                    }, {
                        "x": 61,
                        "y": 8.481
                    }], null, null, null, null, "", 2, 0, 0, 0, "", true]
                ], null, null, null, null, 1, 0, 0, 0, true, false, []],
                [7, 9264.3732, -268.0561, 0, "", "", 210, [
                    [6, -3.2076, 52.1271, 0, "", "", 299, "#286b11", "#000", 1, 50, [{
                        "x": 0,
                        "y": 0
                    }, {
                        "x": 0,
                        "y": 0
                    }], null, null, null, null, "", 1, 0, 0, 0, "", true],
                    [6, 20.7983, -14.5917, 0, "", "", 300, "#303030", "#000", 1, 0, [{
                        "x": -18.8915,
                        "y": 3.8842
                    }, {
                        "x": -18.8915,
                        "y": -3.8842
                    }, {
                        "x": 18.8915,
                        "y": -3.8842
                    }, {
                        "x": 18.8915,
                        "y": 3.8842
                    }], null, null, null, null, "", 1, 0, 0, 0, "", true],
                    [6, -5.9273, -9.7779, 0, "", "", 301, "#939393", "#000", 1, 0, [{
                        "x": -17.037,
                        "y": 19.191
                    }, {
                        "x": -17.037,
                        "y": -19.191
                    }, {
                        "x": 17.037,
                        "y": -19.191
                    }, {
                        "x": 17.037,
                        "y": 19.191
                    }], null, null, null, null, "", 1, 0, 0, 0, "", true],
                    [6, -51.31, -12.1857, 0, "", "", 302, "#939393", "#000", 1, 0, [{
                        "x": 28.2768,
                        "y": -9.4812
                    }, {
                        "x": 15.9168,
                        "y": -10.2522
                    }, {
                        "x": 4.3278,
                        "y": -17.5932
                    }, {
                        "x": -0.6943,
                        "y": -25.7052
                    }, {
                        "x": -6.1032,
                        "y": -25.3182
                    }, {
                        "x": -9.9643,
                        "y": -6.7752
                    }, {
                        "x": -17.3052,
                        "y": 14.0838
                    }, {
                        "x": -31.5972,
                        "y": 33.0108
                    }, {
                        "x": -25.4172,
                        "y": 37.6458
                    }, {
                        "x": 0.0798,
                        "y": 6.3588
                    }, {
                        "x": 14.3718,
                        "y": 0.1758
                    }, {
                        "x": 28.1088,
                        "y": 3.8508
                    }], null, null, null, null, "", 1, 0, 0, 0, "", true],
                    [6, 39.6466, -15.5718, 0, "", "", 303, "#383838", "#000", 1, 11.248, [{
                        "x": 0,
                        "y": 0
                    }, {
                        "x": 0,
                        "y": 0
                    }], null, null, null, null, "", 2, 0, 0, 0, "", true]
                ], null, null, null, null, 1, 0, 0, 0, true, false, []],
                [6, 9252.1207, -396.9632, 0, "", "", 211, "#ff8900", "#000", 1, 0, [{
                    "x": -49.359,
                    "y": 74
                }, {
                    "x": -49.359,
                    "y": -74
                }, {
                    "x": 49.359,
                    "y": -74
                }, {
                    "x": 49.359,
                    "y": 74
                }], null, null, null, null, "", 1, 0, 0, 0, "", true],
                [6, 9282.9898, -474.9794, 0, "", "", 212, "#ffffff", "#000", 1, 0, [{
                    "x": 9.717,
                    "y": -4.302
                }, {
                    "x": 9.717,
                    "y": 4.302
                }, {
                    "x": -9.717,
                    "y": 4.302
                }, {
                    "x": -9.717,
                    "y": -4.302
                }], null, null, null, null, "", 1, 0, 0, 0, "", true],
                [6, 9282.9891, -482.8935, 0, "", "", 213, "#e50000", "#000", 1, 0, [{
                    "x": 12.02,
                    "y": -4.302
                }, {
                    "x": 12.02,
                    "y": 4.302
                }, {
                    "x": -12.02,
                    "y": 4.302
                }, {
                    "x": -12.02,
                    "y": -4.302
                }], null, null, null, null, "", 1, 0, 0, 0, "", true],
                [6, 8972.4022, -193.8587, -1.0472, "", "", 214, "#000000", "#000", 1, null, [{
                    "x": 58.8222,
                    "y": -222.6198,
                    "point1": {
                        "x": 13.4669,
                        "y": -226.2479
                    },
                    "point2": {
                        "x": -59.4409,
                        "y": -194.8701
                    }
                }, {
                    "x": -81.1491,
                    "y": -158.6897,
                    "point1": {
                        "x": -92.605,
                        "y": -139.5965
                    },
                    "point2": {
                        "x": -105.059,
                        "y": -117.5704
                    }
                }, {
                    "x": -110.1938,
                    "y": -95.3194,
                    "point1": {
                        "x": -125.328,
                        "y": -29.7382
                    },
                    "point2": {
                        "x": -81.9673,
                        "y": 58.3275
                    }
                }, {
                    "x": -36.2619,
                    "y": 104.0328,
                    "point1": {
                        "x": -10.4698,
                        "y": 129.8249
                    },
                    "point2": {
                        "x": 18.8039,
                        "y": 153.9867
                    }
                }, {
                    "x": 54.8329,
                    "y": 162.1222,
                    "point1": {
                        "x": 65.0364,
                        "y": 164.4262
                    },
                    "point2": {
                        "x": 75.0294,
                        "y": 167.5891
                    }
                }, {
                    "x": 85.1978,
                    "y": 170.0435,
                    "point1": {
                        "x": 87.7999,
                        "y": 170.6716
                    },
                    "point2": {
                        "x": 92.2726,
                        "y": 173.9032
                    }
                }, {
                    "x": 93.1191,
                    "y": 171.3637,
                    "point1": {
                        "x": 94.0101,
                        "y": 168.6905
                    },
                    "point2": {
                        "x": 88.9957,
                        "y": 167.425
                    }
                }, {
                    "x": 86.518,
                    "y": 166.0829,
                    "point1": {
                        "x": 70.6881,
                        "y": 157.5084
                    },
                    "point2": {
                        "x": 60.4411,
                        "y": 153.4789
                    }
                }, {
                    "x": 46.9116,
                    "y": 143.6392,
                    "point1": {
                        "x": 18.6228,
                        "y": 123.0656
                    },
                    "point2": {
                        "x": -2.9698,
                        "y": 103.4012
                    }
                }, {
                    "x": -29.6608,
                    "y": 80.269,
                    "point1": {
                        "x": -53.1783,
                        "y": 59.8872
                    },
                    "point2": {
                        "x": -61.5206,
                        "y": 28.2806
                    }
                }, {
                    "x": -72.503,
                    "y": 0.0402,
                    "point1": {
                        "x": -74.9852,
                        "y": -6.3428
                    },
                    "point2": {
                        "x": -76.4214,
                        "y": -14.7394
                    }
                }, {
                    "x": -77.1885,
                    "y": -21.3875,
                    "point1": {
                        "x": -79.9166,
                        "y": -45.0311
                    },
                    "point2": {
                        "x": -81.7025,
                        "y": -68.8849
                    }
                }, {
                    "x": -81.1491,
                    "y": -92.679,
                    "point1": {
                        "x": -80.1435,
                        "y": -135.9196
                    },
                    "point2": {
                        "x": -22.6188,
                        "y": -188.4203
                    }
                }, {
                    "x": 15.9454,
                    "y": -199.6163,
                    "point1": {
                        "x": 40.5167,
                        "y": -206.7499
                    },
                    "point2": {
                        "x": 61.7138,
                        "y": -201.9207
                    }
                }, {
                    "x": 86.518,
                    "y": -204.8972,
                    "point1": {
                        "x": 92.6522,
                        "y": -205.6333
                    },
                    "point2": {
                        "x": 59.2148,
                        "y": -222.5884
                    }
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [6, 9160.7137, -183.507, -0.3491, "", "", 215, "#000000", "#c45757", 1, 0, [{
                    "x": -29.5,
                    "y": -16.3333
                }, {
                    "x": 0,
                    "y": 32.6667
                }, {
                    "x": 29.5,
                    "y": -16.3333
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [6, 8969.0394, -200.2231, -1.0472, "", "", 216, "#ff0000", "#000", 1, null, [{
                    "x": 58.8222,
                    "y": -222.6198,
                    "point1": {
                        "x": 13.4669,
                        "y": -226.2479
                    },
                    "point2": {
                        "x": -59.4409,
                        "y": -194.8701
                    }
                }, {
                    "x": -81.1491,
                    "y": -158.6897,
                    "point1": {
                        "x": -92.605,
                        "y": -139.5965
                    },
                    "point2": {
                        "x": -105.059,
                        "y": -117.5704
                    }
                }, {
                    "x": -110.1938,
                    "y": -95.3194,
                    "point1": {
                        "x": -125.328,
                        "y": -29.7382
                    },
                    "point2": {
                        "x": -81.9673,
                        "y": 58.3275
                    }
                }, {
                    "x": -36.2619,
                    "y": 104.0328,
                    "point1": {
                        "x": -10.4698,
                        "y": 129.8249
                    },
                    "point2": {
                        "x": 18.8039,
                        "y": 153.9867
                    }
                }, {
                    "x": 54.8329,
                    "y": 162.1222,
                    "point1": {
                        "x": 65.0364,
                        "y": 164.4262
                    },
                    "point2": {
                        "x": 75.0294,
                        "y": 167.5891
                    }
                }, {
                    "x": 85.1978,
                    "y": 170.0435,
                    "point1": {
                        "x": 87.7999,
                        "y": 170.6716
                    },
                    "point2": {
                        "x": 92.2726,
                        "y": 173.9032
                    }
                }, {
                    "x": 93.1191,
                    "y": 171.3637,
                    "point1": {
                        "x": 94.0101,
                        "y": 168.6905
                    },
                    "point2": {
                        "x": 88.9957,
                        "y": 167.425
                    }
                }, {
                    "x": 86.518,
                    "y": 166.0829,
                    "point1": {
                        "x": 70.6881,
                        "y": 157.5084
                    },
                    "point2": {
                        "x": 60.4411,
                        "y": 153.4789
                    }
                }, {
                    "x": 46.9116,
                    "y": 143.6392,
                    "point1": {
                        "x": 18.6228,
                        "y": 123.0656
                    },
                    "point2": {
                        "x": -2.9698,
                        "y": 103.4012
                    }
                }, {
                    "x": -29.6608,
                    "y": 80.269,
                    "point1": {
                        "x": -53.1783,
                        "y": 59.8872
                    },
                    "point2": {
                        "x": -61.5206,
                        "y": 28.2806
                    }
                }, {
                    "x": -72.503,
                    "y": 0.0402,
                    "point1": {
                        "x": -74.9852,
                        "y": -6.3428
                    },
                    "point2": {
                        "x": -76.4214,
                        "y": -14.7394
                    }
                }, {
                    "x": -77.1885,
                    "y": -21.3875,
                    "point1": {
                        "x": -79.9166,
                        "y": -45.0311
                    },
                    "point2": {
                        "x": -81.7025,
                        "y": -68.8849
                    }
                }, {
                    "x": -81.1491,
                    "y": -92.679,
                    "point1": {
                        "x": -80.1435,
                        "y": -135.9196
                    },
                    "point2": {
                        "x": -22.6188,
                        "y": -188.4203
                    }
                }, {
                    "x": 15.9454,
                    "y": -199.6163,
                    "point1": {
                        "x": 40.5167,
                        "y": -206.7499
                    },
                    "point2": {
                        "x": 61.7138,
                        "y": -201.9207
                    }
                }, {
                    "x": 86.518,
                    "y": -204.8972,
                    "point1": {
                        "x": 92.6522,
                        "y": -205.6333
                    },
                    "point2": {
                        "x": 59.2148,
                        "y": -222.5884
                    }
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [6, 9158.9275, -190.4793, -0.3491, "", "", 217, "#ff0000", "#c45757", 1, 0, [{
                    "x": -29.5,
                    "y": -16.3333
                }, {
                    "x": 0,
                    "y": 32.6667
                }, {
                    "x": 29.5,
                    "y": -16.3333
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [7, 11337.2818, -419.7561, 0, "", "", 218, [
                    [6, -4.2434, -1.4701, 0, "", "", 307, "#2fa0a0", "#000", 1, 0, [{
                        "x": -171.5,
                        "y": 19.52
                    }, {
                        "x": -171.5,
                        "y": -19.52
                    }, {
                        "x": 171.5,
                        "y": -19.52
                    }, {
                        "x": 171.5,
                        "y": 19.52
                    }], null, null, null, null, "", 1, 0, 0, 0, "", true],
                    [6, -108.1867, -10.3654, 0, "", "", 308, "#020202", "#000", 1, null, [{
                        "x": -9.5,
                        "y": -9.5,
                        "point1": {
                            "x": -9.5,
                            "y": -9.5
                        },
                        "point2": {
                            "x": 9.5,
                            "y": -9.5
                        }
                    }, {
                        "x": 9.5,
                        "y": -9.5,
                        "point1": {
                            "x": 9.5,
                            "y": -9.5
                        },
                        "point2": {
                            "x": 9.5,
                            "y": 9.1948
                        }
                    }, {
                        "x": 9.5,
                        "y": 9.1948,
                        "point1": {
                            "x": 9.5,
                            "y": 9.1948
                        },
                        "point2": {
                            "x": 27.8754,
                            "y": 9.1948
                        }
                    }, {
                        "x": 27.8754,
                        "y": 9.1948,
                        "point1": {
                            "x": 27.8754,
                            "y": 9.1948
                        },
                        "point2": {
                            "x": 27.8754,
                            "y": -9.5347
                        }
                    }, {
                        "x": 27.8754,
                        "y": -9.5347,
                        "point1": {
                            "x": 27.8754,
                            "y": -9.5347
                        },
                        "point2": {
                            "x": 46.8754,
                            "y": -9.5347
                        }
                    }, {
                        "x": 46.8754,
                        "y": -9.5347,
                        "point1": {
                            "x": 46.8754,
                            "y": -9.5347
                        },
                        "point2": {
                            "x": 46.8754,
                            "y": 9.4653
                        }
                    }, {
                        "x": 46.8754,
                        "y": 9.4653,
                        "point1": {
                            "x": 46.8754,
                            "y": 9.4653
                        },
                        "point2": {
                            "x": 27.8799,
                            "y": 9.4653
                        }
                    }, {
                        "x": 27.8799,
                        "y": 9.4653,
                        "point1": {
                            "x": 27.8799,
                            "y": 9.4653
                        },
                        "point2": {
                            "x": 27.8799,
                            "y": 28.1948
                        }
                    }, {
                        "x": 27.8799,
                        "y": 28.1948,
                        "point1": {
                            "x": 27.8799,
                            "y": 28.1948
                        },
                        "point2": {
                            "x": 8.8799,
                            "y": 28.1948
                        }
                    }, {
                        "x": 8.8799,
                        "y": 28.1948,
                        "point1": {
                            "x": 8.8799,
                            "y": 28.1948
                        },
                        "point2": {
                            "x": 8.8799,
                            "y": 9.5
                        }
                    }, {
                        "x": 8.8799,
                        "y": 9.5,
                        "point1": {
                            "x": 8.8799,
                            "y": 9.5
                        },
                        "point2": {
                            "x": -9.4955,
                            "y": 9.5
                        }
                    }, {
                        "x": -9.4955,
                        "y": 9.5,
                        "point1": {
                            "x": -9.4955,
                            "y": 9.5
                        },
                        "point2": {
                            "x": -9.4955,
                            "y": 28.2295
                        }
                    }, {
                        "x": -9.4955,
                        "y": 28.2295,
                        "point1": {
                            "x": -9.4955,
                            "y": 28.2295
                        },
                        "point2": {
                            "x": -28.4955,
                            "y": 28.2295
                        }
                    }, {
                        "x": -28.4955,
                        "y": 28.2295,
                        "point1": {
                            "x": -28.4955,
                            "y": 28.2295
                        },
                        "point2": {
                            "x": -28.4955,
                            "y": 9.5
                        }
                    }, {
                        "x": -28.4955,
                        "y": 9.5,
                        "point1": {
                            "x": -28.4955,
                            "y": 9.5
                        },
                        "point2": {
                            "x": -47.2955,
                            "y": 9.5
                        }
                    }, {
                        "x": -47.2955,
                        "y": 9.5,
                        "point1": {
                            "x": -47.2955,
                            "y": 9.5
                        },
                        "point2": {
                            "x": -47.2955,
                            "y": 28.2295
                        }
                    }, {
                        "x": -47.2955,
                        "y": 28.2295,
                        "point1": {
                            "x": -47.2955,
                            "y": 28.2295
                        },
                        "point2": {
                            "x": -66.2955,
                            "y": 28.2295
                        }
                    }, {
                        "x": -66.2955,
                        "y": 28.2295,
                        "point1": {
                            "x": -66.2955,
                            "y": 28.2295
                        },
                        "point2": {
                            "x": -66.2955,
                            "y": 9.2295
                        }
                    }, {
                        "x": -66.2955,
                        "y": 9.2295,
                        "point1": {
                            "x": -66.2955,
                            "y": 9.2295
                        },
                        "point2": {
                            "x": -47.3,
                            "y": 9.2295
                        }
                    }, {
                        "x": -47.3,
                        "y": 9.2295,
                        "point1": {
                            "x": -47.3,
                            "y": 9.2295
                        },
                        "point2": {
                            "x": -47.3,
                            "y": -9.5
                        }
                    }, {
                        "x": -47.3,
                        "y": -9.5,
                        "point1": {
                            "x": -47.3,
                            "y": -9.5
                        },
                        "point2": {
                            "x": -28.3,
                            "y": -9.5
                        }
                    }, {
                        "x": -28.3,
                        "y": -9.5,
                        "point1": {
                            "x": -28.3,
                            "y": -9.5
                        },
                        "point2": {
                            "x": -28.3,
                            "y": 9.2295
                        }
                    }, {
                        "x": -28.3,
                        "y": 9.2295,
                        "point1": {
                            "x": -28.3,
                            "y": 9.2295
                        },
                        "point2": {
                            "x": -9.5,
                            "y": 9.2295
                        }
                    }, {
                        "x": -9.5,
                        "y": 9.2295,
                        "point1": {
                            "x": -9.5,
                            "y": 9.2295
                        },
                        "point2": {
                            "x": -9.5,
                            "y": -9.5
                        }
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, 5.19, -10.9738, 0, "", "", 309, "#020202", "#000", 1, null, [{
                        "x": -9.5,
                        "y": -9.5,
                        "point1": {
                            "x": -9.5,
                            "y": -9.5
                        },
                        "point2": {
                            "x": 9.5,
                            "y": -9.5
                        }
                    }, {
                        "x": 9.5,
                        "y": -9.5,
                        "point1": {
                            "x": 9.5,
                            "y": -9.5
                        },
                        "point2": {
                            "x": 9.5,
                            "y": 9.1948
                        }
                    }, {
                        "x": 9.5,
                        "y": 9.1948,
                        "point1": {
                            "x": 9.5,
                            "y": 9.1948
                        },
                        "point2": {
                            "x": 27.8754,
                            "y": 9.1948
                        }
                    }, {
                        "x": 27.8754,
                        "y": 9.1948,
                        "point1": {
                            "x": 27.8754,
                            "y": 9.1948
                        },
                        "point2": {
                            "x": 27.8754,
                            "y": -9.5347
                        }
                    }, {
                        "x": 27.8754,
                        "y": -9.5347,
                        "point1": {
                            "x": 27.8754,
                            "y": -9.5347
                        },
                        "point2": {
                            "x": 46.8754,
                            "y": -9.5347
                        }
                    }, {
                        "x": 46.8754,
                        "y": -9.5347,
                        "point1": {
                            "x": 46.8754,
                            "y": -9.5347
                        },
                        "point2": {
                            "x": 46.8754,
                            "y": 9.4653
                        }
                    }, {
                        "x": 46.8754,
                        "y": 9.4653,
                        "point1": {
                            "x": 46.8754,
                            "y": 9.4653
                        },
                        "point2": {
                            "x": 27.8799,
                            "y": 9.4653
                        }
                    }, {
                        "x": 27.8799,
                        "y": 9.4653,
                        "point1": {
                            "x": 27.8799,
                            "y": 9.4653
                        },
                        "point2": {
                            "x": 27.8799,
                            "y": 28.1948
                        }
                    }, {
                        "x": 27.8799,
                        "y": 28.1948,
                        "point1": {
                            "x": 27.8799,
                            "y": 28.1948
                        },
                        "point2": {
                            "x": 8.8799,
                            "y": 28.1948
                        }
                    }, {
                        "x": 8.8799,
                        "y": 28.1948,
                        "point1": {
                            "x": 8.8799,
                            "y": 28.1948
                        },
                        "point2": {
                            "x": 8.8799,
                            "y": 9.5
                        }
                    }, {
                        "x": 8.8799,
                        "y": 9.5,
                        "point1": {
                            "x": 8.8799,
                            "y": 9.5
                        },
                        "point2": {
                            "x": -9.4955,
                            "y": 9.5
                        }
                    }, {
                        "x": -9.4955,
                        "y": 9.5,
                        "point1": {
                            "x": -9.4955,
                            "y": 9.5
                        },
                        "point2": {
                            "x": -9.4955,
                            "y": 28.2295
                        }
                    }, {
                        "x": -9.4955,
                        "y": 28.2295,
                        "point1": {
                            "x": -9.4955,
                            "y": 28.2295
                        },
                        "point2": {
                            "x": -28.4955,
                            "y": 28.2295
                        }
                    }, {
                        "x": -28.4955,
                        "y": 28.2295,
                        "point1": {
                            "x": -28.4955,
                            "y": 28.2295
                        },
                        "point2": {
                            "x": -28.4955,
                            "y": 9.5
                        }
                    }, {
                        "x": -28.4955,
                        "y": 9.5,
                        "point1": {
                            "x": -28.4955,
                            "y": 9.5
                        },
                        "point2": {
                            "x": -47.2955,
                            "y": 9.5
                        }
                    }, {
                        "x": -47.2955,
                        "y": 9.5,
                        "point1": {
                            "x": -47.2955,
                            "y": 9.5
                        },
                        "point2": {
                            "x": -47.2955,
                            "y": 28.2295
                        }
                    }, {
                        "x": -47.2955,
                        "y": 28.2295,
                        "point1": {
                            "x": -47.2955,
                            "y": 28.2295
                        },
                        "point2": {
                            "x": -66.2955,
                            "y": 28.2295
                        }
                    }, {
                        "x": -66.2955,
                        "y": 28.2295,
                        "point1": {
                            "x": -66.2955,
                            "y": 28.2295
                        },
                        "point2": {
                            "x": -66.2955,
                            "y": 9.2295
                        }
                    }, {
                        "x": -66.2955,
                        "y": 9.2295,
                        "point1": {
                            "x": -66.2955,
                            "y": 9.2295
                        },
                        "point2": {
                            "x": -47.3,
                            "y": 9.2295
                        }
                    }, {
                        "x": -47.3,
                        "y": 9.2295,
                        "point1": {
                            "x": -47.3,
                            "y": 9.2295
                        },
                        "point2": {
                            "x": -47.3,
                            "y": -9.5
                        }
                    }, {
                        "x": -47.3,
                        "y": -9.5,
                        "point1": {
                            "x": -47.3,
                            "y": -9.5
                        },
                        "point2": {
                            "x": -28.3,
                            "y": -9.5
                        }
                    }, {
                        "x": -28.3,
                        "y": -9.5,
                        "point1": {
                            "x": -28.3,
                            "y": -9.5
                        },
                        "point2": {
                            "x": -28.3,
                            "y": 9.2295
                        }
                    }, {
                        "x": -28.3,
                        "y": 9.2295,
                        "point1": {
                            "x": -28.3,
                            "y": 9.2295
                        },
                        "point2": {
                            "x": -9.5,
                            "y": 9.2295
                        }
                    }, {
                        "x": -9.5,
                        "y": 9.2295,
                        "point1": {
                            "x": -9.5,
                            "y": 9.2295
                        },
                        "point2": {
                            "x": -9.5,
                            "y": -9.5
                        }
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, 118.1881, -10.687, 0, "", "", 310, "#020202", "#000", 1, null, [{
                        "x": -9.5,
                        "y": -9.5,
                        "point1": {
                            "x": -9.5,
                            "y": -9.5
                        },
                        "point2": {
                            "x": 9.5,
                            "y": -9.5
                        }
                    }, {
                        "x": 9.5,
                        "y": -9.5,
                        "point1": {
                            "x": 9.5,
                            "y": -9.5
                        },
                        "point2": {
                            "x": 9.5,
                            "y": 9.1948
                        }
                    }, {
                        "x": 9.5,
                        "y": 9.1948,
                        "point1": {
                            "x": 9.5,
                            "y": 9.1948
                        },
                        "point2": {
                            "x": 27.8754,
                            "y": 9.1948
                        }
                    }, {
                        "x": 27.8754,
                        "y": 9.1948,
                        "point1": {
                            "x": 27.8754,
                            "y": 9.1948
                        },
                        "point2": {
                            "x": 27.8754,
                            "y": -9.5347
                        }
                    }, {
                        "x": 27.8754,
                        "y": -9.5347,
                        "point1": {
                            "x": 27.8754,
                            "y": -9.5347
                        },
                        "point2": {
                            "x": 46.8754,
                            "y": -9.5347
                        }
                    }, {
                        "x": 46.8754,
                        "y": -9.5347,
                        "point1": {
                            "x": 46.8754,
                            "y": -9.5347
                        },
                        "point2": {
                            "x": 46.8754,
                            "y": 9.4653
                        }
                    }, {
                        "x": 46.8754,
                        "y": 9.4653,
                        "point1": {
                            "x": 46.8754,
                            "y": 9.4653
                        },
                        "point2": {
                            "x": 27.8799,
                            "y": 9.4653
                        }
                    }, {
                        "x": 27.8799,
                        "y": 9.4653,
                        "point1": {
                            "x": 27.8799,
                            "y": 9.4653
                        },
                        "point2": {
                            "x": 27.8799,
                            "y": 28.1948
                        }
                    }, {
                        "x": 27.8799,
                        "y": 28.1948,
                        "point1": {
                            "x": 27.8799,
                            "y": 28.1948
                        },
                        "point2": {
                            "x": 8.8799,
                            "y": 28.1948
                        }
                    }, {
                        "x": 8.8799,
                        "y": 28.1948,
                        "point1": {
                            "x": 8.8799,
                            "y": 28.1948
                        },
                        "point2": {
                            "x": 8.8799,
                            "y": 9.5
                        }
                    }, {
                        "x": 8.8799,
                        "y": 9.5,
                        "point1": {
                            "x": 8.8799,
                            "y": 9.5
                        },
                        "point2": {
                            "x": -9.4955,
                            "y": 9.5
                        }
                    }, {
                        "x": -9.4955,
                        "y": 9.5,
                        "point1": {
                            "x": -9.4955,
                            "y": 9.5
                        },
                        "point2": {
                            "x": -9.4955,
                            "y": 28.2295
                        }
                    }, {
                        "x": -9.4955,
                        "y": 28.2295,
                        "point1": {
                            "x": -9.4955,
                            "y": 28.2295
                        },
                        "point2": {
                            "x": -28.4955,
                            "y": 28.2295
                        }
                    }, {
                        "x": -28.4955,
                        "y": 28.2295,
                        "point1": {
                            "x": -28.4955,
                            "y": 28.2295
                        },
                        "point2": {
                            "x": -28.4955,
                            "y": 9.5
                        }
                    }, {
                        "x": -28.4955,
                        "y": 9.5,
                        "point1": {
                            "x": -28.4955,
                            "y": 9.5
                        },
                        "point2": {
                            "x": -47.2955,
                            "y": 9.5
                        }
                    }, {
                        "x": -47.2955,
                        "y": 9.5,
                        "point1": {
                            "x": -47.2955,
                            "y": 9.5
                        },
                        "point2": {
                            "x": -47.2955,
                            "y": 28.2295
                        }
                    }, {
                        "x": -47.2955,
                        "y": 28.2295,
                        "point1": {
                            "x": -47.2955,
                            "y": 28.2295
                        },
                        "point2": {
                            "x": -66.2955,
                            "y": 28.2295
                        }
                    }, {
                        "x": -66.2955,
                        "y": 28.2295,
                        "point1": {
                            "x": -66.2955,
                            "y": 28.2295
                        },
                        "point2": {
                            "x": -66.2955,
                            "y": 9.2295
                        }
                    }, {
                        "x": -66.2955,
                        "y": 9.2295,
                        "point1": {
                            "x": -66.2955,
                            "y": 9.2295
                        },
                        "point2": {
                            "x": -47.3,
                            "y": 9.2295
                        }
                    }, {
                        "x": -47.3,
                        "y": 9.2295,
                        "point1": {
                            "x": -47.3,
                            "y": 9.2295
                        },
                        "point2": {
                            "x": -47.3,
                            "y": -9.5
                        }
                    }, {
                        "x": -47.3,
                        "y": -9.5,
                        "point1": {
                            "x": -47.3,
                            "y": -9.5
                        },
                        "point2": {
                            "x": -28.3,
                            "y": -9.5
                        }
                    }, {
                        "x": -28.3,
                        "y": -9.5,
                        "point1": {
                            "x": -28.3,
                            "y": -9.5
                        },
                        "point2": {
                            "x": -28.3,
                            "y": 9.2295
                        }
                    }, {
                        "x": -28.3,
                        "y": 9.2295,
                        "point1": {
                            "x": -28.3,
                            "y": 9.2295
                        },
                        "point2": {
                            "x": -9.5,
                            "y": 9.2295
                        }
                    }, {
                        "x": -9.5,
                        "y": 9.2295,
                        "point1": {
                            "x": -9.5,
                            "y": 9.2295
                        },
                        "point2": {
                            "x": -9.5,
                            "y": -9.5
                        }
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, -191.3141, 5.4902, 0, "", "", 311, "#020202", "#000", 1, 0, [{
                        "x": 14.6822,
                        "y": 12.7183
                    }, {
                        "x": 15.5613,
                        "y": -25.4436
                    }, {
                        "x": -30.2435,
                        "y": 12.7253
                    }], null, null, null, null, "", 1, 0, 0, 0, "", true],
                    [6, 183.8474, 5.3939, 0, "", "", 312, "#020202", "#000", 1, 0, [{
                        "x": -14.6822,
                        "y": 12.7183
                    }, {
                        "x": -15.5613,
                        "y": -25.4436
                    }, {
                        "x": 30.2435,
                        "y": 12.7253
                    }], null, null, null, null, "", 1, 0, 0, 0, "", true],
                    [6, -3.4812, 22.6124, 0, "", "", 313, "#918787", "#000", 1, 0, [{
                        "x": -220.0875,
                        "y": 4.5128
                    }, {
                        "x": -220.0875,
                        "y": -4.5128
                    }, {
                        "x": 220.0875,
                        "y": -4.5128
                    }, {
                        "x": 220.0875,
                        "y": 4.5128
                    }], null, null, null, null, "", 1, 0, 0, 0, "", true]
                ], null, null, null, null, 1, 0, 0, 0, true, false, []],
                [7, 11333.7464, -234.3631, 0, "", "", 219, [
                    [6, -4.2434, -1.4701, 0, "", "", 308, "#ffffff", "#000", 1, 0, [{
                        "x": -171.5,
                        "y": 19.52
                    }, {
                        "x": -171.5,
                        "y": -19.52
                    }, {
                        "x": 171.5,
                        "y": -19.52
                    }, {
                        "x": 171.5,
                        "y": 19.52
                    }], null, null, null, null, "", 1, 0, 0, 0, "", true],
                    [6, -108.1867, -10.3654, 0, "", "", 309, "#020202", "#000", 1, null, [{
                        "x": -9.5,
                        "y": -9.5,
                        "point1": {
                            "x": -9.5,
                            "y": -9.5
                        },
                        "point2": {
                            "x": 9.5,
                            "y": -9.5
                        }
                    }, {
                        "x": 9.5,
                        "y": -9.5,
                        "point1": {
                            "x": 9.5,
                            "y": -9.5
                        },
                        "point2": {
                            "x": 9.5,
                            "y": 9.1948
                        }
                    }, {
                        "x": 9.5,
                        "y": 9.1948,
                        "point1": {
                            "x": 9.5,
                            "y": 9.1948
                        },
                        "point2": {
                            "x": 27.8754,
                            "y": 9.1948
                        }
                    }, {
                        "x": 27.8754,
                        "y": 9.1948,
                        "point1": {
                            "x": 27.8754,
                            "y": 9.1948
                        },
                        "point2": {
                            "x": 27.8754,
                            "y": -9.5347
                        }
                    }, {
                        "x": 27.8754,
                        "y": -9.5347,
                        "point1": {
                            "x": 27.8754,
                            "y": -9.5347
                        },
                        "point2": {
                            "x": 46.8754,
                            "y": -9.5347
                        }
                    }, {
                        "x": 46.8754,
                        "y": -9.5347,
                        "point1": {
                            "x": 46.8754,
                            "y": -9.5347
                        },
                        "point2": {
                            "x": 46.8754,
                            "y": 9.4653
                        }
                    }, {
                        "x": 46.8754,
                        "y": 9.4653,
                        "point1": {
                            "x": 46.8754,
                            "y": 9.4653
                        },
                        "point2": {
                            "x": 27.8799,
                            "y": 9.4653
                        }
                    }, {
                        "x": 27.8799,
                        "y": 9.4653,
                        "point1": {
                            "x": 27.8799,
                            "y": 9.4653
                        },
                        "point2": {
                            "x": 27.8799,
                            "y": 28.1948
                        }
                    }, {
                        "x": 27.8799,
                        "y": 28.1948,
                        "point1": {
                            "x": 27.8799,
                            "y": 28.1948
                        },
                        "point2": {
                            "x": 8.8799,
                            "y": 28.1948
                        }
                    }, {
                        "x": 8.8799,
                        "y": 28.1948,
                        "point1": {
                            "x": 8.8799,
                            "y": 28.1948
                        },
                        "point2": {
                            "x": 8.8799,
                            "y": 9.5
                        }
                    }, {
                        "x": 8.8799,
                        "y": 9.5,
                        "point1": {
                            "x": 8.8799,
                            "y": 9.5
                        },
                        "point2": {
                            "x": -9.4955,
                            "y": 9.5
                        }
                    }, {
                        "x": -9.4955,
                        "y": 9.5,
                        "point1": {
                            "x": -9.4955,
                            "y": 9.5
                        },
                        "point2": {
                            "x": -9.4955,
                            "y": 28.2295
                        }
                    }, {
                        "x": -9.4955,
                        "y": 28.2295,
                        "point1": {
                            "x": -9.4955,
                            "y": 28.2295
                        },
                        "point2": {
                            "x": -28.4955,
                            "y": 28.2295
                        }
                    }, {
                        "x": -28.4955,
                        "y": 28.2295,
                        "point1": {
                            "x": -28.4955,
                            "y": 28.2295
                        },
                        "point2": {
                            "x": -28.4955,
                            "y": 9.5
                        }
                    }, {
                        "x": -28.4955,
                        "y": 9.5,
                        "point1": {
                            "x": -28.4955,
                            "y": 9.5
                        },
                        "point2": {
                            "x": -47.2955,
                            "y": 9.5
                        }
                    }, {
                        "x": -47.2955,
                        "y": 9.5,
                        "point1": {
                            "x": -47.2955,
                            "y": 9.5
                        },
                        "point2": {
                            "x": -47.2955,
                            "y": 28.2295
                        }
                    }, {
                        "x": -47.2955,
                        "y": 28.2295,
                        "point1": {
                            "x": -47.2955,
                            "y": 28.2295
                        },
                        "point2": {
                            "x": -66.2955,
                            "y": 28.2295
                        }
                    }, {
                        "x": -66.2955,
                        "y": 28.2295,
                        "point1": {
                            "x": -66.2955,
                            "y": 28.2295
                        },
                        "point2": {
                            "x": -66.2955,
                            "y": 9.2295
                        }
                    }, {
                        "x": -66.2955,
                        "y": 9.2295,
                        "point1": {
                            "x": -66.2955,
                            "y": 9.2295
                        },
                        "point2": {
                            "x": -47.3,
                            "y": 9.2295
                        }
                    }, {
                        "x": -47.3,
                        "y": 9.2295,
                        "point1": {
                            "x": -47.3,
                            "y": 9.2295
                        },
                        "point2": {
                            "x": -47.3,
                            "y": -9.5
                        }
                    }, {
                        "x": -47.3,
                        "y": -9.5,
                        "point1": {
                            "x": -47.3,
                            "y": -9.5
                        },
                        "point2": {
                            "x": -28.3,
                            "y": -9.5
                        }
                    }, {
                        "x": -28.3,
                        "y": -9.5,
                        "point1": {
                            "x": -28.3,
                            "y": -9.5
                        },
                        "point2": {
                            "x": -28.3,
                            "y": 9.2295
                        }
                    }, {
                        "x": -28.3,
                        "y": 9.2295,
                        "point1": {
                            "x": -28.3,
                            "y": 9.2295
                        },
                        "point2": {
                            "x": -9.5,
                            "y": 9.2295
                        }
                    }, {
                        "x": -9.5,
                        "y": 9.2295,
                        "point1": {
                            "x": -9.5,
                            "y": 9.2295
                        },
                        "point2": {
                            "x": -9.5,
                            "y": -9.5
                        }
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, 5.19, -10.9738, 0, "", "", 310, "#020202", "#000", 1, null, [{
                        "x": -9.5,
                        "y": -9.5,
                        "point1": {
                            "x": -9.5,
                            "y": -9.5
                        },
                        "point2": {
                            "x": 9.5,
                            "y": -9.5
                        }
                    }, {
                        "x": 9.5,
                        "y": -9.5,
                        "point1": {
                            "x": 9.5,
                            "y": -9.5
                        },
                        "point2": {
                            "x": 9.5,
                            "y": 9.1948
                        }
                    }, {
                        "x": 9.5,
                        "y": 9.1948,
                        "point1": {
                            "x": 9.5,
                            "y": 9.1948
                        },
                        "point2": {
                            "x": 27.8754,
                            "y": 9.1948
                        }
                    }, {
                        "x": 27.8754,
                        "y": 9.1948,
                        "point1": {
                            "x": 27.8754,
                            "y": 9.1948
                        },
                        "point2": {
                            "x": 27.8754,
                            "y": -9.5347
                        }
                    }, {
                        "x": 27.8754,
                        "y": -9.5347,
                        "point1": {
                            "x": 27.8754,
                            "y": -9.5347
                        },
                        "point2": {
                            "x": 46.8754,
                            "y": -9.5347
                        }
                    }, {
                        "x": 46.8754,
                        "y": -9.5347,
                        "point1": {
                            "x": 46.8754,
                            "y": -9.5347
                        },
                        "point2": {
                            "x": 46.8754,
                            "y": 9.4653
                        }
                    }, {
                        "x": 46.8754,
                        "y": 9.4653,
                        "point1": {
                            "x": 46.8754,
                            "y": 9.4653
                        },
                        "point2": {
                            "x": 27.8799,
                            "y": 9.4653
                        }
                    }, {
                        "x": 27.8799,
                        "y": 9.4653,
                        "point1": {
                            "x": 27.8799,
                            "y": 9.4653
                        },
                        "point2": {
                            "x": 27.8799,
                            "y": 28.1948
                        }
                    }, {
                        "x": 27.8799,
                        "y": 28.1948,
                        "point1": {
                            "x": 27.8799,
                            "y": 28.1948
                        },
                        "point2": {
                            "x": 8.8799,
                            "y": 28.1948
                        }
                    }, {
                        "x": 8.8799,
                        "y": 28.1948,
                        "point1": {
                            "x": 8.8799,
                            "y": 28.1948
                        },
                        "point2": {
                            "x": 8.8799,
                            "y": 9.5
                        }
                    }, {
                        "x": 8.8799,
                        "y": 9.5,
                        "point1": {
                            "x": 8.8799,
                            "y": 9.5
                        },
                        "point2": {
                            "x": -9.4955,
                            "y": 9.5
                        }
                    }, {
                        "x": -9.4955,
                        "y": 9.5,
                        "point1": {
                            "x": -9.4955,
                            "y": 9.5
                        },
                        "point2": {
                            "x": -9.4955,
                            "y": 28.2295
                        }
                    }, {
                        "x": -9.4955,
                        "y": 28.2295,
                        "point1": {
                            "x": -9.4955,
                            "y": 28.2295
                        },
                        "point2": {
                            "x": -28.4955,
                            "y": 28.2295
                        }
                    }, {
                        "x": -28.4955,
                        "y": 28.2295,
                        "point1": {
                            "x": -28.4955,
                            "y": 28.2295
                        },
                        "point2": {
                            "x": -28.4955,
                            "y": 9.5
                        }
                    }, {
                        "x": -28.4955,
                        "y": 9.5,
                        "point1": {
                            "x": -28.4955,
                            "y": 9.5
                        },
                        "point2": {
                            "x": -47.2955,
                            "y": 9.5
                        }
                    }, {
                        "x": -47.2955,
                        "y": 9.5,
                        "point1": {
                            "x": -47.2955,
                            "y": 9.5
                        },
                        "point2": {
                            "x": -47.2955,
                            "y": 28.2295
                        }
                    }, {
                        "x": -47.2955,
                        "y": 28.2295,
                        "point1": {
                            "x": -47.2955,
                            "y": 28.2295
                        },
                        "point2": {
                            "x": -66.2955,
                            "y": 28.2295
                        }
                    }, {
                        "x": -66.2955,
                        "y": 28.2295,
                        "point1": {
                            "x": -66.2955,
                            "y": 28.2295
                        },
                        "point2": {
                            "x": -66.2955,
                            "y": 9.2295
                        }
                    }, {
                        "x": -66.2955,
                        "y": 9.2295,
                        "point1": {
                            "x": -66.2955,
                            "y": 9.2295
                        },
                        "point2": {
                            "x": -47.3,
                            "y": 9.2295
                        }
                    }, {
                        "x": -47.3,
                        "y": 9.2295,
                        "point1": {
                            "x": -47.3,
                            "y": 9.2295
                        },
                        "point2": {
                            "x": -47.3,
                            "y": -9.5
                        }
                    }, {
                        "x": -47.3,
                        "y": -9.5,
                        "point1": {
                            "x": -47.3,
                            "y": -9.5
                        },
                        "point2": {
                            "x": -28.3,
                            "y": -9.5
                        }
                    }, {
                        "x": -28.3,
                        "y": -9.5,
                        "point1": {
                            "x": -28.3,
                            "y": -9.5
                        },
                        "point2": {
                            "x": -28.3,
                            "y": 9.2295
                        }
                    }, {
                        "x": -28.3,
                        "y": 9.2295,
                        "point1": {
                            "x": -28.3,
                            "y": 9.2295
                        },
                        "point2": {
                            "x": -9.5,
                            "y": 9.2295
                        }
                    }, {
                        "x": -9.5,
                        "y": 9.2295,
                        "point1": {
                            "x": -9.5,
                            "y": 9.2295
                        },
                        "point2": {
                            "x": -9.5,
                            "y": -9.5
                        }
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, 118.1881, -10.687, 0, "", "", 311, "#020202", "#000", 1, null, [{
                        "x": -9.5,
                        "y": -9.5,
                        "point1": {
                            "x": -9.5,
                            "y": -9.5
                        },
                        "point2": {
                            "x": 9.5,
                            "y": -9.5
                        }
                    }, {
                        "x": 9.5,
                        "y": -9.5,
                        "point1": {
                            "x": 9.5,
                            "y": -9.5
                        },
                        "point2": {
                            "x": 9.5,
                            "y": 9.1948
                        }
                    }, {
                        "x": 9.5,
                        "y": 9.1948,
                        "point1": {
                            "x": 9.5,
                            "y": 9.1948
                        },
                        "point2": {
                            "x": 27.8754,
                            "y": 9.1948
                        }
                    }, {
                        "x": 27.8754,
                        "y": 9.1948,
                        "point1": {
                            "x": 27.8754,
                            "y": 9.1948
                        },
                        "point2": {
                            "x": 27.8754,
                            "y": -9.5347
                        }
                    }, {
                        "x": 27.8754,
                        "y": -9.5347,
                        "point1": {
                            "x": 27.8754,
                            "y": -9.5347
                        },
                        "point2": {
                            "x": 46.8754,
                            "y": -9.5347
                        }
                    }, {
                        "x": 46.8754,
                        "y": -9.5347,
                        "point1": {
                            "x": 46.8754,
                            "y": -9.5347
                        },
                        "point2": {
                            "x": 46.8754,
                            "y": 9.4653
                        }
                    }, {
                        "x": 46.8754,
                        "y": 9.4653,
                        "point1": {
                            "x": 46.8754,
                            "y": 9.4653
                        },
                        "point2": {
                            "x": 27.8799,
                            "y": 9.4653
                        }
                    }, {
                        "x": 27.8799,
                        "y": 9.4653,
                        "point1": {
                            "x": 27.8799,
                            "y": 9.4653
                        },
                        "point2": {
                            "x": 27.8799,
                            "y": 28.1948
                        }
                    }, {
                        "x": 27.8799,
                        "y": 28.1948,
                        "point1": {
                            "x": 27.8799,
                            "y": 28.1948
                        },
                        "point2": {
                            "x": 8.8799,
                            "y": 28.1948
                        }
                    }, {
                        "x": 8.8799,
                        "y": 28.1948,
                        "point1": {
                            "x": 8.8799,
                            "y": 28.1948
                        },
                        "point2": {
                            "x": 8.8799,
                            "y": 9.5
                        }
                    }, {
                        "x": 8.8799,
                        "y": 9.5,
                        "point1": {
                            "x": 8.8799,
                            "y": 9.5
                        },
                        "point2": {
                            "x": -9.4955,
                            "y": 9.5
                        }
                    }, {
                        "x": -9.4955,
                        "y": 9.5,
                        "point1": {
                            "x": -9.4955,
                            "y": 9.5
                        },
                        "point2": {
                            "x": -9.4955,
                            "y": 28.2295
                        }
                    }, {
                        "x": -9.4955,
                        "y": 28.2295,
                        "point1": {
                            "x": -9.4955,
                            "y": 28.2295
                        },
                        "point2": {
                            "x": -28.4955,
                            "y": 28.2295
                        }
                    }, {
                        "x": -28.4955,
                        "y": 28.2295,
                        "point1": {
                            "x": -28.4955,
                            "y": 28.2295
                        },
                        "point2": {
                            "x": -28.4955,
                            "y": 9.5
                        }
                    }, {
                        "x": -28.4955,
                        "y": 9.5,
                        "point1": {
                            "x": -28.4955,
                            "y": 9.5
                        },
                        "point2": {
                            "x": -47.2955,
                            "y": 9.5
                        }
                    }, {
                        "x": -47.2955,
                        "y": 9.5,
                        "point1": {
                            "x": -47.2955,
                            "y": 9.5
                        },
                        "point2": {
                            "x": -47.2955,
                            "y": 28.2295
                        }
                    }, {
                        "x": -47.2955,
                        "y": 28.2295,
                        "point1": {
                            "x": -47.2955,
                            "y": 28.2295
                        },
                        "point2": {
                            "x": -66.2955,
                            "y": 28.2295
                        }
                    }, {
                        "x": -66.2955,
                        "y": 28.2295,
                        "point1": {
                            "x": -66.2955,
                            "y": 28.2295
                        },
                        "point2": {
                            "x": -66.2955,
                            "y": 9.2295
                        }
                    }, {
                        "x": -66.2955,
                        "y": 9.2295,
                        "point1": {
                            "x": -66.2955,
                            "y": 9.2295
                        },
                        "point2": {
                            "x": -47.3,
                            "y": 9.2295
                        }
                    }, {
                        "x": -47.3,
                        "y": 9.2295,
                        "point1": {
                            "x": -47.3,
                            "y": 9.2295
                        },
                        "point2": {
                            "x": -47.3,
                            "y": -9.5
                        }
                    }, {
                        "x": -47.3,
                        "y": -9.5,
                        "point1": {
                            "x": -47.3,
                            "y": -9.5
                        },
                        "point2": {
                            "x": -28.3,
                            "y": -9.5
                        }
                    }, {
                        "x": -28.3,
                        "y": -9.5,
                        "point1": {
                            "x": -28.3,
                            "y": -9.5
                        },
                        "point2": {
                            "x": -28.3,
                            "y": 9.2295
                        }
                    }, {
                        "x": -28.3,
                        "y": 9.2295,
                        "point1": {
                            "x": -28.3,
                            "y": 9.2295
                        },
                        "point2": {
                            "x": -9.5,
                            "y": 9.2295
                        }
                    }, {
                        "x": -9.5,
                        "y": 9.2295,
                        "point1": {
                            "x": -9.5,
                            "y": 9.2295
                        },
                        "point2": {
                            "x": -9.5,
                            "y": -9.5
                        }
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, -191.3141, 5.4902, 0, "", "", 312, "#020202", "#000", 1, 0, [{
                        "x": 14.6822,
                        "y": 12.7183
                    }, {
                        "x": 15.5613,
                        "y": -25.4436
                    }, {
                        "x": -30.2435,
                        "y": 12.7253
                    }], null, null, null, null, "", 1, 0, 0, 0, "", true],
                    [6, 183.8474, 5.3939, 0, "", "", 313, "#020202", "#000", 1, 0, [{
                        "x": -14.6822,
                        "y": 12.7183
                    }, {
                        "x": -15.5613,
                        "y": -25.4436
                    }, {
                        "x": 30.2435,
                        "y": 12.7253
                    }], null, null, null, null, "", 1, 0, 0, 0, "", true],
                    [6, -3.4812, 22.6124, 0, "", "", 314, "#918787", "#000", 1, 0, [{
                        "x": -220.0875,
                        "y": 4.5128
                    }, {
                        "x": -220.0875,
                        "y": -4.5128
                    }, {
                        "x": 220.0875,
                        "y": -4.5128
                    }, {
                        "x": 220.0875,
                        "y": 4.5128
                    }], null, null, null, null, "", 1, 0, 0, 0, "", true]
                ], null, null, null, null, 1, 0, 0, 0, true, false, []],
                [7, 16627.4815, -296.1313, 0, "", "", 220, [
                    [6, -4.2434, -1.4701, 0, "", "", 307, "#2fa0a0", "#000", 1, 0, [{
                        "x": -171.5,
                        "y": 19.52
                    }, {
                        "x": -171.5,
                        "y": -19.52
                    }, {
                        "x": 171.5,
                        "y": -19.52
                    }, {
                        "x": 171.5,
                        "y": 19.52
                    }], null, null, null, null, "", 1, 0, 0, 0, "", true],
                    [6, -108.1867, -10.3654, 0, "", "", 308, "#020202", "#000", 1, null, [{
                        "x": -9.5,
                        "y": -9.5,
                        "point1": {
                            "x": -9.5,
                            "y": -9.5
                        },
                        "point2": {
                            "x": 9.5,
                            "y": -9.5
                        }
                    }, {
                        "x": 9.5,
                        "y": -9.5,
                        "point1": {
                            "x": 9.5,
                            "y": -9.5
                        },
                        "point2": {
                            "x": 9.5,
                            "y": 9.1948
                        }
                    }, {
                        "x": 9.5,
                        "y": 9.1948,
                        "point1": {
                            "x": 9.5,
                            "y": 9.1948
                        },
                        "point2": {
                            "x": 27.8754,
                            "y": 9.1948
                        }
                    }, {
                        "x": 27.8754,
                        "y": 9.1948,
                        "point1": {
                            "x": 27.8754,
                            "y": 9.1948
                        },
                        "point2": {
                            "x": 27.8754,
                            "y": -9.5347
                        }
                    }, {
                        "x": 27.8754,
                        "y": -9.5347,
                        "point1": {
                            "x": 27.8754,
                            "y": -9.5347
                        },
                        "point2": {
                            "x": 46.8754,
                            "y": -9.5347
                        }
                    }, {
                        "x": 46.8754,
                        "y": -9.5347,
                        "point1": {
                            "x": 46.8754,
                            "y": -9.5347
                        },
                        "point2": {
                            "x": 46.8754,
                            "y": 9.4653
                        }
                    }, {
                        "x": 46.8754,
                        "y": 9.4653,
                        "point1": {
                            "x": 46.8754,
                            "y": 9.4653
                        },
                        "point2": {
                            "x": 27.8799,
                            "y": 9.4653
                        }
                    }, {
                        "x": 27.8799,
                        "y": 9.4653,
                        "point1": {
                            "x": 27.8799,
                            "y": 9.4653
                        },
                        "point2": {
                            "x": 27.8799,
                            "y": 28.1948
                        }
                    }, {
                        "x": 27.8799,
                        "y": 28.1948,
                        "point1": {
                            "x": 27.8799,
                            "y": 28.1948
                        },
                        "point2": {
                            "x": 8.8799,
                            "y": 28.1948
                        }
                    }, {
                        "x": 8.8799,
                        "y": 28.1948,
                        "point1": {
                            "x": 8.8799,
                            "y": 28.1948
                        },
                        "point2": {
                            "x": 8.8799,
                            "y": 9.5
                        }
                    }, {
                        "x": 8.8799,
                        "y": 9.5,
                        "point1": {
                            "x": 8.8799,
                            "y": 9.5
                        },
                        "point2": {
                            "x": -9.4955,
                            "y": 9.5
                        }
                    }, {
                        "x": -9.4955,
                        "y": 9.5,
                        "point1": {
                            "x": -9.4955,
                            "y": 9.5
                        },
                        "point2": {
                            "x": -9.4955,
                            "y": 28.2295
                        }
                    }, {
                        "x": -9.4955,
                        "y": 28.2295,
                        "point1": {
                            "x": -9.4955,
                            "y": 28.2295
                        },
                        "point2": {
                            "x": -28.4955,
                            "y": 28.2295
                        }
                    }, {
                        "x": -28.4955,
                        "y": 28.2295,
                        "point1": {
                            "x": -28.4955,
                            "y": 28.2295
                        },
                        "point2": {
                            "x": -28.4955,
                            "y": 9.5
                        }
                    }, {
                        "x": -28.4955,
                        "y": 9.5,
                        "point1": {
                            "x": -28.4955,
                            "y": 9.5
                        },
                        "point2": {
                            "x": -47.2955,
                            "y": 9.5
                        }
                    }, {
                        "x": -47.2955,
                        "y": 9.5,
                        "point1": {
                            "x": -47.2955,
                            "y": 9.5
                        },
                        "point2": {
                            "x": -47.2955,
                            "y": 28.2295
                        }
                    }, {
                        "x": -47.2955,
                        "y": 28.2295,
                        "point1": {
                            "x": -47.2955,
                            "y": 28.2295
                        },
                        "point2": {
                            "x": -66.2955,
                            "y": 28.2295
                        }
                    }, {
                        "x": -66.2955,
                        "y": 28.2295,
                        "point1": {
                            "x": -66.2955,
                            "y": 28.2295
                        },
                        "point2": {
                            "x": -66.2955,
                            "y": 9.2295
                        }
                    }, {
                        "x": -66.2955,
                        "y": 9.2295,
                        "point1": {
                            "x": -66.2955,
                            "y": 9.2295
                        },
                        "point2": {
                            "x": -47.3,
                            "y": 9.2295
                        }
                    }, {
                        "x": -47.3,
                        "y": 9.2295,
                        "point1": {
                            "x": -47.3,
                            "y": 9.2295
                        },
                        "point2": {
                            "x": -47.3,
                            "y": -9.5
                        }
                    }, {
                        "x": -47.3,
                        "y": -9.5,
                        "point1": {
                            "x": -47.3,
                            "y": -9.5
                        },
                        "point2": {
                            "x": -28.3,
                            "y": -9.5
                        }
                    }, {
                        "x": -28.3,
                        "y": -9.5,
                        "point1": {
                            "x": -28.3,
                            "y": -9.5
                        },
                        "point2": {
                            "x": -28.3,
                            "y": 9.2295
                        }
                    }, {
                        "x": -28.3,
                        "y": 9.2295,
                        "point1": {
                            "x": -28.3,
                            "y": 9.2295
                        },
                        "point2": {
                            "x": -9.5,
                            "y": 9.2295
                        }
                    }, {
                        "x": -9.5,
                        "y": 9.2295,
                        "point1": {
                            "x": -9.5,
                            "y": 9.2295
                        },
                        "point2": {
                            "x": -9.5,
                            "y": -9.5
                        }
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, 5.19, -10.9738, 0, "", "", 309, "#020202", "#000", 1, null, [{
                        "x": -9.5,
                        "y": -9.5,
                        "point1": {
                            "x": -9.5,
                            "y": -9.5
                        },
                        "point2": {
                            "x": 9.5,
                            "y": -9.5
                        }
                    }, {
                        "x": 9.5,
                        "y": -9.5,
                        "point1": {
                            "x": 9.5,
                            "y": -9.5
                        },
                        "point2": {
                            "x": 9.5,
                            "y": 9.1948
                        }
                    }, {
                        "x": 9.5,
                        "y": 9.1948,
                        "point1": {
                            "x": 9.5,
                            "y": 9.1948
                        },
                        "point2": {
                            "x": 27.8754,
                            "y": 9.1948
                        }
                    }, {
                        "x": 27.8754,
                        "y": 9.1948,
                        "point1": {
                            "x": 27.8754,
                            "y": 9.1948
                        },
                        "point2": {
                            "x": 27.8754,
                            "y": -9.5347
                        }
                    }, {
                        "x": 27.8754,
                        "y": -9.5347,
                        "point1": {
                            "x": 27.8754,
                            "y": -9.5347
                        },
                        "point2": {
                            "x": 46.8754,
                            "y": -9.5347
                        }
                    }, {
                        "x": 46.8754,
                        "y": -9.5347,
                        "point1": {
                            "x": 46.8754,
                            "y": -9.5347
                        },
                        "point2": {
                            "x": 46.8754,
                            "y": 9.4653
                        }
                    }, {
                        "x": 46.8754,
                        "y": 9.4653,
                        "point1": {
                            "x": 46.8754,
                            "y": 9.4653
                        },
                        "point2": {
                            "x": 27.8799,
                            "y": 9.4653
                        }
                    }, {
                        "x": 27.8799,
                        "y": 9.4653,
                        "point1": {
                            "x": 27.8799,
                            "y": 9.4653
                        },
                        "point2": {
                            "x": 27.8799,
                            "y": 28.1948
                        }
                    }, {
                        "x": 27.8799,
                        "y": 28.1948,
                        "point1": {
                            "x": 27.8799,
                            "y": 28.1948
                        },
                        "point2": {
                            "x": 8.8799,
                            "y": 28.1948
                        }
                    }, {
                        "x": 8.8799,
                        "y": 28.1948,
                        "point1": {
                            "x": 8.8799,
                            "y": 28.1948
                        },
                        "point2": {
                            "x": 8.8799,
                            "y": 9.5
                        }
                    }, {
                        "x": 8.8799,
                        "y": 9.5,
                        "point1": {
                            "x": 8.8799,
                            "y": 9.5
                        },
                        "point2": {
                            "x": -9.4955,
                            "y": 9.5
                        }
                    }, {
                        "x": -9.4955,
                        "y": 9.5,
                        "point1": {
                            "x": -9.4955,
                            "y": 9.5
                        },
                        "point2": {
                            "x": -9.4955,
                            "y": 28.2295
                        }
                    }, {
                        "x": -9.4955,
                        "y": 28.2295,
                        "point1": {
                            "x": -9.4955,
                            "y": 28.2295
                        },
                        "point2": {
                            "x": -28.4955,
                            "y": 28.2295
                        }
                    }, {
                        "x": -28.4955,
                        "y": 28.2295,
                        "point1": {
                            "x": -28.4955,
                            "y": 28.2295
                        },
                        "point2": {
                            "x": -28.4955,
                            "y": 9.5
                        }
                    }, {
                        "x": -28.4955,
                        "y": 9.5,
                        "point1": {
                            "x": -28.4955,
                            "y": 9.5
                        },
                        "point2": {
                            "x": -47.2955,
                            "y": 9.5
                        }
                    }, {
                        "x": -47.2955,
                        "y": 9.5,
                        "point1": {
                            "x": -47.2955,
                            "y": 9.5
                        },
                        "point2": {
                            "x": -47.2955,
                            "y": 28.2295
                        }
                    }, {
                        "x": -47.2955,
                        "y": 28.2295,
                        "point1": {
                            "x": -47.2955,
                            "y": 28.2295
                        },
                        "point2": {
                            "x": -66.2955,
                            "y": 28.2295
                        }
                    }, {
                        "x": -66.2955,
                        "y": 28.2295,
                        "point1": {
                            "x": -66.2955,
                            "y": 28.2295
                        },
                        "point2": {
                            "x": -66.2955,
                            "y": 9.2295
                        }
                    }, {
                        "x": -66.2955,
                        "y": 9.2295,
                        "point1": {
                            "x": -66.2955,
                            "y": 9.2295
                        },
                        "point2": {
                            "x": -47.3,
                            "y": 9.2295
                        }
                    }, {
                        "x": -47.3,
                        "y": 9.2295,
                        "point1": {
                            "x": -47.3,
                            "y": 9.2295
                        },
                        "point2": {
                            "x": -47.3,
                            "y": -9.5
                        }
                    }, {
                        "x": -47.3,
                        "y": -9.5,
                        "point1": {
                            "x": -47.3,
                            "y": -9.5
                        },
                        "point2": {
                            "x": -28.3,
                            "y": -9.5
                        }
                    }, {
                        "x": -28.3,
                        "y": -9.5,
                        "point1": {
                            "x": -28.3,
                            "y": -9.5
                        },
                        "point2": {
                            "x": -28.3,
                            "y": 9.2295
                        }
                    }, {
                        "x": -28.3,
                        "y": 9.2295,
                        "point1": {
                            "x": -28.3,
                            "y": 9.2295
                        },
                        "point2": {
                            "x": -9.5,
                            "y": 9.2295
                        }
                    }, {
                        "x": -9.5,
                        "y": 9.2295,
                        "point1": {
                            "x": -9.5,
                            "y": 9.2295
                        },
                        "point2": {
                            "x": -9.5,
                            "y": -9.5
                        }
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, 118.1881, -10.687, 0, "", "", 310, "#020202", "#000", 1, null, [{
                        "x": -9.5,
                        "y": -9.5,
                        "point1": {
                            "x": -9.5,
                            "y": -9.5
                        },
                        "point2": {
                            "x": 9.5,
                            "y": -9.5
                        }
                    }, {
                        "x": 9.5,
                        "y": -9.5,
                        "point1": {
                            "x": 9.5,
                            "y": -9.5
                        },
                        "point2": {
                            "x": 9.5,
                            "y": 9.1948
                        }
                    }, {
                        "x": 9.5,
                        "y": 9.1948,
                        "point1": {
                            "x": 9.5,
                            "y": 9.1948
                        },
                        "point2": {
                            "x": 27.8754,
                            "y": 9.1948
                        }
                    }, {
                        "x": 27.8754,
                        "y": 9.1948,
                        "point1": {
                            "x": 27.8754,
                            "y": 9.1948
                        },
                        "point2": {
                            "x": 27.8754,
                            "y": -9.5347
                        }
                    }, {
                        "x": 27.8754,
                        "y": -9.5347,
                        "point1": {
                            "x": 27.8754,
                            "y": -9.5347
                        },
                        "point2": {
                            "x": 46.8754,
                            "y": -9.5347
                        }
                    }, {
                        "x": 46.8754,
                        "y": -9.5347,
                        "point1": {
                            "x": 46.8754,
                            "y": -9.5347
                        },
                        "point2": {
                            "x": 46.8754,
                            "y": 9.4653
                        }
                    }, {
                        "x": 46.8754,
                        "y": 9.4653,
                        "point1": {
                            "x": 46.8754,
                            "y": 9.4653
                        },
                        "point2": {
                            "x": 27.8799,
                            "y": 9.4653
                        }
                    }, {
                        "x": 27.8799,
                        "y": 9.4653,
                        "point1": {
                            "x": 27.8799,
                            "y": 9.4653
                        },
                        "point2": {
                            "x": 27.8799,
                            "y": 28.1948
                        }
                    }, {
                        "x": 27.8799,
                        "y": 28.1948,
                        "point1": {
                            "x": 27.8799,
                            "y": 28.1948
                        },
                        "point2": {
                            "x": 8.8799,
                            "y": 28.1948
                        }
                    }, {
                        "x": 8.8799,
                        "y": 28.1948,
                        "point1": {
                            "x": 8.8799,
                            "y": 28.1948
                        },
                        "point2": {
                            "x": 8.8799,
                            "y": 9.5
                        }
                    }, {
                        "x": 8.8799,
                        "y": 9.5,
                        "point1": {
                            "x": 8.8799,
                            "y": 9.5
                        },
                        "point2": {
                            "x": -9.4955,
                            "y": 9.5
                        }
                    }, {
                        "x": -9.4955,
                        "y": 9.5,
                        "point1": {
                            "x": -9.4955,
                            "y": 9.5
                        },
                        "point2": {
                            "x": -9.4955,
                            "y": 28.2295
                        }
                    }, {
                        "x": -9.4955,
                        "y": 28.2295,
                        "point1": {
                            "x": -9.4955,
                            "y": 28.2295
                        },
                        "point2": {
                            "x": -28.4955,
                            "y": 28.2295
                        }
                    }, {
                        "x": -28.4955,
                        "y": 28.2295,
                        "point1": {
                            "x": -28.4955,
                            "y": 28.2295
                        },
                        "point2": {
                            "x": -28.4955,
                            "y": 9.5
                        }
                    }, {
                        "x": -28.4955,
                        "y": 9.5,
                        "point1": {
                            "x": -28.4955,
                            "y": 9.5
                        },
                        "point2": {
                            "x": -47.2955,
                            "y": 9.5
                        }
                    }, {
                        "x": -47.2955,
                        "y": 9.5,
                        "point1": {
                            "x": -47.2955,
                            "y": 9.5
                        },
                        "point2": {
                            "x": -47.2955,
                            "y": 28.2295
                        }
                    }, {
                        "x": -47.2955,
                        "y": 28.2295,
                        "point1": {
                            "x": -47.2955,
                            "y": 28.2295
                        },
                        "point2": {
                            "x": -66.2955,
                            "y": 28.2295
                        }
                    }, {
                        "x": -66.2955,
                        "y": 28.2295,
                        "point1": {
                            "x": -66.2955,
                            "y": 28.2295
                        },
                        "point2": {
                            "x": -66.2955,
                            "y": 9.2295
                        }
                    }, {
                        "x": -66.2955,
                        "y": 9.2295,
                        "point1": {
                            "x": -66.2955,
                            "y": 9.2295
                        },
                        "point2": {
                            "x": -47.3,
                            "y": 9.2295
                        }
                    }, {
                        "x": -47.3,
                        "y": 9.2295,
                        "point1": {
                            "x": -47.3,
                            "y": 9.2295
                        },
                        "point2": {
                            "x": -47.3,
                            "y": -9.5
                        }
                    }, {
                        "x": -47.3,
                        "y": -9.5,
                        "point1": {
                            "x": -47.3,
                            "y": -9.5
                        },
                        "point2": {
                            "x": -28.3,
                            "y": -9.5
                        }
                    }, {
                        "x": -28.3,
                        "y": -9.5,
                        "point1": {
                            "x": -28.3,
                            "y": -9.5
                        },
                        "point2": {
                            "x": -28.3,
                            "y": 9.2295
                        }
                    }, {
                        "x": -28.3,
                        "y": 9.2295,
                        "point1": {
                            "x": -28.3,
                            "y": 9.2295
                        },
                        "point2": {
                            "x": -9.5,
                            "y": 9.2295
                        }
                    }, {
                        "x": -9.5,
                        "y": 9.2295,
                        "point1": {
                            "x": -9.5,
                            "y": 9.2295
                        },
                        "point2": {
                            "x": -9.5,
                            "y": -9.5
                        }
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, -191.3141, 5.4902, 0, "", "", 311, "#020202", "#000", 1, 0, [{
                        "x": 14.6822,
                        "y": 12.7183
                    }, {
                        "x": 15.5613,
                        "y": -25.4436
                    }, {
                        "x": -30.2435,
                        "y": 12.7253
                    }], null, null, null, null, "", 1, 0, 0, 0, "", true],
                    [6, 183.8474, 5.3939, 0, "", "", 312, "#020202", "#000", 1, 0, [{
                        "x": -14.6822,
                        "y": 12.7183
                    }, {
                        "x": -15.5613,
                        "y": -25.4436
                    }, {
                        "x": 30.2435,
                        "y": 12.7253
                    }], null, null, null, null, "", 1, 0, 0, 0, "", true],
                    [6, -3.4812, 22.6124, 0, "", "", 313, "#918787", "#000", 1, 0, [{
                        "x": -220.0875,
                        "y": 4.5128
                    }, {
                        "x": -220.0875,
                        "y": -4.5128
                    }, {
                        "x": 220.0875,
                        "y": -4.5128
                    }, {
                        "x": 220.0875,
                        "y": 4.5128
                    }], null, null, null, null, "", 1, 0, 0, 0, "", true]
                ], null, null, null, null, 1, 0, 0, 0, true, false, []],
                [7, 16623.9461, -110.7383, 0, "", "", 221, [
                    [6, -4.2434, -1.4701, 0, "", "", 308, "#ffffff", "#000", 1, 0, [{
                        "x": -171.5,
                        "y": 19.52
                    }, {
                        "x": -171.5,
                        "y": -19.52
                    }, {
                        "x": 171.5,
                        "y": -19.52
                    }, {
                        "x": 171.5,
                        "y": 19.52
                    }], null, null, null, null, "", 1, 0, 0, 0, "", true],
                    [6, -108.1867, -10.3654, 0, "", "", 309, "#020202", "#000", 1, null, [{
                        "x": -9.5,
                        "y": -9.5,
                        "point1": {
                            "x": -9.5,
                            "y": -9.5
                        },
                        "point2": {
                            "x": 9.5,
                            "y": -9.5
                        }
                    }, {
                        "x": 9.5,
                        "y": -9.5,
                        "point1": {
                            "x": 9.5,
                            "y": -9.5
                        },
                        "point2": {
                            "x": 9.5,
                            "y": 9.1948
                        }
                    }, {
                        "x": 9.5,
                        "y": 9.1948,
                        "point1": {
                            "x": 9.5,
                            "y": 9.1948
                        },
                        "point2": {
                            "x": 27.8754,
                            "y": 9.1948
                        }
                    }, {
                        "x": 27.8754,
                        "y": 9.1948,
                        "point1": {
                            "x": 27.8754,
                            "y": 9.1948
                        },
                        "point2": {
                            "x": 27.8754,
                            "y": -9.5347
                        }
                    }, {
                        "x": 27.8754,
                        "y": -9.5347,
                        "point1": {
                            "x": 27.8754,
                            "y": -9.5347
                        },
                        "point2": {
                            "x": 46.8754,
                            "y": -9.5347
                        }
                    }, {
                        "x": 46.8754,
                        "y": -9.5347,
                        "point1": {
                            "x": 46.8754,
                            "y": -9.5347
                        },
                        "point2": {
                            "x": 46.8754,
                            "y": 9.4653
                        }
                    }, {
                        "x": 46.8754,
                        "y": 9.4653,
                        "point1": {
                            "x": 46.8754,
                            "y": 9.4653
                        },
                        "point2": {
                            "x": 27.8799,
                            "y": 9.4653
                        }
                    }, {
                        "x": 27.8799,
                        "y": 9.4653,
                        "point1": {
                            "x": 27.8799,
                            "y": 9.4653
                        },
                        "point2": {
                            "x": 27.8799,
                            "y": 28.1948
                        }
                    }, {
                        "x": 27.8799,
                        "y": 28.1948,
                        "point1": {
                            "x": 27.8799,
                            "y": 28.1948
                        },
                        "point2": {
                            "x": 8.8799,
                            "y": 28.1948
                        }
                    }, {
                        "x": 8.8799,
                        "y": 28.1948,
                        "point1": {
                            "x": 8.8799,
                            "y": 28.1948
                        },
                        "point2": {
                            "x": 8.8799,
                            "y": 9.5
                        }
                    }, {
                        "x": 8.8799,
                        "y": 9.5,
                        "point1": {
                            "x": 8.8799,
                            "y": 9.5
                        },
                        "point2": {
                            "x": -9.4955,
                            "y": 9.5
                        }
                    }, {
                        "x": -9.4955,
                        "y": 9.5,
                        "point1": {
                            "x": -9.4955,
                            "y": 9.5
                        },
                        "point2": {
                            "x": -9.4955,
                            "y": 28.2295
                        }
                    }, {
                        "x": -9.4955,
                        "y": 28.2295,
                        "point1": {
                            "x": -9.4955,
                            "y": 28.2295
                        },
                        "point2": {
                            "x": -28.4955,
                            "y": 28.2295
                        }
                    }, {
                        "x": -28.4955,
                        "y": 28.2295,
                        "point1": {
                            "x": -28.4955,
                            "y": 28.2295
                        },
                        "point2": {
                            "x": -28.4955,
                            "y": 9.5
                        }
                    }, {
                        "x": -28.4955,
                        "y": 9.5,
                        "point1": {
                            "x": -28.4955,
                            "y": 9.5
                        },
                        "point2": {
                            "x": -47.2955,
                            "y": 9.5
                        }
                    }, {
                        "x": -47.2955,
                        "y": 9.5,
                        "point1": {
                            "x": -47.2955,
                            "y": 9.5
                        },
                        "point2": {
                            "x": -47.2955,
                            "y": 28.2295
                        }
                    }, {
                        "x": -47.2955,
                        "y": 28.2295,
                        "point1": {
                            "x": -47.2955,
                            "y": 28.2295
                        },
                        "point2": {
                            "x": -66.2955,
                            "y": 28.2295
                        }
                    }, {
                        "x": -66.2955,
                        "y": 28.2295,
                        "point1": {
                            "x": -66.2955,
                            "y": 28.2295
                        },
                        "point2": {
                            "x": -66.2955,
                            "y": 9.2295
                        }
                    }, {
                        "x": -66.2955,
                        "y": 9.2295,
                        "point1": {
                            "x": -66.2955,
                            "y": 9.2295
                        },
                        "point2": {
                            "x": -47.3,
                            "y": 9.2295
                        }
                    }, {
                        "x": -47.3,
                        "y": 9.2295,
                        "point1": {
                            "x": -47.3,
                            "y": 9.2295
                        },
                        "point2": {
                            "x": -47.3,
                            "y": -9.5
                        }
                    }, {
                        "x": -47.3,
                        "y": -9.5,
                        "point1": {
                            "x": -47.3,
                            "y": -9.5
                        },
                        "point2": {
                            "x": -28.3,
                            "y": -9.5
                        }
                    }, {
                        "x": -28.3,
                        "y": -9.5,
                        "point1": {
                            "x": -28.3,
                            "y": -9.5
                        },
                        "point2": {
                            "x": -28.3,
                            "y": 9.2295
                        }
                    }, {
                        "x": -28.3,
                        "y": 9.2295,
                        "point1": {
                            "x": -28.3,
                            "y": 9.2295
                        },
                        "point2": {
                            "x": -9.5,
                            "y": 9.2295
                        }
                    }, {
                        "x": -9.5,
                        "y": 9.2295,
                        "point1": {
                            "x": -9.5,
                            "y": 9.2295
                        },
                        "point2": {
                            "x": -9.5,
                            "y": -9.5
                        }
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, 5.19, -10.9738, 0, "", "", 310, "#020202", "#000", 1, null, [{
                        "x": -9.5,
                        "y": -9.5,
                        "point1": {
                            "x": -9.5,
                            "y": -9.5
                        },
                        "point2": {
                            "x": 9.5,
                            "y": -9.5
                        }
                    }, {
                        "x": 9.5,
                        "y": -9.5,
                        "point1": {
                            "x": 9.5,
                            "y": -9.5
                        },
                        "point2": {
                            "x": 9.5,
                            "y": 9.1948
                        }
                    }, {
                        "x": 9.5,
                        "y": 9.1948,
                        "point1": {
                            "x": 9.5,
                            "y": 9.1948
                        },
                        "point2": {
                            "x": 27.8754,
                            "y": 9.1948
                        }
                    }, {
                        "x": 27.8754,
                        "y": 9.1948,
                        "point1": {
                            "x": 27.8754,
                            "y": 9.1948
                        },
                        "point2": {
                            "x": 27.8754,
                            "y": -9.5347
                        }
                    }, {
                        "x": 27.8754,
                        "y": -9.5347,
                        "point1": {
                            "x": 27.8754,
                            "y": -9.5347
                        },
                        "point2": {
                            "x": 46.8754,
                            "y": -9.5347
                        }
                    }, {
                        "x": 46.8754,
                        "y": -9.5347,
                        "point1": {
                            "x": 46.8754,
                            "y": -9.5347
                        },
                        "point2": {
                            "x": 46.8754,
                            "y": 9.4653
                        }
                    }, {
                        "x": 46.8754,
                        "y": 9.4653,
                        "point1": {
                            "x": 46.8754,
                            "y": 9.4653
                        },
                        "point2": {
                            "x": 27.8799,
                            "y": 9.4653
                        }
                    }, {
                        "x": 27.8799,
                        "y": 9.4653,
                        "point1": {
                            "x": 27.8799,
                            "y": 9.4653
                        },
                        "point2": {
                            "x": 27.8799,
                            "y": 28.1948
                        }
                    }, {
                        "x": 27.8799,
                        "y": 28.1948,
                        "point1": {
                            "x": 27.8799,
                            "y": 28.1948
                        },
                        "point2": {
                            "x": 8.8799,
                            "y": 28.1948
                        }
                    }, {
                        "x": 8.8799,
                        "y": 28.1948,
                        "point1": {
                            "x": 8.8799,
                            "y": 28.1948
                        },
                        "point2": {
                            "x": 8.8799,
                            "y": 9.5
                        }
                    }, {
                        "x": 8.8799,
                        "y": 9.5,
                        "point1": {
                            "x": 8.8799,
                            "y": 9.5
                        },
                        "point2": {
                            "x": -9.4955,
                            "y": 9.5
                        }
                    }, {
                        "x": -9.4955,
                        "y": 9.5,
                        "point1": {
                            "x": -9.4955,
                            "y": 9.5
                        },
                        "point2": {
                            "x": -9.4955,
                            "y": 28.2295
                        }
                    }, {
                        "x": -9.4955,
                        "y": 28.2295,
                        "point1": {
                            "x": -9.4955,
                            "y": 28.2295
                        },
                        "point2": {
                            "x": -28.4955,
                            "y": 28.2295
                        }
                    }, {
                        "x": -28.4955,
                        "y": 28.2295,
                        "point1": {
                            "x": -28.4955,
                            "y": 28.2295
                        },
                        "point2": {
                            "x": -28.4955,
                            "y": 9.5
                        }
                    }, {
                        "x": -28.4955,
                        "y": 9.5,
                        "point1": {
                            "x": -28.4955,
                            "y": 9.5
                        },
                        "point2": {
                            "x": -47.2955,
                            "y": 9.5
                        }
                    }, {
                        "x": -47.2955,
                        "y": 9.5,
                        "point1": {
                            "x": -47.2955,
                            "y": 9.5
                        },
                        "point2": {
                            "x": -47.2955,
                            "y": 28.2295
                        }
                    }, {
                        "x": -47.2955,
                        "y": 28.2295,
                        "point1": {
                            "x": -47.2955,
                            "y": 28.2295
                        },
                        "point2": {
                            "x": -66.2955,
                            "y": 28.2295
                        }
                    }, {
                        "x": -66.2955,
                        "y": 28.2295,
                        "point1": {
                            "x": -66.2955,
                            "y": 28.2295
                        },
                        "point2": {
                            "x": -66.2955,
                            "y": 9.2295
                        }
                    }, {
                        "x": -66.2955,
                        "y": 9.2295,
                        "point1": {
                            "x": -66.2955,
                            "y": 9.2295
                        },
                        "point2": {
                            "x": -47.3,
                            "y": 9.2295
                        }
                    }, {
                        "x": -47.3,
                        "y": 9.2295,
                        "point1": {
                            "x": -47.3,
                            "y": 9.2295
                        },
                        "point2": {
                            "x": -47.3,
                            "y": -9.5
                        }
                    }, {
                        "x": -47.3,
                        "y": -9.5,
                        "point1": {
                            "x": -47.3,
                            "y": -9.5
                        },
                        "point2": {
                            "x": -28.3,
                            "y": -9.5
                        }
                    }, {
                        "x": -28.3,
                        "y": -9.5,
                        "point1": {
                            "x": -28.3,
                            "y": -9.5
                        },
                        "point2": {
                            "x": -28.3,
                            "y": 9.2295
                        }
                    }, {
                        "x": -28.3,
                        "y": 9.2295,
                        "point1": {
                            "x": -28.3,
                            "y": 9.2295
                        },
                        "point2": {
                            "x": -9.5,
                            "y": 9.2295
                        }
                    }, {
                        "x": -9.5,
                        "y": 9.2295,
                        "point1": {
                            "x": -9.5,
                            "y": 9.2295
                        },
                        "point2": {
                            "x": -9.5,
                            "y": -9.5
                        }
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, 118.1881, -10.687, 0, "", "", 311, "#020202", "#000", 1, null, [{
                        "x": -9.5,
                        "y": -9.5,
                        "point1": {
                            "x": -9.5,
                            "y": -9.5
                        },
                        "point2": {
                            "x": 9.5,
                            "y": -9.5
                        }
                    }, {
                        "x": 9.5,
                        "y": -9.5,
                        "point1": {
                            "x": 9.5,
                            "y": -9.5
                        },
                        "point2": {
                            "x": 9.5,
                            "y": 9.1948
                        }
                    }, {
                        "x": 9.5,
                        "y": 9.1948,
                        "point1": {
                            "x": 9.5,
                            "y": 9.1948
                        },
                        "point2": {
                            "x": 27.8754,
                            "y": 9.1948
                        }
                    }, {
                        "x": 27.8754,
                        "y": 9.1948,
                        "point1": {
                            "x": 27.8754,
                            "y": 9.1948
                        },
                        "point2": {
                            "x": 27.8754,
                            "y": -9.5347
                        }
                    }, {
                        "x": 27.8754,
                        "y": -9.5347,
                        "point1": {
                            "x": 27.8754,
                            "y": -9.5347
                        },
                        "point2": {
                            "x": 46.8754,
                            "y": -9.5347
                        }
                    }, {
                        "x": 46.8754,
                        "y": -9.5347,
                        "point1": {
                            "x": 46.8754,
                            "y": -9.5347
                        },
                        "point2": {
                            "x": 46.8754,
                            "y": 9.4653
                        }
                    }, {
                        "x": 46.8754,
                        "y": 9.4653,
                        "point1": {
                            "x": 46.8754,
                            "y": 9.4653
                        },
                        "point2": {
                            "x": 27.8799,
                            "y": 9.4653
                        }
                    }, {
                        "x": 27.8799,
                        "y": 9.4653,
                        "point1": {
                            "x": 27.8799,
                            "y": 9.4653
                        },
                        "point2": {
                            "x": 27.8799,
                            "y": 28.1948
                        }
                    }, {
                        "x": 27.8799,
                        "y": 28.1948,
                        "point1": {
                            "x": 27.8799,
                            "y": 28.1948
                        },
                        "point2": {
                            "x": 8.8799,
                            "y": 28.1948
                        }
                    }, {
                        "x": 8.8799,
                        "y": 28.1948,
                        "point1": {
                            "x": 8.8799,
                            "y": 28.1948
                        },
                        "point2": {
                            "x": 8.8799,
                            "y": 9.5
                        }
                    }, {
                        "x": 8.8799,
                        "y": 9.5,
                        "point1": {
                            "x": 8.8799,
                            "y": 9.5
                        },
                        "point2": {
                            "x": -9.4955,
                            "y": 9.5
                        }
                    }, {
                        "x": -9.4955,
                        "y": 9.5,
                        "point1": {
                            "x": -9.4955,
                            "y": 9.5
                        },
                        "point2": {
                            "x": -9.4955,
                            "y": 28.2295
                        }
                    }, {
                        "x": -9.4955,
                        "y": 28.2295,
                        "point1": {
                            "x": -9.4955,
                            "y": 28.2295
                        },
                        "point2": {
                            "x": -28.4955,
                            "y": 28.2295
                        }
                    }, {
                        "x": -28.4955,
                        "y": 28.2295,
                        "point1": {
                            "x": -28.4955,
                            "y": 28.2295
                        },
                        "point2": {
                            "x": -28.4955,
                            "y": 9.5
                        }
                    }, {
                        "x": -28.4955,
                        "y": 9.5,
                        "point1": {
                            "x": -28.4955,
                            "y": 9.5
                        },
                        "point2": {
                            "x": -47.2955,
                            "y": 9.5
                        }
                    }, {
                        "x": -47.2955,
                        "y": 9.5,
                        "point1": {
                            "x": -47.2955,
                            "y": 9.5
                        },
                        "point2": {
                            "x": -47.2955,
                            "y": 28.2295
                        }
                    }, {
                        "x": -47.2955,
                        "y": 28.2295,
                        "point1": {
                            "x": -47.2955,
                            "y": 28.2295
                        },
                        "point2": {
                            "x": -66.2955,
                            "y": 28.2295
                        }
                    }, {
                        "x": -66.2955,
                        "y": 28.2295,
                        "point1": {
                            "x": -66.2955,
                            "y": 28.2295
                        },
                        "point2": {
                            "x": -66.2955,
                            "y": 9.2295
                        }
                    }, {
                        "x": -66.2955,
                        "y": 9.2295,
                        "point1": {
                            "x": -66.2955,
                            "y": 9.2295
                        },
                        "point2": {
                            "x": -47.3,
                            "y": 9.2295
                        }
                    }, {
                        "x": -47.3,
                        "y": 9.2295,
                        "point1": {
                            "x": -47.3,
                            "y": 9.2295
                        },
                        "point2": {
                            "x": -47.3,
                            "y": -9.5
                        }
                    }, {
                        "x": -47.3,
                        "y": -9.5,
                        "point1": {
                            "x": -47.3,
                            "y": -9.5
                        },
                        "point2": {
                            "x": -28.3,
                            "y": -9.5
                        }
                    }, {
                        "x": -28.3,
                        "y": -9.5,
                        "point1": {
                            "x": -28.3,
                            "y": -9.5
                        },
                        "point2": {
                            "x": -28.3,
                            "y": 9.2295
                        }
                    }, {
                        "x": -28.3,
                        "y": 9.2295,
                        "point1": {
                            "x": -28.3,
                            "y": 9.2295
                        },
                        "point2": {
                            "x": -9.5,
                            "y": 9.2295
                        }
                    }, {
                        "x": -9.5,
                        "y": 9.2295,
                        "point1": {
                            "x": -9.5,
                            "y": 9.2295
                        },
                        "point2": {
                            "x": -9.5,
                            "y": -9.5
                        }
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, -191.3141, 5.4902, 0, "", "", 312, "#020202", "#000", 1, 0, [{
                        "x": 14.6822,
                        "y": 12.7183
                    }, {
                        "x": 15.5613,
                        "y": -25.4436
                    }, {
                        "x": -30.2435,
                        "y": 12.7253
                    }], null, null, null, null, "", 1, 0, 0, 0, "", true],
                    [6, 183.8474, 5.3939, 0, "", "", 313, "#020202", "#000", 1, 0, [{
                        "x": -14.6822,
                        "y": 12.7183
                    }, {
                        "x": -15.5613,
                        "y": -25.4436
                    }, {
                        "x": 30.2435,
                        "y": 12.7253
                    }], null, null, null, null, "", 1, 0, 0, 0, "", true],
                    [6, -3.4812, 22.6124, 0, "", "", 314, "#918787", "#000", 1, 0, [{
                        "x": -220.0875,
                        "y": 4.5128
                    }, {
                        "x": -220.0875,
                        "y": -4.5128
                    }, {
                        "x": 220.0875,
                        "y": -4.5128
                    }, {
                        "x": 220.0875,
                        "y": 4.5128
                    }], null, null, null, null, "", 1, 0, 0, 0, "", true]
                ], null, null, null, null, 1, 0, 0, 0, true, false, []],
                [6, 12291.8193, -446.4971, 0, "", "", 222, "#000000", "#000000", 1, 0, [{
                    "x": -37.263,
                    "y": 7.02
                }, {
                    "x": -37.263,
                    "y": -7.02
                }, {
                    "x": 37.263,
                    "y": -7.02
                }, {
                    "x": 37.263,
                    "y": 7.02
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [6, 12333.846, -134.2705, 0, "", "", 223, "#000000", "#000000", 1, 0, [{
                    "x": 22.278,
                    "y": -13.392
                }, {
                    "x": 0,
                    "y": 26.784
                }, {
                    "x": -22.278,
                    "y": -13.392
                }], null, null, null, null, "", 4, 0, 0, 0, "", true],
                [7, 12458.4135, -68.6399, 0, "", "", 224, [
                    [6, -4.2434, -1.4701, 0, "", "", 307, "#2fa0a0", "#000", 1, 0, [{
                        "x": -171.5,
                        "y": 19.52
                    }, {
                        "x": -171.5,
                        "y": -19.52
                    }, {
                        "x": 171.5,
                        "y": -19.52
                    }, {
                        "x": 171.5,
                        "y": 19.52
                    }], null, null, null, null, "", 1, 0, 0, 0, "", true],
                    [6, -108.1867, -10.3654, 0, "", "", 308, "#020202", "#000", 1, null, [{
                        "x": -9.5,
                        "y": -9.5,
                        "point1": {
                            "x": -9.5,
                            "y": -9.5
                        },
                        "point2": {
                            "x": 9.5,
                            "y": -9.5
                        }
                    }, {
                        "x": 9.5,
                        "y": -9.5,
                        "point1": {
                            "x": 9.5,
                            "y": -9.5
                        },
                        "point2": {
                            "x": 9.5,
                            "y": 9.1948
                        }
                    }, {
                        "x": 9.5,
                        "y": 9.1948,
                        "point1": {
                            "x": 9.5,
                            "y": 9.1948
                        },
                        "point2": {
                            "x": 27.8754,
                            "y": 9.1948
                        }
                    }, {
                        "x": 27.8754,
                        "y": 9.1948,
                        "point1": {
                            "x": 27.8754,
                            "y": 9.1948
                        },
                        "point2": {
                            "x": 27.8754,
                            "y": -9.5347
                        }
                    }, {
                        "x": 27.8754,
                        "y": -9.5347,
                        "point1": {
                            "x": 27.8754,
                            "y": -9.5347
                        },
                        "point2": {
                            "x": 46.8754,
                            "y": -9.5347
                        }
                    }, {
                        "x": 46.8754,
                        "y": -9.5347,
                        "point1": {
                            "x": 46.8754,
                            "y": -9.5347
                        },
                        "point2": {
                            "x": 46.8754,
                            "y": 9.4653
                        }
                    }, {
                        "x": 46.8754,
                        "y": 9.4653,
                        "point1": {
                            "x": 46.8754,
                            "y": 9.4653
                        },
                        "point2": {
                            "x": 27.8799,
                            "y": 9.4653
                        }
                    }, {
                        "x": 27.8799,
                        "y": 9.4653,
                        "point1": {
                            "x": 27.8799,
                            "y": 9.4653
                        },
                        "point2": {
                            "x": 27.8799,
                            "y": 28.1948
                        }
                    }, {
                        "x": 27.8799,
                        "y": 28.1948,
                        "point1": {
                            "x": 27.8799,
                            "y": 28.1948
                        },
                        "point2": {
                            "x": 8.8799,
                            "y": 28.1948
                        }
                    }, {
                        "x": 8.8799,
                        "y": 28.1948,
                        "point1": {
                            "x": 8.8799,
                            "y": 28.1948
                        },
                        "point2": {
                            "x": 8.8799,
                            "y": 9.5
                        }
                    }, {
                        "x": 8.8799,
                        "y": 9.5,
                        "point1": {
                            "x": 8.8799,
                            "y": 9.5
                        },
                        "point2": {
                            "x": -9.4955,
                            "y": 9.5
                        }
                    }, {
                        "x": -9.4955,
                        "y": 9.5,
                        "point1": {
                            "x": -9.4955,
                            "y": 9.5
                        },
                        "point2": {
                            "x": -9.4955,
                            "y": 28.2295
                        }
                    }, {
                        "x": -9.4955,
                        "y": 28.2295,
                        "point1": {
                            "x": -9.4955,
                            "y": 28.2295
                        },
                        "point2": {
                            "x": -28.4955,
                            "y": 28.2295
                        }
                    }, {
                        "x": -28.4955,
                        "y": 28.2295,
                        "point1": {
                            "x": -28.4955,
                            "y": 28.2295
                        },
                        "point2": {
                            "x": -28.4955,
                            "y": 9.5
                        }
                    }, {
                        "x": -28.4955,
                        "y": 9.5,
                        "point1": {
                            "x": -28.4955,
                            "y": 9.5
                        },
                        "point2": {
                            "x": -47.2955,
                            "y": 9.5
                        }
                    }, {
                        "x": -47.2955,
                        "y": 9.5,
                        "point1": {
                            "x": -47.2955,
                            "y": 9.5
                        },
                        "point2": {
                            "x": -47.2955,
                            "y": 28.2295
                        }
                    }, {
                        "x": -47.2955,
                        "y": 28.2295,
                        "point1": {
                            "x": -47.2955,
                            "y": 28.2295
                        },
                        "point2": {
                            "x": -66.2955,
                            "y": 28.2295
                        }
                    }, {
                        "x": -66.2955,
                        "y": 28.2295,
                        "point1": {
                            "x": -66.2955,
                            "y": 28.2295
                        },
                        "point2": {
                            "x": -66.2955,
                            "y": 9.2295
                        }
                    }, {
                        "x": -66.2955,
                        "y": 9.2295,
                        "point1": {
                            "x": -66.2955,
                            "y": 9.2295
                        },
                        "point2": {
                            "x": -47.3,
                            "y": 9.2295
                        }
                    }, {
                        "x": -47.3,
                        "y": 9.2295,
                        "point1": {
                            "x": -47.3,
                            "y": 9.2295
                        },
                        "point2": {
                            "x": -47.3,
                            "y": -9.5
                        }
                    }, {
                        "x": -47.3,
                        "y": -9.5,
                        "point1": {
                            "x": -47.3,
                            "y": -9.5
                        },
                        "point2": {
                            "x": -28.3,
                            "y": -9.5
                        }
                    }, {
                        "x": -28.3,
                        "y": -9.5,
                        "point1": {
                            "x": -28.3,
                            "y": -9.5
                        },
                        "point2": {
                            "x": -28.3,
                            "y": 9.2295
                        }
                    }, {
                        "x": -28.3,
                        "y": 9.2295,
                        "point1": {
                            "x": -28.3,
                            "y": 9.2295
                        },
                        "point2": {
                            "x": -9.5,
                            "y": 9.2295
                        }
                    }, {
                        "x": -9.5,
                        "y": 9.2295,
                        "point1": {
                            "x": -9.5,
                            "y": 9.2295
                        },
                        "point2": {
                            "x": -9.5,
                            "y": -9.5
                        }
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, 5.19, -10.9738, 0, "", "", 309, "#020202", "#000", 1, null, [{
                        "x": -9.5,
                        "y": -9.5,
                        "point1": {
                            "x": -9.5,
                            "y": -9.5
                        },
                        "point2": {
                            "x": 9.5,
                            "y": -9.5
                        }
                    }, {
                        "x": 9.5,
                        "y": -9.5,
                        "point1": {
                            "x": 9.5,
                            "y": -9.5
                        },
                        "point2": {
                            "x": 9.5,
                            "y": 9.1948
                        }
                    }, {
                        "x": 9.5,
                        "y": 9.1948,
                        "point1": {
                            "x": 9.5,
                            "y": 9.1948
                        },
                        "point2": {
                            "x": 27.8754,
                            "y": 9.1948
                        }
                    }, {
                        "x": 27.8754,
                        "y": 9.1948,
                        "point1": {
                            "x": 27.8754,
                            "y": 9.1948
                        },
                        "point2": {
                            "x": 27.8754,
                            "y": -9.5347
                        }
                    }, {
                        "x": 27.8754,
                        "y": -9.5347,
                        "point1": {
                            "x": 27.8754,
                            "y": -9.5347
                        },
                        "point2": {
                            "x": 46.8754,
                            "y": -9.5347
                        }
                    }, {
                        "x": 46.8754,
                        "y": -9.5347,
                        "point1": {
                            "x": 46.8754,
                            "y": -9.5347
                        },
                        "point2": {
                            "x": 46.8754,
                            "y": 9.4653
                        }
                    }, {
                        "x": 46.8754,
                        "y": 9.4653,
                        "point1": {
                            "x": 46.8754,
                            "y": 9.4653
                        },
                        "point2": {
                            "x": 27.8799,
                            "y": 9.4653
                        }
                    }, {
                        "x": 27.8799,
                        "y": 9.4653,
                        "point1": {
                            "x": 27.8799,
                            "y": 9.4653
                        },
                        "point2": {
                            "x": 27.8799,
                            "y": 28.1948
                        }
                    }, {
                        "x": 27.8799,
                        "y": 28.1948,
                        "point1": {
                            "x": 27.8799,
                            "y": 28.1948
                        },
                        "point2": {
                            "x": 8.8799,
                            "y": 28.1948
                        }
                    }, {
                        "x": 8.8799,
                        "y": 28.1948,
                        "point1": {
                            "x": 8.8799,
                            "y": 28.1948
                        },
                        "point2": {
                            "x": 8.8799,
                            "y": 9.5
                        }
                    }, {
                        "x": 8.8799,
                        "y": 9.5,
                        "point1": {
                            "x": 8.8799,
                            "y": 9.5
                        },
                        "point2": {
                            "x": -9.4955,
                            "y": 9.5
                        }
                    }, {
                        "x": -9.4955,
                        "y": 9.5,
                        "point1": {
                            "x": -9.4955,
                            "y": 9.5
                        },
                        "point2": {
                            "x": -9.4955,
                            "y": 28.2295
                        }
                    }, {
                        "x": -9.4955,
                        "y": 28.2295,
                        "point1": {
                            "x": -9.4955,
                            "y": 28.2295
                        },
                        "point2": {
                            "x": -28.4955,
                            "y": 28.2295
                        }
                    }, {
                        "x": -28.4955,
                        "y": 28.2295,
                        "point1": {
                            "x": -28.4955,
                            "y": 28.2295
                        },
                        "point2": {
                            "x": -28.4955,
                            "y": 9.5
                        }
                    }, {
                        "x": -28.4955,
                        "y": 9.5,
                        "point1": {
                            "x": -28.4955,
                            "y": 9.5
                        },
                        "point2": {
                            "x": -47.2955,
                            "y": 9.5
                        }
                    }, {
                        "x": -47.2955,
                        "y": 9.5,
                        "point1": {
                            "x": -47.2955,
                            "y": 9.5
                        },
                        "point2": {
                            "x": -47.2955,
                            "y": 28.2295
                        }
                    }, {
                        "x": -47.2955,
                        "y": 28.2295,
                        "point1": {
                            "x": -47.2955,
                            "y": 28.2295
                        },
                        "point2": {
                            "x": -66.2955,
                            "y": 28.2295
                        }
                    }, {
                        "x": -66.2955,
                        "y": 28.2295,
                        "point1": {
                            "x": -66.2955,
                            "y": 28.2295
                        },
                        "point2": {
                            "x": -66.2955,
                            "y": 9.2295
                        }
                    }, {
                        "x": -66.2955,
                        "y": 9.2295,
                        "point1": {
                            "x": -66.2955,
                            "y": 9.2295
                        },
                        "point2": {
                            "x": -47.3,
                            "y": 9.2295
                        }
                    }, {
                        "x": -47.3,
                        "y": 9.2295,
                        "point1": {
                            "x": -47.3,
                            "y": 9.2295
                        },
                        "point2": {
                            "x": -47.3,
                            "y": -9.5
                        }
                    }, {
                        "x": -47.3,
                        "y": -9.5,
                        "point1": {
                            "x": -47.3,
                            "y": -9.5
                        },
                        "point2": {
                            "x": -28.3,
                            "y": -9.5
                        }
                    }, {
                        "x": -28.3,
                        "y": -9.5,
                        "point1": {
                            "x": -28.3,
                            "y": -9.5
                        },
                        "point2": {
                            "x": -28.3,
                            "y": 9.2295
                        }
                    }, {
                        "x": -28.3,
                        "y": 9.2295,
                        "point1": {
                            "x": -28.3,
                            "y": 9.2295
                        },
                        "point2": {
                            "x": -9.5,
                            "y": 9.2295
                        }
                    }, {
                        "x": -9.5,
                        "y": 9.2295,
                        "point1": {
                            "x": -9.5,
                            "y": 9.2295
                        },
                        "point2": {
                            "x": -9.5,
                            "y": -9.5
                        }
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, 118.1881, -10.687, 0, "", "", 310, "#020202", "#000", 1, null, [{
                        "x": -9.5,
                        "y": -9.5,
                        "point1": {
                            "x": -9.5,
                            "y": -9.5
                        },
                        "point2": {
                            "x": 9.5,
                            "y": -9.5
                        }
                    }, {
                        "x": 9.5,
                        "y": -9.5,
                        "point1": {
                            "x": 9.5,
                            "y": -9.5
                        },
                        "point2": {
                            "x": 9.5,
                            "y": 9.1948
                        }
                    }, {
                        "x": 9.5,
                        "y": 9.1948,
                        "point1": {
                            "x": 9.5,
                            "y": 9.1948
                        },
                        "point2": {
                            "x": 27.8754,
                            "y": 9.1948
                        }
                    }, {
                        "x": 27.8754,
                        "y": 9.1948,
                        "point1": {
                            "x": 27.8754,
                            "y": 9.1948
                        },
                        "point2": {
                            "x": 27.8754,
                            "y": -9.5347
                        }
                    }, {
                        "x": 27.8754,
                        "y": -9.5347,
                        "point1": {
                            "x": 27.8754,
                            "y": -9.5347
                        },
                        "point2": {
                            "x": 46.8754,
                            "y": -9.5347
                        }
                    }, {
                        "x": 46.8754,
                        "y": -9.5347,
                        "point1": {
                            "x": 46.8754,
                            "y": -9.5347
                        },
                        "point2": {
                            "x": 46.8754,
                            "y": 9.4653
                        }
                    }, {
                        "x": 46.8754,
                        "y": 9.4653,
                        "point1": {
                            "x": 46.8754,
                            "y": 9.4653
                        },
                        "point2": {
                            "x": 27.8799,
                            "y": 9.4653
                        }
                    }, {
                        "x": 27.8799,
                        "y": 9.4653,
                        "point1": {
                            "x": 27.8799,
                            "y": 9.4653
                        },
                        "point2": {
                            "x": 27.8799,
                            "y": 28.1948
                        }
                    }, {
                        "x": 27.8799,
                        "y": 28.1948,
                        "point1": {
                            "x": 27.8799,
                            "y": 28.1948
                        },
                        "point2": {
                            "x": 8.8799,
                            "y": 28.1948
                        }
                    }, {
                        "x": 8.8799,
                        "y": 28.1948,
                        "point1": {
                            "x": 8.8799,
                            "y": 28.1948
                        },
                        "point2": {
                            "x": 8.8799,
                            "y": 9.5
                        }
                    }, {
                        "x": 8.8799,
                        "y": 9.5,
                        "point1": {
                            "x": 8.8799,
                            "y": 9.5
                        },
                        "point2": {
                            "x": -9.4955,
                            "y": 9.5
                        }
                    }, {
                        "x": -9.4955,
                        "y": 9.5,
                        "point1": {
                            "x": -9.4955,
                            "y": 9.5
                        },
                        "point2": {
                            "x": -9.4955,
                            "y": 28.2295
                        }
                    }, {
                        "x": -9.4955,
                        "y": 28.2295,
                        "point1": {
                            "x": -9.4955,
                            "y": 28.2295
                        },
                        "point2": {
                            "x": -28.4955,
                            "y": 28.2295
                        }
                    }, {
                        "x": -28.4955,
                        "y": 28.2295,
                        "point1": {
                            "x": -28.4955,
                            "y": 28.2295
                        },
                        "point2": {
                            "x": -28.4955,
                            "y": 9.5
                        }
                    }, {
                        "x": -28.4955,
                        "y": 9.5,
                        "point1": {
                            "x": -28.4955,
                            "y": 9.5
                        },
                        "point2": {
                            "x": -47.2955,
                            "y": 9.5
                        }
                    }, {
                        "x": -47.2955,
                        "y": 9.5,
                        "point1": {
                            "x": -47.2955,
                            "y": 9.5
                        },
                        "point2": {
                            "x": -47.2955,
                            "y": 28.2295
                        }
                    }, {
                        "x": -47.2955,
                        "y": 28.2295,
                        "point1": {
                            "x": -47.2955,
                            "y": 28.2295
                        },
                        "point2": {
                            "x": -66.2955,
                            "y": 28.2295
                        }
                    }, {
                        "x": -66.2955,
                        "y": 28.2295,
                        "point1": {
                            "x": -66.2955,
                            "y": 28.2295
                        },
                        "point2": {
                            "x": -66.2955,
                            "y": 9.2295
                        }
                    }, {
                        "x": -66.2955,
                        "y": 9.2295,
                        "point1": {
                            "x": -66.2955,
                            "y": 9.2295
                        },
                        "point2": {
                            "x": -47.3,
                            "y": 9.2295
                        }
                    }, {
                        "x": -47.3,
                        "y": 9.2295,
                        "point1": {
                            "x": -47.3,
                            "y": 9.2295
                        },
                        "point2": {
                            "x": -47.3,
                            "y": -9.5
                        }
                    }, {
                        "x": -47.3,
                        "y": -9.5,
                        "point1": {
                            "x": -47.3,
                            "y": -9.5
                        },
                        "point2": {
                            "x": -28.3,
                            "y": -9.5
                        }
                    }, {
                        "x": -28.3,
                        "y": -9.5,
                        "point1": {
                            "x": -28.3,
                            "y": -9.5
                        },
                        "point2": {
                            "x": -28.3,
                            "y": 9.2295
                        }
                    }, {
                        "x": -28.3,
                        "y": 9.2295,
                        "point1": {
                            "x": -28.3,
                            "y": 9.2295
                        },
                        "point2": {
                            "x": -9.5,
                            "y": 9.2295
                        }
                    }, {
                        "x": -9.5,
                        "y": 9.2295,
                        "point1": {
                            "x": -9.5,
                            "y": 9.2295
                        },
                        "point2": {
                            "x": -9.5,
                            "y": -9.5
                        }
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, -191.3141, 5.4902, 0, "", "", 311, "#020202", "#000", 1, 0, [{
                        "x": 14.6822,
                        "y": 12.7183
                    }, {
                        "x": 15.5613,
                        "y": -25.4436
                    }, {
                        "x": -30.2435,
                        "y": 12.7253
                    }], null, null, null, null, "", 1, 0, 0, 0, "", true],
                    [6, 183.8474, 5.3939, 0, "", "", 312, "#020202", "#000", 1, 0, [{
                        "x": -14.6822,
                        "y": 12.7183
                    }, {
                        "x": -15.5613,
                        "y": -25.4436
                    }, {
                        "x": 30.2435,
                        "y": 12.7253
                    }], null, null, null, null, "", 1, 0, 0, 0, "", true],
                    [6, -3.4812, 22.6124, 0, "", "", 313, "#918787", "#000", 1, 0, [{
                        "x": -220.0875,
                        "y": 4.5128
                    }, {
                        "x": -220.0875,
                        "y": -4.5128
                    }, {
                        "x": 220.0875,
                        "y": -4.5128
                    }, {
                        "x": 220.0875,
                        "y": 4.5128
                    }], null, null, null, null, "", 1, 0, 0, 0, "", true]
                ], null, null, null, null, 1, 0, 0, 0, true, false, []],
                [7, 12623.0597, 9.2933, -0.5236, "", "", 225, [
                    [6, 39.9149, 117.8124, 0, "", "", 298, "#000000", "#000", 1, 78.5242, [{
                        "x": 0,
                        "y": 0
                    }, {
                        "x": 0,
                        "y": 0
                    }], null, null, null, null, "", 2, 0, 0, 0, "", true],
                    [6, 39.7198, 13.3524, 0, "", "", 299, "#999999", "#000", 1, 78.5242, [{
                        "x": 0,
                        "y": 0
                    }, {
                        "x": 0,
                        "y": 0
                    }], null, null, null, null, "", 2, 0, 0, 0, "", true],
                    [6, 38.0503, -25.8066, 0, "", "", 300, "#000000", "#000", 1, 0, [{
                        "x": -5.0535,
                        "y": 38.244
                    }, {
                        "x": -5.0535,
                        "y": -38.244
                    }, {
                        "x": 5.0535,
                        "y": -38.244
                    }, {
                        "x": 5.0535,
                        "y": 38.244
                    }], null, null, null, null, "", 2, 0, 0, 0, "", true],
                    [6, 38.1328, 2.8704, 0, "", "", 301, "#999999", "#000", 1, 14.7212, [{
                        "x": 0,
                        "y": 0
                    }, {
                        "x": 0,
                        "y": 0
                    }], null, null, null, null, "", 2, 0, 0, 0, "", true],
                    [6, 39.7198, 69.0414, 0, "", "", 302, "#000000", "#000", 1, 0, [{
                        "x": -79.377,
                        "y": 56.304
                    }, {
                        "x": -79.377,
                        "y": -56.304
                    }, {
                        "x": 79.377,
                        "y": -56.304
                    }, {
                        "x": 79.377,
                        "y": 56.304
                    }], null, null, null, null, "", 2, 0, 0, 0, "", true],
                    [6, -75.8283, -34.8191, -0.5236, "", "", 303, "#000000", "#000", 1, 0, [{
                        "x": 20.433,
                        "y": 13.188
                    }, {
                        "x": -13.002,
                        "y": -2.415
                    }, {
                        "x": -7.431,
                        "y": -10.773
                    }], null, null, null, null, "", 2, 0, 0, 0, "", true],
                    [6, -49.8243, -81.2561, 0.3491, "", "", 304, "#000000", "#000", 1, 0, [{
                        "x": 20.433,
                        "y": 13.188
                    }, {
                        "x": -13.002,
                        "y": -2.415
                    }, {
                        "x": -7.431,
                        "y": -10.773
                    }], null, null, null, null, "", 2, 0, 0, 0, "", true],
                    [6, -69.8852, -61.1951, 0, "", "", 305, "#000000", "#000", 1, 0, [{
                        "x": 20.433,
                        "y": 13.188
                    }, {
                        "x": -13.002,
                        "y": -2.415
                    }, {
                        "x": -7.431,
                        "y": -10.773
                    }], null, null, null, null, "", 2, 0, 0, 0, "", true]
                ], null, null, null, null, 1, 0, 0, 0, true, false, []],
                [9, 12698.168, 44.8207, -0.5236, "", "", 226, "Select", "#ffffff", 1, 25, "Lily Script One", "left", null, null, null, null, 0, 0, 0, true],
                [6, 12334.9718, -292.3958, 1.5708, "", "", 227, "#000000", "#000000", 1, 0, [{
                    "x": -160,
                    "y": 7.02
                }, {
                    "x": -160,
                    "y": -7.02
                }, {
                    "x": 160,
                    "y": -7.02
                }, {
                    "x": 160,
                    "y": 7.02
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [7, 11033.5205, -306.2303, -0.3491, "", "", 228, [
                    [6, -92.8685, -1.8417, -1.0472, "", "", 317, "#000000", "#000", 1, null, [{
                        "x": 58.8222,
                        "y": -222.6198,
                        "point1": {
                            "x": 13.4669,
                            "y": -226.2479
                        },
                        "point2": {
                            "x": -59.4409,
                            "y": -194.8701
                        }
                    }, {
                        "x": -81.1491,
                        "y": -158.6897,
                        "point1": {
                            "x": -92.605,
                            "y": -139.5965
                        },
                        "point2": {
                            "x": -105.059,
                            "y": -117.5704
                        }
                    }, {
                        "x": -110.1938,
                        "y": -95.3194,
                        "point1": {
                            "x": -125.328,
                            "y": -29.7382
                        },
                        "point2": {
                            "x": -81.9673,
                            "y": 58.3275
                        }
                    }, {
                        "x": -36.2619,
                        "y": 104.0328,
                        "point1": {
                            "x": -10.4698,
                            "y": 129.8249
                        },
                        "point2": {
                            "x": 18.8039,
                            "y": 153.9867
                        }
                    }, {
                        "x": 54.8329,
                        "y": 162.1222,
                        "point1": {
                            "x": 65.0364,
                            "y": 164.4262
                        },
                        "point2": {
                            "x": 75.0294,
                            "y": 167.5891
                        }
                    }, {
                        "x": 85.1978,
                        "y": 170.0435,
                        "point1": {
                            "x": 87.7999,
                            "y": 170.6716
                        },
                        "point2": {
                            "x": 92.2726,
                            "y": 173.9032
                        }
                    }, {
                        "x": 93.1191,
                        "y": 171.3637,
                        "point1": {
                            "x": 94.0101,
                            "y": 168.6905
                        },
                        "point2": {
                            "x": 88.9957,
                            "y": 167.425
                        }
                    }, {
                        "x": 86.518,
                        "y": 166.0829,
                        "point1": {
                            "x": 70.6881,
                            "y": 157.5084
                        },
                        "point2": {
                            "x": 60.4411,
                            "y": 153.4789
                        }
                    }, {
                        "x": 46.9116,
                        "y": 143.6392,
                        "point1": {
                            "x": 18.6228,
                            "y": 123.0656
                        },
                        "point2": {
                            "x": -2.9698,
                            "y": 103.4012
                        }
                    }, {
                        "x": -29.6608,
                        "y": 80.269,
                        "point1": {
                            "x": -53.1783,
                            "y": 59.8872
                        },
                        "point2": {
                            "x": -61.5206,
                            "y": 28.2806
                        }
                    }, {
                        "x": -72.503,
                        "y": 0.0402,
                        "point1": {
                            "x": -74.9852,
                            "y": -6.3428
                        },
                        "point2": {
                            "x": -76.4214,
                            "y": -14.7394
                        }
                    }, {
                        "x": -77.1885,
                        "y": -21.3875,
                        "point1": {
                            "x": -79.9166,
                            "y": -45.0311
                        },
                        "point2": {
                            "x": -81.7025,
                            "y": -68.8849
                        }
                    }, {
                        "x": -81.1491,
                        "y": -92.679,
                        "point1": {
                            "x": -80.1435,
                            "y": -135.9196
                        },
                        "point2": {
                            "x": -22.6188,
                            "y": -188.4203
                        }
                    }, {
                        "x": 15.9454,
                        "y": -199.6163,
                        "point1": {
                            "x": 40.5167,
                            "y": -206.7499
                        },
                        "point2": {
                            "x": 61.7138,
                            "y": -201.9207
                        }
                    }, {
                        "x": 86.518,
                        "y": -204.8972,
                        "point1": {
                            "x": 92.6522,
                            "y": -205.6333
                        },
                        "point2": {
                            "x": 59.2148,
                            "y": -222.5884
                        }
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, 95.443, 8.51, -0.3491, "", "", 318, "#000000", "#c45757", 1, 0, [{
                        "x": -29.5,
                        "y": -16.3333
                    }, {
                        "x": 0,
                        "y": 32.6667
                    }, {
                        "x": 29.5,
                        "y": -16.3333
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, -96.2313, -8.2061, -1.0472, "", "", 319, "#ff0000", "#000", 1, null, [{
                        "x": 58.8222,
                        "y": -222.6198,
                        "point1": {
                            "x": 13.4669,
                            "y": -226.2479
                        },
                        "point2": {
                            "x": -59.4409,
                            "y": -194.8701
                        }
                    }, {
                        "x": -81.1491,
                        "y": -158.6897,
                        "point1": {
                            "x": -92.605,
                            "y": -139.5965
                        },
                        "point2": {
                            "x": -105.059,
                            "y": -117.5704
                        }
                    }, {
                        "x": -110.1938,
                        "y": -95.3194,
                        "point1": {
                            "x": -125.328,
                            "y": -29.7382
                        },
                        "point2": {
                            "x": -81.9673,
                            "y": 58.3275
                        }
                    }, {
                        "x": -36.2619,
                        "y": 104.0328,
                        "point1": {
                            "x": -10.4698,
                            "y": 129.8249
                        },
                        "point2": {
                            "x": 18.8039,
                            "y": 153.9867
                        }
                    }, {
                        "x": 54.8329,
                        "y": 162.1222,
                        "point1": {
                            "x": 65.0364,
                            "y": 164.4262
                        },
                        "point2": {
                            "x": 75.0294,
                            "y": 167.5891
                        }
                    }, {
                        "x": 85.1978,
                        "y": 170.0435,
                        "point1": {
                            "x": 87.7999,
                            "y": 170.6716
                        },
                        "point2": {
                            "x": 92.2726,
                            "y": 173.9032
                        }
                    }, {
                        "x": 93.1191,
                        "y": 171.3637,
                        "point1": {
                            "x": 94.0101,
                            "y": 168.6905
                        },
                        "point2": {
                            "x": 88.9957,
                            "y": 167.425
                        }
                    }, {
                        "x": 86.518,
                        "y": 166.0829,
                        "point1": {
                            "x": 70.6881,
                            "y": 157.5084
                        },
                        "point2": {
                            "x": 60.4411,
                            "y": 153.4789
                        }
                    }, {
                        "x": 46.9116,
                        "y": 143.6392,
                        "point1": {
                            "x": 18.6228,
                            "y": 123.0656
                        },
                        "point2": {
                            "x": -2.9698,
                            "y": 103.4012
                        }
                    }, {
                        "x": -29.6608,
                        "y": 80.269,
                        "point1": {
                            "x": -53.1783,
                            "y": 59.8872
                        },
                        "point2": {
                            "x": -61.5206,
                            "y": 28.2806
                        }
                    }, {
                        "x": -72.503,
                        "y": 0.0402,
                        "point1": {
                            "x": -74.9852,
                            "y": -6.3428
                        },
                        "point2": {
                            "x": -76.4214,
                            "y": -14.7394
                        }
                    }, {
                        "x": -77.1885,
                        "y": -21.3875,
                        "point1": {
                            "x": -79.9166,
                            "y": -45.0311
                        },
                        "point2": {
                            "x": -81.7025,
                            "y": -68.8849
                        }
                    }, {
                        "x": -81.1491,
                        "y": -92.679,
                        "point1": {
                            "x": -80.1435,
                            "y": -135.9196
                        },
                        "point2": {
                            "x": -22.6188,
                            "y": -188.4203
                        }
                    }, {
                        "x": 15.9454,
                        "y": -199.6163,
                        "point1": {
                            "x": 40.5167,
                            "y": -206.7499
                        },
                        "point2": {
                            "x": 61.7138,
                            "y": -201.9207
                        }
                    }, {
                        "x": 86.518,
                        "y": -204.8972,
                        "point1": {
                            "x": 92.6522,
                            "y": -205.6333
                        },
                        "point2": {
                            "x": 59.2148,
                            "y": -222.5884
                        }
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, 93.6568, 1.5377, -0.3491, "", "", 320, "#ff0000", "#c45757", 1, 0, [{
                        "x": -29.5,
                        "y": -16.3333
                    }, {
                        "x": 0,
                        "y": 32.6667
                    }, {
                        "x": 29.5,
                        "y": -16.3333
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true]
                ], null, null, null, null, 1, 0, 0, 0, true, false, []],
                [7, 16296.8781, -153.4671, 0.3491, "", "", 229, [
                    [6, -92.8685, -1.8417, -1.0472, "", "", 317, "#000000", "#000", 1, null, [{
                        "x": 58.8222,
                        "y": -222.6198,
                        "point1": {
                            "x": 13.4669,
                            "y": -226.2479
                        },
                        "point2": {
                            "x": -59.4409,
                            "y": -194.8701
                        }
                    }, {
                        "x": -81.1491,
                        "y": -158.6897,
                        "point1": {
                            "x": -92.605,
                            "y": -139.5965
                        },
                        "point2": {
                            "x": -105.059,
                            "y": -117.5704
                        }
                    }, {
                        "x": -110.1938,
                        "y": -95.3194,
                        "point1": {
                            "x": -125.328,
                            "y": -29.7382
                        },
                        "point2": {
                            "x": -81.9673,
                            "y": 58.3275
                        }
                    }, {
                        "x": -36.2619,
                        "y": 104.0328,
                        "point1": {
                            "x": -10.4698,
                            "y": 129.8249
                        },
                        "point2": {
                            "x": 18.8039,
                            "y": 153.9867
                        }
                    }, {
                        "x": 54.8329,
                        "y": 162.1222,
                        "point1": {
                            "x": 65.0364,
                            "y": 164.4262
                        },
                        "point2": {
                            "x": 75.0294,
                            "y": 167.5891
                        }
                    }, {
                        "x": 85.1978,
                        "y": 170.0435,
                        "point1": {
                            "x": 87.7999,
                            "y": 170.6716
                        },
                        "point2": {
                            "x": 92.2726,
                            "y": 173.9032
                        }
                    }, {
                        "x": 93.1191,
                        "y": 171.3637,
                        "point1": {
                            "x": 94.0101,
                            "y": 168.6905
                        },
                        "point2": {
                            "x": 88.9957,
                            "y": 167.425
                        }
                    }, {
                        "x": 86.518,
                        "y": 166.0829,
                        "point1": {
                            "x": 70.6881,
                            "y": 157.5084
                        },
                        "point2": {
                            "x": 60.4411,
                            "y": 153.4789
                        }
                    }, {
                        "x": 46.9116,
                        "y": 143.6392,
                        "point1": {
                            "x": 18.6228,
                            "y": 123.0656
                        },
                        "point2": {
                            "x": -2.9698,
                            "y": 103.4012
                        }
                    }, {
                        "x": -29.6608,
                        "y": 80.269,
                        "point1": {
                            "x": -53.1783,
                            "y": 59.8872
                        },
                        "point2": {
                            "x": -61.5206,
                            "y": 28.2806
                        }
                    }, {
                        "x": -72.503,
                        "y": 0.0402,
                        "point1": {
                            "x": -74.9852,
                            "y": -6.3428
                        },
                        "point2": {
                            "x": -76.4214,
                            "y": -14.7394
                        }
                    }, {
                        "x": -77.1885,
                        "y": -21.3875,
                        "point1": {
                            "x": -79.9166,
                            "y": -45.0311
                        },
                        "point2": {
                            "x": -81.7025,
                            "y": -68.8849
                        }
                    }, {
                        "x": -81.1491,
                        "y": -92.679,
                        "point1": {
                            "x": -80.1435,
                            "y": -135.9196
                        },
                        "point2": {
                            "x": -22.6188,
                            "y": -188.4203
                        }
                    }, {
                        "x": 15.9454,
                        "y": -199.6163,
                        "point1": {
                            "x": 40.5167,
                            "y": -206.7499
                        },
                        "point2": {
                            "x": 61.7138,
                            "y": -201.9207
                        }
                    }, {
                        "x": 86.518,
                        "y": -204.8972,
                        "point1": {
                            "x": 92.6522,
                            "y": -205.6333
                        },
                        "point2": {
                            "x": 59.2148,
                            "y": -222.5884
                        }
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, 95.443, 8.51, -0.3491, "", "", 318, "#000000", "#c45757", 1, 0, [{
                        "x": -29.5,
                        "y": -16.3333
                    }, {
                        "x": 0,
                        "y": 32.6667
                    }, {
                        "x": 29.5,
                        "y": -16.3333
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, -96.2313, -8.2061, -1.0472, "", "", 319, "#ff0000", "#000", 1, null, [{
                        "x": 58.8222,
                        "y": -222.6198,
                        "point1": {
                            "x": 13.4669,
                            "y": -226.2479
                        },
                        "point2": {
                            "x": -59.4409,
                            "y": -194.8701
                        }
                    }, {
                        "x": -81.1491,
                        "y": -158.6897,
                        "point1": {
                            "x": -92.605,
                            "y": -139.5965
                        },
                        "point2": {
                            "x": -105.059,
                            "y": -117.5704
                        }
                    }, {
                        "x": -110.1938,
                        "y": -95.3194,
                        "point1": {
                            "x": -125.328,
                            "y": -29.7382
                        },
                        "point2": {
                            "x": -81.9673,
                            "y": 58.3275
                        }
                    }, {
                        "x": -36.2619,
                        "y": 104.0328,
                        "point1": {
                            "x": -10.4698,
                            "y": 129.8249
                        },
                        "point2": {
                            "x": 18.8039,
                            "y": 153.9867
                        }
                    }, {
                        "x": 54.8329,
                        "y": 162.1222,
                        "point1": {
                            "x": 65.0364,
                            "y": 164.4262
                        },
                        "point2": {
                            "x": 75.0294,
                            "y": 167.5891
                        }
                    }, {
                        "x": 85.1978,
                        "y": 170.0435,
                        "point1": {
                            "x": 87.7999,
                            "y": 170.6716
                        },
                        "point2": {
                            "x": 92.2726,
                            "y": 173.9032
                        }
                    }, {
                        "x": 93.1191,
                        "y": 171.3637,
                        "point1": {
                            "x": 94.0101,
                            "y": 168.6905
                        },
                        "point2": {
                            "x": 88.9957,
                            "y": 167.425
                        }
                    }, {
                        "x": 86.518,
                        "y": 166.0829,
                        "point1": {
                            "x": 70.6881,
                            "y": 157.5084
                        },
                        "point2": {
                            "x": 60.4411,
                            "y": 153.4789
                        }
                    }, {
                        "x": 46.9116,
                        "y": 143.6392,
                        "point1": {
                            "x": 18.6228,
                            "y": 123.0656
                        },
                        "point2": {
                            "x": -2.9698,
                            "y": 103.4012
                        }
                    }, {
                        "x": -29.6608,
                        "y": 80.269,
                        "point1": {
                            "x": -53.1783,
                            "y": 59.8872
                        },
                        "point2": {
                            "x": -61.5206,
                            "y": 28.2806
                        }
                    }, {
                        "x": -72.503,
                        "y": 0.0402,
                        "point1": {
                            "x": -74.9852,
                            "y": -6.3428
                        },
                        "point2": {
                            "x": -76.4214,
                            "y": -14.7394
                        }
                    }, {
                        "x": -77.1885,
                        "y": -21.3875,
                        "point1": {
                            "x": -79.9166,
                            "y": -45.0311
                        },
                        "point2": {
                            "x": -81.7025,
                            "y": -68.8849
                        }
                    }, {
                        "x": -81.1491,
                        "y": -92.679,
                        "point1": {
                            "x": -80.1435,
                            "y": -135.9196
                        },
                        "point2": {
                            "x": -22.6188,
                            "y": -188.4203
                        }
                    }, {
                        "x": 15.9454,
                        "y": -199.6163,
                        "point1": {
                            "x": 40.5167,
                            "y": -206.7499
                        },
                        "point2": {
                            "x": 61.7138,
                            "y": -201.9207
                        }
                    }, {
                        "x": 86.518,
                        "y": -204.8972,
                        "point1": {
                            "x": 92.6522,
                            "y": -205.6333
                        },
                        "point2": {
                            "x": 59.2148,
                            "y": -222.5884
                        }
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, 93.6568, 1.5377, -0.3491, "", "", 320, "#ff0000", "#c45757", 1, 0, [{
                        "x": -29.5,
                        "y": -16.3333
                    }, {
                        "x": 0,
                        "y": 32.6667
                    }, {
                        "x": 29.5,
                        "y": -16.3333
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true]
                ], null, null, null, null, 1, 0, 0, 0, true, false, []],
                [9, 1075.7019, -111.8177, 0, "", "Tutorial_Text_4", 230, "Press on your Keyboard", "#000000", 1, 35, "Lily Script One", "left", null, null, null, null, 0, 0, 0, true],
                [9, 1499.4322, -111.5231, 0, "", "Tutorial_Text_6", 231, "Mouse Wheel", "#000000", 1, 35, "Lily Script One", "left", null, null, null, null, 0, 0, 0, true],
                [9, 207.1451, -108.9853, 0, "", "Tutorial_Text_3", 232, "Press Space on your Keyboard and Hold Left click", "#000000", 1, 30, "Lily Script One", "left", null, null, null, null, 0, 0, 0, true],
                [9, 1334.6089, -113.3056, 0, "", "Tutorial_Text_5", 233, "or", "#706868", 1, 42, "Lily Script One", "left", null, null, null, null, 0, 0, 0, true],
                [6, 12669.51, -361.719, 0, "", "", 234, "#ffffff", "#000000", 1, 0, [{
                    "x": -15.891,
                    "y": 15.891
                }, {
                    "x": -15.891,
                    "y": -15.891
                }, {
                    "x": 15.891,
                    "y": -15.891
                }, {
                    "x": 15.891,
                    "y": 15.891
                }], null, null, null, null, "", 1, 0, 0, 0, "", true],
                [9, 6902.4052, -14.0402, 0, "", "", 235, "Click Here", "#000000", 1, 25, "Lily Script One", "left", null, null, null, null, 0, 0, 0, true],
                [9, 10697.4395, -39.2387, 0, "", "Tutorial_Text_7", 236, "Is a good practice to add checkpoints \nafter difficult obstacles", "#848181", 1, 35, "Lily Script One", "center", null, null, null, null, 0, 0, 0, true],
                [7, 10712.8123, 183.5187, 0, "", "", 237, [
                    [6, -117.2302, 59.3699, 0, "", "", 314, "#ff0000", "#000", 1, 0, [{
                        "x": -25.9304,
                        "y": 5.5565
                    }, {
                        "x": -25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": 5.5565
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, -56.3972, 59.2944, 0, "", "", 315, "#ff0000", "#000", 1, 0, [{
                        "x": -25.9304,
                        "y": 5.5565
                    }, {
                        "x": -25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": 5.5565
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, 2.2834, 59.4455, 0, "", "", 316, "#ff0000", "#000", 1, 0, [{
                        "x": -25.9304,
                        "y": 5.5565
                    }, {
                        "x": -25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": 5.5565
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, 60.677, 58.6128, 0, "", "", 317, "#ff0000", "#000", 1, 0, [{
                        "x": -25.9304,
                        "y": 5.5565
                    }, {
                        "x": -25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": 5.5565
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, 121.51, 58.5371, 0, "", "", 318, "#ff0000", "#000", 1, 0, [{
                        "x": -25.9304,
                        "y": 5.5565
                    }, {
                        "x": -25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": 5.5565
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, 180.1906, 58.6883, 0, "", "", 319, "#ff0000", "#000", 1, 0, [{
                        "x": -25.9304,
                        "y": 5.5565
                    }, {
                        "x": -25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": 5.5565
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, -178.9184, 59.7249, 0, "", "", 320, "#ff0000", "#000", 1, 0, [{
                        "x": -25.9304,
                        "y": 5.5565
                    }, {
                        "x": -25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": 5.5565
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, 218.015, -18.8216, 1.5708, "", "", 321, "#f90000", "#000", 1, 0, [{
                        "x": -25.9304,
                        "y": 5.5565
                    }, {
                        "x": -25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": 5.5565
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, -224.7729, -18.8915, 1.5708, "", "", 323, "#f90000", "#000", 1, 0, [{
                        "x": -25.9304,
                        "y": 5.5565
                    }, {
                        "x": -25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": 5.5565
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, -119.7262, -53.4348, 0, "", "", 325, "#ff0000", "#000", 1, 0, [{
                        "x": -25.9304,
                        "y": 5.5565
                    }, {
                        "x": -25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": 5.5565
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, -58.8932, -53.5103, 0, "", "", 326, "#ff0000", "#000", 1, 0, [{
                        "x": -25.9304,
                        "y": 5.5565
                    }, {
                        "x": -25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": 5.5565
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, -0.2126, -53.3591, 0, "", "", 327, "#ff0000", "#000", 1, 0, [{
                        "x": -25.9304,
                        "y": 5.5565
                    }, {
                        "x": -25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": 5.5565
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, 58.181, -54.1919, 0, "", "", 328, "#ff0000", "#000", 1, 0, [{
                        "x": -25.9304,
                        "y": 5.5565
                    }, {
                        "x": -25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": 5.5565
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, 119.014, -54.2675, 0, "", "", 329, "#ff0000", "#000", 1, 0, [{
                        "x": -25.9304,
                        "y": 5.5565
                    }, {
                        "x": -25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": 5.5565
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, 177.6946, -54.1164, 0, "", "", 330, "#ff0000", "#000", 1, 0, [{
                        "x": -25.9304,
                        "y": 5.5565
                    }, {
                        "x": -25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": 5.5565
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, -181.4144, -53.0798, 0, "", "", 331, "#ff0000", "#000", 1, 0, [{
                        "x": -25.9304,
                        "y": 5.5565
                    }, {
                        "x": -25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": -5.5565
                    }, {
                        "x": 25.9304,
                        "y": 5.5565
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true]
                ], null, null, null, null, 1, 0, 0, 0, true, false, []],
                [6, 10930.6759, 223.3777, 1.5708, "", "", 238, "#f90000", "#000", 1, 0, [{
                    "x": -25.9304,
                    "y": 5.5565
                }, {
                    "x": -25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": 5.5565
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [6, 10487.888, 223.3078, 1.5708, "", "", 239, "#f90000", "#000", 1, 0, [{
                    "x": -25.9304,
                    "y": 5.5565
                }, {
                    "x": -25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": 5.5565
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [6, 10701.0861, 81.5775, 0, "", "", 240, "#000000", "#c45757", 1, 0, [{
                    "x": 29.5,
                    "y": -16.3333
                }, {
                    "x": 0,
                    "y": 32.6667
                }, {
                    "x": -29.5,
                    "y": -16.3333
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [6, 10697.4291, 79.874, 0, "", "", 241, "#f40000", "#c45757", 1, 0, [{
                    "x": 29.5,
                    "y": -16.3333
                }, {
                    "x": 0,
                    "y": 32.6667
                }, {
                    "x": -29.5,
                    "y": -16.3333
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [9, 10696.143, 40.3412, 0, "", "", 242, "Here", "#000000", 1, 25, "Lily Script One", "left", null, null, null, null, 0, 0, 0, true],
                [7, 11580.2429, -602.6491, -0.5236, "", "", 243, [
                    [6, -0.5315, 2.9732, 0, "", "", 400, "#000000", "#000", 1, null, [{
                        "x": -76.396,
                        "y": -5.7186,
                        "point1": {
                            "x": -46.0445,
                            "y": -0.8105
                        },
                        "point2": {
                            "x": -17.8157,
                            "y": -6.128
                        }
                    }, {
                        "x": 12.9262,
                        "y": -5.6321,
                        "point1": {
                            "x": 16.5689,
                            "y": -5.5734
                        },
                        "point2": {
                            "x": 20.0893,
                            "y": -4.1356
                        }
                    }, {
                        "x": 23.7288,
                        "y": -3.9702,
                        "point1": {
                            "x": 52.9054,
                            "y": -2.644
                        },
                        "point2": {
                            "x": 82.7952,
                            "y": -3.1143
                        }
                    }, {
                        "x": 111.8114,
                        "y": -2.3082,
                        "point1": {
                            "x": 121.783,
                            "y": -2.0313
                        },
                        "point2": {
                            "x": 131.7632,
                            "y": -1.9754
                        }
                    }, {
                        "x": 141.7263,
                        "y": -1.4773,
                        "point1": {
                            "x": 145.5993,
                            "y": -1.2836
                        },
                        "point2": {
                            "x": 150.0714,
                            "y": -3.5325
                        }
                    }, {
                        "x": 153.3598,
                        "y": -1.4773,
                        "point1": {
                            "x": 155.1943,
                            "y": -0.3307
                        },
                        "point2": {
                            "x": 150.2788,
                            "y": 1.6519
                        }
                    }, {
                        "x": 148.374,
                        "y": 2.6776,
                        "point1": {
                            "x": 146.5985,
                            "y": 3.6336
                        },
                        "point2": {
                            "x": 144.5708,
                            "y": 4.2307
                        }
                    }, {
                        "x": 142.5572,
                        "y": 4.3395,
                        "point1": {
                            "x": 132.5963,
                            "y": 4.8779
                        },
                        "point2": {
                            "x": 122.6158,
                            "y": 4.9669
                        }
                    }, {
                        "x": 112.6424,
                        "y": 5.1705,
                        "point1": {
                            "x": 81.7926,
                            "y": 5.8001
                        },
                        "point2": {
                            "x": 50.2664,
                            "y": 4.7862
                        }
                    }, {
                        "x": 19.5739,
                        "y": 6.8324,
                        "point1": {
                            "x": -9.8137,
                            "y": 8.7916
                        },
                        "point2": {
                            "x": -56.371,
                            "y": 6.8195
                        }
                    }, {
                        "x": -85.6731,
                        "y": 5.8427,
                        "point1": {
                            "x": -97.7406,
                            "y": 5.4405
                        },
                        "point2": {
                            "x": -85.6388,
                            "y": 19.6952
                        }
                    }, {
                        "x": -97.5992,
                        "y": 18.6079,
                        "point1": {
                            "x": -101.2274,
                            "y": 18.2781
                        },
                        "point2": {
                            "x": -113.0359,
                            "y": 10.1583
                        }
                    }, {
                        "x": -117.0103,
                        "y": 8.4008,
                        "point1": {
                            "x": -118.7836,
                            "y": 7.6166
                        },
                        "point2": {
                            "x": -141.4126,
                            "y": -6.7188
                        }
                    }, {
                        "x": -141.4126,
                        "y": -8.6577,
                        "point1": {
                            "x": -141.4126,
                            "y": -10.7515
                        },
                        "point2": {
                            "x": -94.9839,
                            "y": -24.1173
                        }
                    }, {
                        "x": -93.8001,
                        "y": -24.4461,
                        "point1": {
                            "x": -88.3996,
                            "y": -25.9463
                        },
                        "point2": {
                            "x": -92.0859,
                            "y": -16.0355
                        }
                    }, {
                        "x": -89.8107,
                        "y": -11.0481,
                        "point1": {
                            "x": -88.4967,
                            "y": -8.1676
                        },
                        "point2": {
                            "x": -93.083,
                            "y": -7.569
                        }
                    }, {
                        "x": -89.258,
                        "y": -6.9315,
                        "point1": {
                            "x": -87.0552,
                            "y": -6.5643
                        },
                        "point2": {
                            "x": -84.013,
                            "y": -6.9503
                        }
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, 0.5315, -2.9732, 0, "", "", 401, "#e80000", "#000", 1, null, [{
                        "x": -90.1139,
                        "y": -3.9702,
                        "point1": {
                            "x": -86.5414,
                            "y": -4.6847
                        },
                        "point2": {
                            "x": -82.9541,
                            "y": -5.5734
                        }
                    }, {
                        "x": -79.3113,
                        "y": -5.6321,
                        "point1": {
                            "x": -48.5695,
                            "y": -6.128
                        },
                        "point2": {
                            "x": -17.8157,
                            "y": -6.128
                        }
                    }, {
                        "x": 12.9262,
                        "y": -5.6321,
                        "point1": {
                            "x": 16.5689,
                            "y": -5.5734
                        },
                        "point2": {
                            "x": 20.0893,
                            "y": -4.1356
                        }
                    }, {
                        "x": 23.7288,
                        "y": -3.9702,
                        "point1": {
                            "x": 52.9054,
                            "y": -2.644
                        },
                        "point2": {
                            "x": 82.7952,
                            "y": -3.1143
                        }
                    }, {
                        "x": 111.8114,
                        "y": -2.3082,
                        "point1": {
                            "x": 121.783,
                            "y": -2.0313
                        },
                        "point2": {
                            "x": 131.7632,
                            "y": -1.9754
                        }
                    }, {
                        "x": 141.7263,
                        "y": -1.4773,
                        "point1": {
                            "x": 145.5993,
                            "y": -1.2836
                        },
                        "point2": {
                            "x": 150.0714,
                            "y": -3.5325
                        }
                    }, {
                        "x": 153.3598,
                        "y": -1.4773,
                        "point1": {
                            "x": 155.1943,
                            "y": -0.3307
                        },
                        "point2": {
                            "x": 150.2788,
                            "y": 1.6519
                        }
                    }, {
                        "x": 148.374,
                        "y": 2.6776,
                        "point1": {
                            "x": 146.5985,
                            "y": 3.6336
                        },
                        "point2": {
                            "x": 144.5708,
                            "y": 4.2307
                        }
                    }, {
                        "x": 142.5572,
                        "y": 4.3395,
                        "point1": {
                            "x": 132.5963,
                            "y": 4.8779
                        },
                        "point2": {
                            "x": 122.6158,
                            "y": 4.9669
                        }
                    }, {
                        "x": 112.6424,
                        "y": 5.1705,
                        "point1": {
                            "x": 81.7926,
                            "y": 5.8001
                        },
                        "point2": {
                            "x": 50.2664,
                            "y": 4.7862
                        }
                    }, {
                        "x": 19.5739,
                        "y": 6.8324,
                        "point1": {
                            "x": -9.8137,
                            "y": 8.7916
                        },
                        "point2": {
                            "x": -62.8525,
                            "y": 7.6973
                        }
                    }, {
                        "x": -92.1432,
                        "y": 6.4223,
                        "point1": {
                            "x": -101.6459,
                            "y": 6.0087
                        },
                        "point2": {
                            "x": -89.0926,
                            "y": 18.7366
                        }
                    }, {
                        "x": -101.053,
                        "y": 17.6493,
                        "point1": {
                            "x": -104.6812,
                            "y": 17.3195
                        },
                        "point2": {
                            "x": -116.5157,
                            "y": 10.8862
                        }
                    }, {
                        "x": -120.0228,
                        "y": 9.5431,
                        "point1": {
                            "x": -121.8335,
                            "y": 8.8497
                        },
                        "point2": {
                            "x": -141.0945,
                            "y": -2.4356
                        }
                    }, {
                        "x": -141.0945,
                        "y": -4.3745,
                        "point1": {
                            "x": -141.0945,
                            "y": -6.4683
                        },
                        "point2": {
                            "x": -97.639,
                            "y": -20.6604
                        }
                    }, {
                        "x": -96.4552,
                        "y": -20.9892,
                        "point1": {
                            "x": -91.0547,
                            "y": -22.4894
                        },
                        "point2": {
                            "x": -98.5297,
                            "y": -6.0754
                        }
                    }, {
                        "x": -93.0547,
                        "y": -6.3492,
                        "point1": {
                            "x": -89.1817,
                            "y": -6.5428
                        },
                        "point2": {
                            "x": -87.2912,
                            "y": -5.4387
                        }
                    }, {
                        "x": -83.4662,
                        "y": -4.8012,
                        "point1": {
                            "x": -81.2634,
                            "y": -4.434
                        },
                        "point2": {
                            "x": -92.3037,
                            "y": -3.5322
                        }
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true]
                ], null, null, null, null, 1, 0, 0, 0, true, false, []],
                [7, 9503.7342, -591.6529, -0.5236, "", "", 244, [
                    [6, -0.5315, 2.9732, 0, "", "", 400, "#000000", "#000", 1, null, [{
                        "x": -76.396,
                        "y": -5.7186,
                        "point1": {
                            "x": -46.0445,
                            "y": -0.8105
                        },
                        "point2": {
                            "x": -17.8157,
                            "y": -6.128
                        }
                    }, {
                        "x": 12.9262,
                        "y": -5.6321,
                        "point1": {
                            "x": 16.5689,
                            "y": -5.5734
                        },
                        "point2": {
                            "x": 20.0893,
                            "y": -4.1356
                        }
                    }, {
                        "x": 23.7288,
                        "y": -3.9702,
                        "point1": {
                            "x": 52.9054,
                            "y": -2.644
                        },
                        "point2": {
                            "x": 82.7952,
                            "y": -3.1143
                        }
                    }, {
                        "x": 111.8114,
                        "y": -2.3082,
                        "point1": {
                            "x": 121.783,
                            "y": -2.0313
                        },
                        "point2": {
                            "x": 131.7632,
                            "y": -1.9754
                        }
                    }, {
                        "x": 141.7263,
                        "y": -1.4773,
                        "point1": {
                            "x": 145.5993,
                            "y": -1.2836
                        },
                        "point2": {
                            "x": 150.0714,
                            "y": -3.5325
                        }
                    }, {
                        "x": 153.3598,
                        "y": -1.4773,
                        "point1": {
                            "x": 155.1943,
                            "y": -0.3307
                        },
                        "point2": {
                            "x": 150.2788,
                            "y": 1.6519
                        }
                    }, {
                        "x": 148.374,
                        "y": 2.6776,
                        "point1": {
                            "x": 146.5985,
                            "y": 3.6336
                        },
                        "point2": {
                            "x": 144.5708,
                            "y": 4.2307
                        }
                    }, {
                        "x": 142.5572,
                        "y": 4.3395,
                        "point1": {
                            "x": 132.5963,
                            "y": 4.8779
                        },
                        "point2": {
                            "x": 122.6158,
                            "y": 4.9669
                        }
                    }, {
                        "x": 112.6424,
                        "y": 5.1705,
                        "point1": {
                            "x": 81.7926,
                            "y": 5.8001
                        },
                        "point2": {
                            "x": 50.2664,
                            "y": 4.7862
                        }
                    }, {
                        "x": 19.5739,
                        "y": 6.8324,
                        "point1": {
                            "x": -9.8137,
                            "y": 8.7916
                        },
                        "point2": {
                            "x": -56.371,
                            "y": 6.8195
                        }
                    }, {
                        "x": -85.6731,
                        "y": 5.8427,
                        "point1": {
                            "x": -97.7406,
                            "y": 5.4405
                        },
                        "point2": {
                            "x": -85.6388,
                            "y": 19.6952
                        }
                    }, {
                        "x": -97.5992,
                        "y": 18.6079,
                        "point1": {
                            "x": -101.2274,
                            "y": 18.2781
                        },
                        "point2": {
                            "x": -113.0359,
                            "y": 10.1583
                        }
                    }, {
                        "x": -117.0103,
                        "y": 8.4008,
                        "point1": {
                            "x": -118.7836,
                            "y": 7.6166
                        },
                        "point2": {
                            "x": -141.4126,
                            "y": -6.7188
                        }
                    }, {
                        "x": -141.4126,
                        "y": -8.6577,
                        "point1": {
                            "x": -141.4126,
                            "y": -10.7515
                        },
                        "point2": {
                            "x": -94.9839,
                            "y": -24.1173
                        }
                    }, {
                        "x": -93.8001,
                        "y": -24.4461,
                        "point1": {
                            "x": -88.3996,
                            "y": -25.9463
                        },
                        "point2": {
                            "x": -92.0859,
                            "y": -16.0355
                        }
                    }, {
                        "x": -89.8107,
                        "y": -11.0481,
                        "point1": {
                            "x": -88.4967,
                            "y": -8.1676
                        },
                        "point2": {
                            "x": -93.083,
                            "y": -7.569
                        }
                    }, {
                        "x": -89.258,
                        "y": -6.9315,
                        "point1": {
                            "x": -87.0552,
                            "y": -6.5643
                        },
                        "point2": {
                            "x": -84.013,
                            "y": -6.9503
                        }
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, 0.5315, -2.9732, 0, "", "", 401, "#e80000", "#000", 1, null, [{
                        "x": -90.1139,
                        "y": -3.9702,
                        "point1": {
                            "x": -86.5414,
                            "y": -4.6847
                        },
                        "point2": {
                            "x": -82.9541,
                            "y": -5.5734
                        }
                    }, {
                        "x": -79.3113,
                        "y": -5.6321,
                        "point1": {
                            "x": -48.5695,
                            "y": -6.128
                        },
                        "point2": {
                            "x": -17.8157,
                            "y": -6.128
                        }
                    }, {
                        "x": 12.9262,
                        "y": -5.6321,
                        "point1": {
                            "x": 16.5689,
                            "y": -5.5734
                        },
                        "point2": {
                            "x": 20.0893,
                            "y": -4.1356
                        }
                    }, {
                        "x": 23.7288,
                        "y": -3.9702,
                        "point1": {
                            "x": 52.9054,
                            "y": -2.644
                        },
                        "point2": {
                            "x": 82.7952,
                            "y": -3.1143
                        }
                    }, {
                        "x": 111.8114,
                        "y": -2.3082,
                        "point1": {
                            "x": 121.783,
                            "y": -2.0313
                        },
                        "point2": {
                            "x": 131.7632,
                            "y": -1.9754
                        }
                    }, {
                        "x": 141.7263,
                        "y": -1.4773,
                        "point1": {
                            "x": 145.5993,
                            "y": -1.2836
                        },
                        "point2": {
                            "x": 150.0714,
                            "y": -3.5325
                        }
                    }, {
                        "x": 153.3598,
                        "y": -1.4773,
                        "point1": {
                            "x": 155.1943,
                            "y": -0.3307
                        },
                        "point2": {
                            "x": 150.2788,
                            "y": 1.6519
                        }
                    }, {
                        "x": 148.374,
                        "y": 2.6776,
                        "point1": {
                            "x": 146.5985,
                            "y": 3.6336
                        },
                        "point2": {
                            "x": 144.5708,
                            "y": 4.2307
                        }
                    }, {
                        "x": 142.5572,
                        "y": 4.3395,
                        "point1": {
                            "x": 132.5963,
                            "y": 4.8779
                        },
                        "point2": {
                            "x": 122.6158,
                            "y": 4.9669
                        }
                    }, {
                        "x": 112.6424,
                        "y": 5.1705,
                        "point1": {
                            "x": 81.7926,
                            "y": 5.8001
                        },
                        "point2": {
                            "x": 50.2664,
                            "y": 4.7862
                        }
                    }, {
                        "x": 19.5739,
                        "y": 6.8324,
                        "point1": {
                            "x": -9.8137,
                            "y": 8.7916
                        },
                        "point2": {
                            "x": -62.8525,
                            "y": 7.6973
                        }
                    }, {
                        "x": -92.1432,
                        "y": 6.4223,
                        "point1": {
                            "x": -101.6459,
                            "y": 6.0087
                        },
                        "point2": {
                            "x": -89.0926,
                            "y": 18.7366
                        }
                    }, {
                        "x": -101.053,
                        "y": 17.6493,
                        "point1": {
                            "x": -104.6812,
                            "y": 17.3195
                        },
                        "point2": {
                            "x": -116.5157,
                            "y": 10.8862
                        }
                    }, {
                        "x": -120.0228,
                        "y": 9.5431,
                        "point1": {
                            "x": -121.8335,
                            "y": 8.8497
                        },
                        "point2": {
                            "x": -141.0945,
                            "y": -2.4356
                        }
                    }, {
                        "x": -141.0945,
                        "y": -4.3745,
                        "point1": {
                            "x": -141.0945,
                            "y": -6.4683
                        },
                        "point2": {
                            "x": -97.639,
                            "y": -20.6604
                        }
                    }, {
                        "x": -96.4552,
                        "y": -20.9892,
                        "point1": {
                            "x": -91.0547,
                            "y": -22.4894
                        },
                        "point2": {
                            "x": -98.5297,
                            "y": -6.0754
                        }
                    }, {
                        "x": -93.0547,
                        "y": -6.3492,
                        "point1": {
                            "x": -89.1817,
                            "y": -6.5428
                        },
                        "point2": {
                            "x": -87.2912,
                            "y": -5.4387
                        }
                    }, {
                        "x": -83.4662,
                        "y": -4.8012,
                        "point1": {
                            "x": -81.2634,
                            "y": -4.434
                        },
                        "point2": {
                            "x": -92.3037,
                            "y": -3.5322
                        }
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true]
                ], null, null, null, null, 1, 0, 0, 0, true, false, []],
                [6, 14751.1628, -268.9281, 0, "", "", 245, "#6b6a6a", "#000000", 1, 0, [{
                    "x": -240.8255,
                    "y": 158.5
                }, {
                    "x": -240.8255,
                    "y": -158.5
                }, {
                    "x": 240.8255,
                    "y": -158.5
                }, {
                    "x": 240.8255,
                    "y": 158.5
                }], null, null, null, null, "", 2, 0, 0, 0, "", true],
                [6, 14754.1127, -443.484, 0, "", "", 246, "#3d3d3d", "#000000", 1, 0, [{
                    "x": -243.5,
                    "y": 17.742
                }, {
                    "x": -243.5,
                    "y": -17.742
                }, {
                    "x": 243.5,
                    "y": -17.742
                }, {
                    "x": 243.5,
                    "y": 17.742
                }], null, null, null, null, "", 2, 0, 0, 0, "", true],
                [9, 14587.3167, -448.5401, 0, "", "", 247, "Body", "#ffffff", 1, 25, "Karla", "left", null, null, null, null, 0, 0, 0, true],
                [6, 14750.9485, -104.5543, 0, "", "", 248, "#3d3d3d", "#000000", 1, 0, [{
                    "x": -246.21,
                    "y": 16.239
                }, {
                    "x": -246.21,
                    "y": -16.239
                }, {
                    "x": 246.21,
                    "y": -16.239
                }, {
                    "x": 246.21,
                    "y": 16.239
                }], null, null, null, null, "", 2, 0, 0, 0, "", true],
                [9, 14588.1721, -103.5874, 0, "", "", 249, "Visuals", "#ffffff", 1, 25, "Karla", "left", null, null, null, null, 0, 0, 0, true],
                [6, 14532.3643, -447.8577, 0, "", "", 250, "#ffffff", "#ffffff", 1, 0, [{
                    "x": 10.6992,
                    "y": -5.1267
                }, {
                    "x": 0,
                    "y": 10.2534
                }, {
                    "x": -10.6992,
                    "y": -5.1267
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [6, 14525.8498, -107.5821, 0, "", "", 251, "#ffffff", "#ffffff", 1, 0, [{
                    "x": 10.6992,
                    "y": -5.1267
                }, {
                    "x": 0,
                    "y": 10.2534
                }, {
                    "x": -10.6992,
                    "y": -5.1267
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [9, 14566.541, -342.2498, 0, "", "", 252, "Width", "#ffffff", 1, 25, "Karla", "left", null, null, null, null, 0, 0, 0, true],
                [9, 14709.8698, -389.5207, 0, "", "", 253, "14815", "#00efff", 1, 25, "Karla", "left", null, null, null, null, 0, 0, 0, true],
                [9, 14561.8623, -220.3394, 0, "", "", 254, "Name", "#ffffff", 1, 25, "Karla", "left", null, null, null, null, 0, 0, 0, true],
                [9, 14858.541, -338.2498, 0, "", "", 255, "Height", "#ffffff", 1, 25, "Karla", "left", null, null, null, null, 0, 0, 0, true],
                [9, 14830.541, -390.2498, 0, "", "", 256, "Y", "#ffffff", 1, 25, "Karla", "left", null, null, null, null, 0, 0, 0, true],
                [9, 14576.541, -276.646, 0, "", "", 257, "Rotation", "#ffffff", 1, 25, "Karla", "left", null, null, null, null, 0, 0, 0, true],
                [9, 14545.061, -392.9925, 0, "", "", 258, "X", "#ffffff", 1, 25, "Karla", "left", null, null, null, null, 0, 0, 0, true],
                [9, 14702.541, -342.2498, 0, "", "", 259, "302", "#00efff", 1, 25, "Karla", "left", null, null, null, null, 0, 0, 0, true],
                [9, 14950.541, -336.2498, 0, "", "", 260, "302", "#00efff", 1, 25, "Karla", "left", null, null, null, null, 0, 0, 0, true],
                [9, 14950.541, -386.2498, 0, "", "", 261, "-29", "#00efff", 1, 25, "Karla", "left", null, null, null, null, 0, 0, 0, true],
                [7, 14933.292, -79.4761, 0.5236, "", "", 262, [
                    [6, -0.5315, 2.9732, 0, "", "", 400, "#000000", "#000", 1, null, [{
                        "x": -76.396,
                        "y": -5.7186,
                        "point1": {
                            "x": -46.0445,
                            "y": -0.8105
                        },
                        "point2": {
                            "x": -17.8157,
                            "y": -6.128
                        }
                    }, {
                        "x": 12.9262,
                        "y": -5.6321,
                        "point1": {
                            "x": 16.5689,
                            "y": -5.5734
                        },
                        "point2": {
                            "x": 20.0893,
                            "y": -4.1356
                        }
                    }, {
                        "x": 23.7288,
                        "y": -3.9702,
                        "point1": {
                            "x": 52.9054,
                            "y": -2.644
                        },
                        "point2": {
                            "x": 82.7952,
                            "y": -3.1143
                        }
                    }, {
                        "x": 111.8114,
                        "y": -2.3082,
                        "point1": {
                            "x": 121.783,
                            "y": -2.0313
                        },
                        "point2": {
                            "x": 131.7632,
                            "y": -1.9754
                        }
                    }, {
                        "x": 141.7263,
                        "y": -1.4773,
                        "point1": {
                            "x": 145.5993,
                            "y": -1.2836
                        },
                        "point2": {
                            "x": 150.0714,
                            "y": -3.5325
                        }
                    }, {
                        "x": 153.3598,
                        "y": -1.4773,
                        "point1": {
                            "x": 155.1943,
                            "y": -0.3307
                        },
                        "point2": {
                            "x": 150.2788,
                            "y": 1.6519
                        }
                    }, {
                        "x": 148.374,
                        "y": 2.6776,
                        "point1": {
                            "x": 146.5985,
                            "y": 3.6336
                        },
                        "point2": {
                            "x": 144.5708,
                            "y": 4.2307
                        }
                    }, {
                        "x": 142.5572,
                        "y": 4.3395,
                        "point1": {
                            "x": 132.5963,
                            "y": 4.8779
                        },
                        "point2": {
                            "x": 122.6158,
                            "y": 4.9669
                        }
                    }, {
                        "x": 112.6424,
                        "y": 5.1705,
                        "point1": {
                            "x": 81.7926,
                            "y": 5.8001
                        },
                        "point2": {
                            "x": 50.2664,
                            "y": 4.7862
                        }
                    }, {
                        "x": 19.5739,
                        "y": 6.8324,
                        "point1": {
                            "x": -9.8137,
                            "y": 8.7916
                        },
                        "point2": {
                            "x": -56.371,
                            "y": 6.8195
                        }
                    }, {
                        "x": -85.6731,
                        "y": 5.8427,
                        "point1": {
                            "x": -97.7406,
                            "y": 5.4405
                        },
                        "point2": {
                            "x": -85.6388,
                            "y": 19.6952
                        }
                    }, {
                        "x": -97.5992,
                        "y": 18.6079,
                        "point1": {
                            "x": -101.2274,
                            "y": 18.2781
                        },
                        "point2": {
                            "x": -113.0359,
                            "y": 10.1583
                        }
                    }, {
                        "x": -117.0103,
                        "y": 8.4008,
                        "point1": {
                            "x": -118.7836,
                            "y": 7.6166
                        },
                        "point2": {
                            "x": -141.4126,
                            "y": -6.7188
                        }
                    }, {
                        "x": -141.4126,
                        "y": -8.6577,
                        "point1": {
                            "x": -141.4126,
                            "y": -10.7515
                        },
                        "point2": {
                            "x": -94.9839,
                            "y": -24.1173
                        }
                    }, {
                        "x": -93.8001,
                        "y": -24.4461,
                        "point1": {
                            "x": -88.3996,
                            "y": -25.9463
                        },
                        "point2": {
                            "x": -92.0859,
                            "y": -16.0355
                        }
                    }, {
                        "x": -89.8107,
                        "y": -11.0481,
                        "point1": {
                            "x": -88.4967,
                            "y": -8.1676
                        },
                        "point2": {
                            "x": -93.083,
                            "y": -7.569
                        }
                    }, {
                        "x": -89.258,
                        "y": -6.9315,
                        "point1": {
                            "x": -87.0552,
                            "y": -6.5643
                        },
                        "point2": {
                            "x": -84.013,
                            "y": -6.9503
                        }
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, 0.5315, -2.9732, 0, "", "", 401, "#e80000", "#000", 1, null, [{
                        "x": -90.1139,
                        "y": -3.9702,
                        "point1": {
                            "x": -86.5414,
                            "y": -4.6847
                        },
                        "point2": {
                            "x": -82.9541,
                            "y": -5.5734
                        }
                    }, {
                        "x": -79.3113,
                        "y": -5.6321,
                        "point1": {
                            "x": -48.5695,
                            "y": -6.128
                        },
                        "point2": {
                            "x": -17.8157,
                            "y": -6.128
                        }
                    }, {
                        "x": 12.9262,
                        "y": -5.6321,
                        "point1": {
                            "x": 16.5689,
                            "y": -5.5734
                        },
                        "point2": {
                            "x": 20.0893,
                            "y": -4.1356
                        }
                    }, {
                        "x": 23.7288,
                        "y": -3.9702,
                        "point1": {
                            "x": 52.9054,
                            "y": -2.644
                        },
                        "point2": {
                            "x": 82.7952,
                            "y": -3.1143
                        }
                    }, {
                        "x": 111.8114,
                        "y": -2.3082,
                        "point1": {
                            "x": 121.783,
                            "y": -2.0313
                        },
                        "point2": {
                            "x": 131.7632,
                            "y": -1.9754
                        }
                    }, {
                        "x": 141.7263,
                        "y": -1.4773,
                        "point1": {
                            "x": 145.5993,
                            "y": -1.2836
                        },
                        "point2": {
                            "x": 150.0714,
                            "y": -3.5325
                        }
                    }, {
                        "x": 153.3598,
                        "y": -1.4773,
                        "point1": {
                            "x": 155.1943,
                            "y": -0.3307
                        },
                        "point2": {
                            "x": 150.2788,
                            "y": 1.6519
                        }
                    }, {
                        "x": 148.374,
                        "y": 2.6776,
                        "point1": {
                            "x": 146.5985,
                            "y": 3.6336
                        },
                        "point2": {
                            "x": 144.5708,
                            "y": 4.2307
                        }
                    }, {
                        "x": 142.5572,
                        "y": 4.3395,
                        "point1": {
                            "x": 132.5963,
                            "y": 4.8779
                        },
                        "point2": {
                            "x": 122.6158,
                            "y": 4.9669
                        }
                    }, {
                        "x": 112.6424,
                        "y": 5.1705,
                        "point1": {
                            "x": 81.7926,
                            "y": 5.8001
                        },
                        "point2": {
                            "x": 50.2664,
                            "y": 4.7862
                        }
                    }, {
                        "x": 19.5739,
                        "y": 6.8324,
                        "point1": {
                            "x": -9.8137,
                            "y": 8.7916
                        },
                        "point2": {
                            "x": -62.8525,
                            "y": 7.6973
                        }
                    }, {
                        "x": -92.1432,
                        "y": 6.4223,
                        "point1": {
                            "x": -101.6459,
                            "y": 6.0087
                        },
                        "point2": {
                            "x": -89.0926,
                            "y": 18.7366
                        }
                    }, {
                        "x": -101.053,
                        "y": 17.6493,
                        "point1": {
                            "x": -104.6812,
                            "y": 17.3195
                        },
                        "point2": {
                            "x": -116.5157,
                            "y": 10.8862
                        }
                    }, {
                        "x": -120.0228,
                        "y": 9.5431,
                        "point1": {
                            "x": -121.8335,
                            "y": 8.8497
                        },
                        "point2": {
                            "x": -141.0945,
                            "y": -2.4356
                        }
                    }, {
                        "x": -141.0945,
                        "y": -4.3745,
                        "point1": {
                            "x": -141.0945,
                            "y": -6.4683
                        },
                        "point2": {
                            "x": -97.639,
                            "y": -20.6604
                        }
                    }, {
                        "x": -96.4552,
                        "y": -20.9892,
                        "point1": {
                            "x": -91.0547,
                            "y": -22.4894
                        },
                        "point2": {
                            "x": -98.5297,
                            "y": -6.0754
                        }
                    }, {
                        "x": -93.0547,
                        "y": -6.3492,
                        "point1": {
                            "x": -89.1817,
                            "y": -6.5428
                        },
                        "point2": {
                            "x": -87.2912,
                            "y": -5.4387
                        }
                    }, {
                        "x": -83.4662,
                        "y": -4.8012,
                        "point1": {
                            "x": -81.2634,
                            "y": -4.434
                        },
                        "point2": {
                            "x": -92.3037,
                            "y": -3.5322
                        }
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true]
                ], null, null, null, null, 1, 0, 0, 0, true, false, []],
                [9, 14826.9372, -274.2126, 0, "", "", 263, "0", "#00efff", 1, 25, "Karla", "left", null, null, null, null, 0, 0, 0, true],
                [9, 17792.0397, -285.3903, 0, "", "Tutorial_Text_8", 264, "Press T on your Keyboard\nto test the level", "#000000", 1, 35, "Lily Script One", "left", null, null, null, null, 0, 0, 0, true],
                [9, 17722.9448, -120.2737, 0, "", "Tutorial_Text_9", 265, "Press this button \nat the top right", "#0f0f0f", 1, 35, "Lily Script One", "left", null, null, null, null, 0, 0, 0, true],
                [9, 17912.3557, 106.3198, 0, "", "Tutorial_Text_10", 266, "Fill up all the info, then Save or hit publish!\nPS: Don't publish this tutorial please ;P", "#000000", 1, 35, "Lily Script One", "left", null, null, null, null, 0, 0, 0, true],
                [9, 14559.135, -159.1619, 0, "", "", 267, "Static", "#ffffff", 1, 25, "Karla", "left", null, null, null, null, 0, 0, 0, true],
                [6, 14798.4338, -155.3062, 0, "", "", 268, "#009cce", "#000000", 1, 0, [{
                    "x": -15.891,
                    "y": 15.891
                }, {
                    "x": -15.891,
                    "y": -15.891
                }, {
                    "x": 15.891,
                    "y": -15.891
                }, {
                    "x": 15.891,
                    "y": 15.891
                }], null, null, null, null, "", 1, 0, 0, 0, "", true],
                [9, 15119.6879, 13.9044, 0, "", "", 269, "Click Here", "#000000", 1, 25, "Lily Script One", "left", null, null, null, null, 0, 0, 0, true],
                [6, 14795.9137, -155.5903, 0, "", "", 270, "#ffffff", "#000", 1, 0, [{
                    "x": -10.9356,
                    "y": -6.129
                }, {
                    "x": -3.0171,
                    "y": -5.971
                }, {
                    "x": 0.0755,
                    "y": 1.8879
                }, {
                    "x": 15.1837,
                    "y": -13.064
                }, {
                    "x": 1.9669,
                    "y": 12.3475
                }, {
                    "x": -3.6282,
                    "y": 12.3475
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [6, 14142.2216, -13.4893, 0.6109, "", "", 271, "#000000", "#000", 1, null, [{
                    "x": 76.396,
                    "y": -5.7186,
                    "point1": {
                        "x": 46.0445,
                        "y": -0.8105
                    },
                    "point2": {
                        "x": 17.8157,
                        "y": -6.128
                    }
                }, {
                    "x": -12.9262,
                    "y": -5.6321,
                    "point1": {
                        "x": -16.5689,
                        "y": -5.5734
                    },
                    "point2": {
                        "x": -24.4,
                        "y": -5.8171
                    }
                }, {
                    "x": -28.0395,
                    "y": -5.6517,
                    "point1": {
                        "x": -57.2161,
                        "y": -4.3255
                    },
                    "point2": {
                        "x": -83.9522,
                        "y": -7.004
                    }
                }, {
                    "x": -112.9684,
                    "y": -6.1979,
                    "point1": {
                        "x": -122.94,
                        "y": -5.921
                    },
                    "point2": {
                        "x": -131.6585,
                        "y": -5.1819
                    }
                }, {
                    "x": -141.6216,
                    "y": -4.6838,
                    "point1": {
                        "x": -145.4946,
                        "y": -4.4901
                    },
                    "point2": {
                        "x": -639.4627,
                        "y": -13.3468
                    }
                }, {
                    "x": -642.7511,
                    "y": -11.2916,
                    "point1": {
                        "x": -644.5856,
                        "y": -10.145
                    },
                    "point2": {
                        "x": -641.4563,
                        "y": -0.6452
                    }
                }, {
                    "x": -639.5515,
                    "y": 0.3805,
                    "point1": {
                        "x": -637.776,
                        "y": 1.3365
                    },
                    "point2": {
                        "x": -144.5708,
                        "y": 4.2307
                    }
                }, {
                    "x": -142.5572,
                    "y": 4.3395,
                    "point1": {
                        "x": -132.5963,
                        "y": 4.8779
                    },
                    "point2": {
                        "x": -122.6158,
                        "y": 4.9669
                    }
                }, {
                    "x": -112.6424,
                    "y": 5.1705,
                    "point1": {
                        "x": -81.7926,
                        "y": 5.8001
                    },
                    "point2": {
                        "x": -50.2664,
                        "y": 4.7862
                    }
                }, {
                    "x": -19.5739,
                    "y": 6.8324,
                    "point1": {
                        "x": 9.8137,
                        "y": 8.7916
                    },
                    "point2": {
                        "x": 56.371,
                        "y": 6.8195
                    }
                }, {
                    "x": 85.6731,
                    "y": 5.8427,
                    "point1": {
                        "x": 97.7406,
                        "y": 5.4405
                    },
                    "point2": {
                        "x": 85.6388,
                        "y": 19.6952
                    }
                }, {
                    "x": 97.5992,
                    "y": 18.6079,
                    "point1": {
                        "x": 101.2274,
                        "y": 18.2781
                    },
                    "point2": {
                        "x": 113.0359,
                        "y": 10.1583
                    }
                }, {
                    "x": 117.0103,
                    "y": 8.4008,
                    "point1": {
                        "x": 118.7836,
                        "y": 7.6166
                    },
                    "point2": {
                        "x": 141.4126,
                        "y": -6.7188
                    }
                }, {
                    "x": 141.4126,
                    "y": -8.6577,
                    "point1": {
                        "x": 141.4126,
                        "y": -10.7515
                    },
                    "point2": {
                        "x": 94.9839,
                        "y": -24.1173
                    }
                }, {
                    "x": 93.8001,
                    "y": -24.4461,
                    "point1": {
                        "x": 88.3996,
                        "y": -25.9463
                    },
                    "point2": {
                        "x": 92.0859,
                        "y": -16.0355
                    }
                }, {
                    "x": 89.8107,
                    "y": -11.0481,
                    "point1": {
                        "x": 88.4967,
                        "y": -8.1676
                    },
                    "point2": {
                        "x": 93.083,
                        "y": -7.569
                    }
                }, {
                    "x": 89.258,
                    "y": -6.9315,
                    "point1": {
                        "x": 87.0552,
                        "y": -6.5643
                    },
                    "point2": {
                        "x": 84.013,
                        "y": -6.9503
                    }
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [6, 14149.9031, -14.3196, 0.6109, "", "", 272, "#e80000", "#000", 1, null, [{
                    "x": 90.1139,
                    "y": -3.9702,
                    "point1": {
                        "x": 86.5414,
                        "y": -4.6847
                    },
                    "point2": {
                        "x": 82.9541,
                        "y": -5.5734
                    }
                }, {
                    "x": 79.3113,
                    "y": -5.6321,
                    "point1": {
                        "x": 48.5695,
                        "y": -6.128
                    },
                    "point2": {
                        "x": 17.8157,
                        "y": -6.128
                    }
                }, {
                    "x": -12.9262,
                    "y": -5.6321,
                    "point1": {
                        "x": -16.5689,
                        "y": -5.5734
                    },
                    "point2": {
                        "x": -20.0893,
                        "y": -4.1356
                    }
                }, {
                    "x": -23.7288,
                    "y": -3.9702,
                    "point1": {
                        "x": -52.9054,
                        "y": -2.644
                    },
                    "point2": {
                        "x": -82.6905,
                        "y": -6.3208
                    }
                }, {
                    "x": -111.7067,
                    "y": -5.5147,
                    "point1": {
                        "x": -121.6783,
                        "y": -5.2378
                    },
                    "point2": {
                        "x": -131.869,
                        "y": -6.6012
                    }
                }, {
                    "x": -141.8321,
                    "y": -6.1031,
                    "point1": {
                        "x": -145.7051,
                        "y": -5.9094
                    },
                    "point2": {
                        "x": -650.3969,
                        "y": -16.6569
                    }
                }, {
                    "x": -653.6853,
                    "y": -14.6017,
                    "point1": {
                        "x": -655.5198,
                        "y": -13.4551
                    },
                    "point2": {
                        "x": -653.4946,
                        "y": -5.5321
                    }
                }, {
                    "x": -651.5898,
                    "y": -4.5064,
                    "point1": {
                        "x": -649.8143,
                        "y": -3.5504
                    },
                    "point2": {
                        "x": -144.5708,
                        "y": 4.2307
                    }
                }, {
                    "x": -142.5572,
                    "y": 4.3395,
                    "point1": {
                        "x": -132.5963,
                        "y": 4.8779
                    },
                    "point2": {
                        "x": -122.6158,
                        "y": 4.9669
                    }
                }, {
                    "x": -112.6424,
                    "y": 5.1705,
                    "point1": {
                        "x": -81.7926,
                        "y": 5.8001
                    },
                    "point2": {
                        "x": -50.2664,
                        "y": 4.7862
                    }
                }, {
                    "x": -19.5739,
                    "y": 6.8324,
                    "point1": {
                        "x": 9.8137,
                        "y": 8.7916
                    },
                    "point2": {
                        "x": 62.8525,
                        "y": 7.6973
                    }
                }, {
                    "x": 92.1432,
                    "y": 6.4223,
                    "point1": {
                        "x": 101.6459,
                        "y": 6.0087
                    },
                    "point2": {
                        "x": 89.0926,
                        "y": 18.7366
                    }
                }, {
                    "x": 101.053,
                    "y": 17.6493,
                    "point1": {
                        "x": 104.6812,
                        "y": 17.3195
                    },
                    "point2": {
                        "x": 116.5157,
                        "y": 10.8862
                    }
                }, {
                    "x": 120.0228,
                    "y": 9.5431,
                    "point1": {
                        "x": 121.8335,
                        "y": 8.8497
                    },
                    "point2": {
                        "x": 141.0945,
                        "y": -2.4356
                    }
                }, {
                    "x": 141.0945,
                    "y": -4.3745,
                    "point1": {
                        "x": 141.0945,
                        "y": -6.4683
                    },
                    "point2": {
                        "x": 97.639,
                        "y": -20.6604
                    }
                }, {
                    "x": 96.4552,
                    "y": -20.9892,
                    "point1": {
                        "x": 91.0547,
                        "y": -22.4894
                    },
                    "point2": {
                        "x": 98.5297,
                        "y": -6.0754
                    }
                }, {
                    "x": 93.0547,
                    "y": -6.3492,
                    "point1": {
                        "x": 89.1817,
                        "y": -6.5428
                    },
                    "point2": {
                        "x": 87.2912,
                        "y": -5.4387
                    }
                }, {
                    "x": 83.4662,
                    "y": -4.8012,
                    "point1": {
                        "x": 81.2634,
                        "y": -4.434
                    },
                    "point2": {
                        "x": 92.3037,
                        "y": -3.5322
                    }
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [9, 14353.6581, 52.3068, 0, "", "", 273, "Click Here", "#ffffff", 1, 25, "Lily Script One", "left", null, null, null, null, 0, 0, 0, true],
                [6, 15956.8509, 240.3216, 0, "", "", 274, "#ff0000", "#000", 1, 0, [{
                    "x": -25.9304,
                    "y": 5.5565
                }, {
                    "x": -25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": 5.5565
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [6, 16017.6839, 240.2461, 0, "", "", 275, "#ff0000", "#000", 1, 0, [{
                    "x": -25.9304,
                    "y": 5.5565
                }, {
                    "x": -25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": 5.5565
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [6, 16076.3645, 240.3972, 0, "", "", 276, "#ff0000", "#000", 1, 0, [{
                    "x": -25.9304,
                    "y": 5.5565
                }, {
                    "x": -25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": 5.5565
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [6, 16134.7581, 239.5645, 0, "", "", 277, "#ff0000", "#000", 1, 0, [{
                    "x": -25.9304,
                    "y": 5.5565
                }, {
                    "x": -25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": 5.5565
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [6, 16195.5911, 239.4888, 0, "", "", 278, "#ff0000", "#000", 1, 0, [{
                    "x": -25.9304,
                    "y": 5.5565
                }, {
                    "x": -25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": 5.5565
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [6, 16254.2717, 239.64, 0, "", "", 279, "#ff0000", "#000", 1, 0, [{
                    "x": -25.9304,
                    "y": 5.5565
                }, {
                    "x": -25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": 5.5565
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [6, 15895.1627, 240.6766, 0, "", "", 280, "#ff0000", "#000", 1, 0, [{
                    "x": -25.9304,
                    "y": 5.5565
                }, {
                    "x": -25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": 5.5565
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [6, 16292.0961, 157.8851, 1.5708, "", "", 281, "#f90000", "#000", 1, 0, [{
                    "x": -25.9304,
                    "y": 5.5565
                }, {
                    "x": -25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": 5.5565
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [6, 15849.3082, 157.8152, 1.5708, "", "", 282, "#f90000", "#000", 1, 0, [{
                    "x": -25.9304,
                    "y": 5.5565
                }, {
                    "x": -25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": 5.5565
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [6, 15954.3549, 127.5169, 0, "", "", 283, "#ff0000", "#000", 1, 0, [{
                    "x": -25.9304,
                    "y": 5.5565
                }, {
                    "x": -25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": 5.5565
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [6, 16015.1879, 127.4414, 0, "", "", 284, "#ff0000", "#000", 1, 0, [{
                    "x": -25.9304,
                    "y": 5.5565
                }, {
                    "x": -25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": 5.5565
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [6, 16073.8685, 127.5926, 0, "", "", 285, "#ff0000", "#000", 1, 0, [{
                    "x": -25.9304,
                    "y": 5.5565
                }, {
                    "x": -25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": 5.5565
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [6, 16132.2621, 126.7598, 0, "", "", 286, "#ff0000", "#000", 1, 0, [{
                    "x": -25.9304,
                    "y": 5.5565
                }, {
                    "x": -25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": 5.5565
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [6, 16193.0951, 126.6842, 0, "", "", 287, "#ff0000", "#000", 1, 0, [{
                    "x": -25.9304,
                    "y": 5.5565
                }, {
                    "x": -25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": 5.5565
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [6, 16251.7757, 126.8353, 0, "", "", 288, "#ff0000", "#000", 1, 0, [{
                    "x": -25.9304,
                    "y": 5.5565
                }, {
                    "x": -25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": 5.5565
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [6, 15892.6667, 127.8719, 0, "", "", 289, "#ff0000", "#000", 1, 0, [{
                    "x": -25.9304,
                    "y": 5.5565
                }, {
                    "x": -25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": 5.5565
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [6, 16060.3262, 84.6413, 0, "", "", 290, "#000000", "#c45757", 1, 0, [{
                    "x": 29.5,
                    "y": -16.3333
                }, {
                    "x": 0,
                    "y": 32.6667
                }, {
                    "x": -29.5,
                    "y": -16.3333
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [6, 16055.8202, 79.5418, 0, "", "", 291, "#f40000", "#c45757", 1, 0, [{
                    "x": 29.5,
                    "y": -16.3333
                }, {
                    "x": 0,
                    "y": 32.6667
                }, {
                    "x": -29.5,
                    "y": -16.3333
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [9, 16056.5628, 42.0193, 0, "", "", 292, "Here", "#000000", 1, 25, "Lily Script One", "left", null, null, null, null, 0, 0, 0, true],
                [6, 16292.0827, 214.8093, 1.5708, "", "", 293, "#f90000", "#000", 1, 0, [{
                    "x": -25.9304,
                    "y": 5.5565
                }, {
                    "x": -25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": 5.5565
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [6, 15849.2949, 214.7393, 1.5708, "", "", 294, "#f90000", "#000", 1, 0, [{
                    "x": -25.9304,
                    "y": 5.5565
                }, {
                    "x": -25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": -5.5565
                }, {
                    "x": 25.9304,
                    "y": 5.5565
                }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                [4, -568.547, 80.4702, 0, {
                    "selectedVehicle": "Bike",
                    "life": 300,
                    "forceVehicle": true
                }, "Bike"],
                [6, 17517.8042, -122.3146, 0, "", "", 363, "#999999", "#000", 1, 0, [{
                    "x": -41.534,
                    "y": 46.909
                }, {
                    "x": -41.534,
                    "y": -46.909
                }, {
                    "x": 41.534,
                    "y": -46.909
                }, {
                    "x": 41.534,
                    "y": 46.909
                }], null, null, null, null, "", 1, 0, 0, 0, "", true],
                [7, 17518.6249, -123.7679, 0, "", "", 364, [
                    [6, -3.2566, 0.7886, 0, "", "", 371, "#f7f7f7", "#000", 1, 0, [{
                        "x": -18.2362,
                        "y": 29.2193
                    }, {
                        "x": -18.2362,
                        "y": -29.2193
                    }, {
                        "x": 18.2362,
                        "y": -29.2193
                    }, {
                        "x": 18.2362,
                        "y": 29.2193
                    }], null, null, null, null, "", 1, 0, 0, 0, "", true],
                    [6, -3.2603, -17.5543, 0, "", "", 372, "#000000", "#000", 1, 0, [{
                        "x": -15.2068,
                        "y": 2.5735
                    }, {
                        "x": -15.2068,
                        "y": -2.5735
                    }, {
                        "x": 15.2068,
                        "y": -2.5735
                    }, {
                        "x": 15.2068,
                        "y": 2.5735
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, -2.7924, -9.366, 0, "", "", 373, "#000000", "#000", 1, 0, [{
                        "x": -15.2068,
                        "y": 2.5735
                    }, {
                        "x": -15.2068,
                        "y": -2.5735
                    }, {
                        "x": 15.2068,
                        "y": -2.5735
                    }, {
                        "x": 15.2068,
                        "y": 2.5735
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, -3.2603, -1.1777, 0, "", "", 374, "#000000", "#000", 1, 0, [{
                        "x": -15.2068,
                        "y": 2.5735
                    }, {
                        "x": -15.2068,
                        "y": -2.5735
                    }, {
                        "x": 15.2068,
                        "y": -2.5735
                    }, {
                        "x": 15.2068,
                        "y": 2.5735
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, -3.2603, 7.4784, 0, "", "", 375, "#000000", "#000", 1, 0, [{
                        "x": -15.2068,
                        "y": 2.5735
                    }, {
                        "x": -15.2068,
                        "y": -2.5735
                    }, {
                        "x": 15.2068,
                        "y": -2.5735
                    }, {
                        "x": 15.2068,
                        "y": 2.5735
                    }], null, null, null, null, "", 0, 0, 0, 0, "", true],
                    [6, 15.83, 19.831, 0, "", "", 376, "#ffffff", "#000000", 1, 0, [{
                        "x": -8.7965,
                        "y": 1.6844
                    }, {
                        "x": 5.7084,
                        "y": -14.2242
                    }, {
                        "x": 13.1948,
                        "y": -6.5038
                    }, {
                        "x": 0.3275,
                        "y": 6.8314
                    }, {
                        "x": -10.4342,
                        "y": 12.2122
                    }], null, null, null, null, "", 1, 0, 0, 0, "", true]
                ], null, null, null, null, 1, 0, 0, 0, true, false, []],
                [6, 17510.1073, 65.6103, 0, "", "", 365, "#17aa00", "#000", 1, 0, [{
                    "x": -53.5,
                    "y": 29.8797
                }, {
                    "x": -53.5,
                    "y": -29.8797
                }, {
                    "x": 53.5,
                    "y": -29.8797
                }, {
                    "x": 53.5,
                    "y": 29.8797
                }], null, null, null, null, "", 2, 0, 0, 0, "", true],
                [6, 17513.2492, 144.566, 0, "", "", 366, "#c95400", "#000", 1, 0, [{
                    "x": -53.5,
                    "y": 29.88
                }, {
                    "x": -53.5,
                    "y": -29.88
                }, {
                    "x": 53.5,
                    "y": -29.88
                }, {
                    "x": 53.5,
                    "y": 29.88
                }], null, null, null, null, "", 2, 0, 0, 0, "", true],
                [9, 17516.1263, -292.7856, 0, "", "", 367, "T", "#070000", 1, 75, "Karla", "left", null, null, null, null, 0, 0, 0, true],
                [9, 17506.3696, 64.5524, 0, "", "", 368, "SAVE", "#ffffff", 1, 25, "Karla", "left", null, null, null, null, 0, 0, 0, true],
                [9, 17511.8356, 146.1952, 0, "", "", 369, "PUBLISH", "#ffffff", 1, 20, "Karla", "left", null, null, null, null, 0, 0, 0, true]
            ],
        }),
        title: '',
        description: '',
        crossPromo: [],
    }),

    tutorialLevel:{
        id: 'BNNWOqMaR2KLOS2ndlMOk',
        level_md5: '3b8f76a520c92994637e626ceae4b361',
        forced_vehicle: 1,
    }
};
